(function() {
  'use strict';

  /* =============================================
     CONFIG + UTILITIES
     ============================================= */
  var CFG = window.WIZARD_CFG || {};
  var MODELS = window.WIZARD_MODELS || {};
  var CONTEXT = window.WIZARD_CONTEXT || {};
  var CUST = window.WIZARD_CUSTOMER || null;

  /* [4.5] Currency formatter */
  var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 2 });

  var DN = { iphone: 'iPhone', macbook: 'MacBook', ipad: 'iPad', watch: 'Apple Watch' };

  function esc(str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; }

  /* Centralized scroll: precise, firm, no clunkiness.
     Uses requestAnimationFrame so the DOM has settled. */
  var _scrollLock = false;
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function scrollBehavior() {
    return prefersReducedMotion() ? 'auto' : 'smooth';
  }
  function scrollToEl(el, delay, block) {
    if (!el || _scrollLock) return;
    _scrollLock = true;
    setTimeout(function() {
      requestAnimationFrame(function() {
        try {
          el.scrollIntoView({ behavior: scrollBehavior(), block: block || 'start' });
        } catch (e) {}
        _scrollLock = false;
      });
    }, delay || 80);
  }

  /* After a postcode produces a price, bring Total + Proceed into view (#53 P1 #14). */
  function focusPriceAndProceed() {
    var wrap = document.getElementById('qwPriceTotalWrap');
    var btn = document.getElementById('qwBookBtn');
    var price = document.getElementById('qwResPrice');
    if (wrap && wrap.hidden) return;
    var target = btn || wrap || price;
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (rect.top >= 56 && rect.bottom <= vh - 12) return;
    _scrollLock = false;
    scrollToEl(target, 220, 'end');
  }

  function isMobileQuoteLayout() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 720px)').matches);
  }

  /* After fault → land on the quote screen, not the progress pills.
     Mobile: scroll to the step title / repair card so "Your repair quote"
     stays near the top and the postcode sits mid–lower — never yank
     #qwPostcodeCard to block:start (that put postcode flush at the top). */
  function focusQuoteEntry() {
    if (isMobileQuoteLayout()) {
      var mobileTarget = document.getElementById('qw-s4t') ||
        document.getElementById('qwResCard') ||
        document.getElementById('qw-rP');
      scrollToEl(mobileTarget, 120, 'start');
      return;
    }
    var target = document.getElementById('qwPostcodeCard') ||
      document.getElementById('qw-rP') ||
      document.getElementById('qwResCard');
    scrollToEl(target, 180, 'nearest');
  }


  /* After model → fault: bring "What's wrong with your …?" back into view.
     Model lists (esp. MacBook + find-model image) push users down the page;
     pinWizardChrome preserves that Y and leaves the fault title off-screen. */
  function focusWizardStep(stepN) {
    if (_suppressScroll) return;
    var title = document.getElementById('qw-s' + stepN + 't');
    var step = document.getElementById('qw-s' + stepN);
    var target = title || step || document.querySelector('.qw-prog') || document.querySelector('.qw-wizard');
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    /* Already comfortably in the upper half — don't yank. */
    if (rect.top >= 56 && rect.top < vh * 0.42) return;
    scrollToEl(target, 120, 'start');
  }

  /* After postcode → land on collection + journey + price as one screen. */
  function focusCollectionPanel() {
    var slot = document.getElementById('qwSlotPanel');
    var reveal = document.getElementById('qwDeliveryReveal');
    var price = document.getElementById('qwResPrice');
    var target = (slot && !slot.hidden) ? slot : reveal;
    if (!target || target.hidden) return;
    scrollToEl(target, 140, isMobileQuoteLayout() ? 'start' : 'nearest');
    if (price && isMobileQuoteLayout()) {
      setTimeout(function() {
        try {
          var rect = price.getBoundingClientRect();
          if (rect.bottom > (window.innerHeight || 0) - 12) {
            price.scrollIntoView({ behavior: scrollBehavior(), block: 'end' });
          }
        } catch (e) {}
      }, 320);
    }
  }

  /* [4.7] Shared a11y helper */
  function wireA11y(el, label) {
    if (label) el.setAttribute('aria-label', label);
    el.setAttribute('role', 'button');
    el.tabIndex = 0;
    el.onkeydown = function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); } };
  }

  /* =============================================
     DEVICES
     ============================================= */
  var DEVS = [
    { id: 'macbook', label: 'MacBook', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M2 17h20M8 21h8M12 17v4"/></svg>' },
    { id: 'iphone', label: 'iPhone', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="6" y="1" width="12" height="22" rx="2.5"/><path d="M10 19h4"/></svg>' },
    { id: 'ipad', label: 'iPad', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M10 18h4"/></svg>' },
    { id: 'watch', label: 'Watch', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="6" y="4" width="12" height="16" rx="6"/><path d="M9 1h6M9 23h6"/></svg>' }
  ];

  /* =============================================
     FAULT CATEGORIES
     ============================================= */
  var FAULTS = {
    macbook: [
      { v: 'Screen / Display', icon: 'screen', label: 'Screen / Display' },
      { v: 'Power / Battery / Charging', icon: 'battery', label: 'Power / Battery / Charging' },
      { v: 'Trackpad / Keyboard', icon: 'keyboard', label: 'Trackpad / Keyboard' },
      { v: 'Touch Bar', icon: 'touch-bar', label: 'Touch Bar' },
      { v: 'Audio / Mic / Speaker', icon: 'audio', label: 'Audio / Mic / Speaker' },
      { v: 'Water Damage', icon: 'water', label: 'Water Damage' },
      { v: 'Data Recovery', icon: 'data', label: 'Data Recovery' },
      { v: 'Other', icon: 'other', label: 'Other' }
    ],
    iphone: [
      { v: 'Screen / Display', icon: 'screen', label: 'Screen / Display' },
      { v: 'Power / Battery / Charging', icon: 'battery', label: 'Power / Battery / Charging' },
      { v: 'Camera', icon: 'camera', label: 'Front or Rear Camera' },
      { v: 'Audio / Mic / Speaker', icon: 'audio', label: 'Audio / Mic / Speaker' },
      { v: 'Buttons', icon: 'iphone-buttons', label: 'Buttons' },
      { v: 'Connectivity', icon: 'connectivity', label: 'Connectivity' },
      { v: 'Rear Glass', icon: 'rear-glass', label: 'Rear Glass' },
      { v: 'Water Damage', icon: 'water', label: 'Water Damage' },
      { v: 'Data Recovery', icon: 'data', label: 'Data Recovery' },
      { v: 'Other', icon: 'other', label: 'Other' }
    ],
    ipad: [
      { v: 'Screen / Display', icon: 'screen', label: 'Screen / Display' },
      { v: 'Power / Battery / Charging', icon: 'battery', label: 'Power / Battery / Charging' },
      { v: 'Camera', icon: 'camera', label: 'Front or Rear Camera' },
      { v: 'Water Damage', icon: 'water', label: 'Water Damage' },
      { v: 'Data Recovery', icon: 'data', label: 'Data Recovery' },
      { v: 'Other', icon: 'other', label: 'Other' }
    ],
    watch: [
      { v: 'Screen / Display', icon: 'screen', label: 'Screen / Display' },
      { v: 'Power / Battery / Charging', icon: 'battery', label: 'Power / Battery / Charging' },
      { v: 'Rear Glass', icon: 'rear-glass', label: 'Rear Glass' },
      { v: 'Crown', icon: 'buttons', label: 'Crown' },
      { v: 'Water Damage', icon: 'water', label: 'Water Damage' },
      { v: 'Other', icon: 'other', label: 'Other' }
    ]
  };

  var FAULT_ICONS = {
    'screen': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>',
    'battery': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
    'keyboard': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M6 8h.01M10 8h.01M14 8h.01M18 8h.01M8 16h8"/></svg>',
    'touch-bar': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="9" width="20" height="6" rx="3"/><circle cx="7" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="17" cy="12" r="1"/></svg>',
    'audio': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8"/></svg>',
    'camera': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    'rear-glass': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="6" r="1.5"/><path d="M10 18h4"/></svg>',
    'buttons': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="2"/><circle cx="12" cy="16" r="2"/><rect x="7" y="3" width="10" height="18" rx="3"/></svg>',
    'iphone-buttons': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2.6"/><path d="M4.6 6.2v2.2M4.6 10.2v3.2M4.6 15.2v3.2M19.4 8.5v5"/></svg>',
    'mute-button': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2.6"/><path d="M4.6 6.2v2.4"/></svg>',
    'volume-button': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2.6"/><path d="M4.6 9.4v3.4M4.6 14.4v3.4"/></svg>',
    'power-button': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2.6"/><path d="M19.4 8v6"/></svg>',
    'water': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/></svg>',
    'data': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>',
    'other': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>',
    'connectivity': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12.55a11 11 0 0114.08 0M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1"/></svg>'
  };

  /* =============================================
     HANDLE SUFFIX MAP + REPAIR TYPE MAP
     ============================================= */
  var HANDLE_SUFFIX_MAP = {
    'screen-repair':'screen','display-screen-repair':'screen','original-screen-repair':'screen',
    'original-lcd-screen-no-screen-message-repair':'screen','lcd-display-repair':'screen',
    'glass-screen-repair':'screen','xdr-screen-repair':'screen','screen-glass-repair':'screen-glass',
    'dustgate-repair':'dustgate','flexgate-repair':'flexgate','battery-repair':'battery','battery':'battery',
    'charging-port-repair':'charging-port','charging-port':'charging-port','keyboard-repair':'keyboard',
    'trackpad-repair':'trackpad','touch-bar-repair':'touch-bar','loudspeaker-repair':'loudspeaker',
    'loudspeaker':'loudspeaker','earpiece-speaker-repair':'earpiece','microphone-repair':'microphone',
    'microphone':'microphone','rear-camera-repair':'rear-camera','rear-camera':'rear-camera',
    'rear-camera-lens-repair':'rear-camera-lens','rear-camera-lens':'rear-camera-lens',
    'front-camera-repair':'front-camera','front-camera':'front-camera','face-id-repair':'face-id',
    'rear-glass-repair':'rear-glass','housing-repair':'rear-glass','housing-rear-glass-repair':'rear-glass',
    'heart-rate-monitor-rear-glass-repair':'heart-rate-monitor','volume-button-repair':'volume-button',
    'volume-button':'volume-button','power-button-repair':'power-button','power-button':'power-button',
    'mute-button-repair':'mute-button','home-button-repair':'home-button','side-button-repair':'side-button',
    'crown-repair':'crown','diagnostic':'diagnostic'
  };

  var REPAIR_TYPE_TO_FAULT = {
    'screen':'Screen / Display','screen-glass':'Screen / Display','dustgate':'Screen / Display',
    'flexgate':'Screen / Display','battery':'Power / Battery / Charging','charging-port':'Power / Battery / Charging',
    'keyboard':'Trackpad / Keyboard','trackpad':'Trackpad / Keyboard','touch-bar':'Touch Bar',
    'loudspeaker':'Audio / Mic / Speaker','earpiece':'Audio / Mic / Speaker','microphone':'Audio / Mic / Speaker',
    'rear-camera':'Camera','rear-camera-lens':'Camera','front-camera':'Camera','face-id':'Camera',
    'rear-glass':'Rear Glass','heart-rate-monitor':'Rear Glass',
    'power-button':'Buttons','volume-button':'Buttons','mute-button':'Buttons',
    'crown':'Crown','diagnostic':'_diagnostic'
  };

  /* Repair types that share another type's issue cards. */
  var REPAIR_TYPE_ALIASES = { 'dustgate': 'screen', 'flexgate': 'screen' };

  /* Repair type key (screen, rear-camera-lens, ...) or fault name to the fault
     name this device uses in TS. Reads TS so each device keeps its own grouping
     (iPhone rear-camera-lens price pages stay on Rear Glass). alsoListed marks a
     second copy of the same repair, such as the lens under Camera. Null if none. */
  function faultForRepairType(device, key) {
    if (!key) return null;
    var faults = TS[device] || {};
    var raw = String(key).trim();
    if (faults[raw]) return raw;
    var k = raw.toLowerCase();
    var names = Object.keys(faults);
    for (var n = 0; n < names.length; n++) { if (names[n].toLowerCase() === k) return names[n]; }
    var want = [k];
    if (REPAIR_TYPE_ALIASES[k]) want.push(REPAIR_TYPE_ALIASES[k]);
    for (var w = 0; w < want.length; w++) {
      for (var f = 0; f < names.length; f++) {
        var list = faults[names[f]] || [];
        for (var i = 0; i < list.length; i++) {
          if (list[i].alsoListed) continue;
          if (list[i].repairType === want[w] && list[i].route === 'repair') return names[f];
        }
      }
    }
    var mapped = REPAIR_TYPE_TO_FAULT[k];
    return (mapped && faults[mapped]) ? mapped : null;
  }

  /* =============================================
     DEVICE COLOUR DATA
     ============================================= */
  var COLOR_HEX = {
    "Midnight":"#2c3e50","Starlight":"#f5f5dc","Red":"#e74c3c","Blue":"#3498db",
    "Purple":"#9b59b6","Yellow":"#f1c40f","Black":"#1c1c1c","White":"#f9f9f9",
    "Pink":"#ffc0cb","Teal":"#008080","Ultramarine":"#120a8f","Natural Titanium":"#bebebe",
    "Black Titanium":"#212121","White Titanium":"#f2f2f2","Desert Titanium":"#d2b48c",
    "Space Black":"#1a1a1a","Deep Purple":"#3c2a4d","Sierra Blue":"#9fb1bd","Alpine Green":"#505e4d",
    "Graphite":"#4b4e53","Gold":"#e3d0b1","Silver":"#e2e4e1","Midnight Green":"#4e5851",
    "Space Gray":"#535150","Cosmic Orange":"#e67e22","Mist Blue":"#a0d1e5","Sage":"#9db4a1",
    "Lavender":"#e6e6fa","Blue Titanium":"#4b6f86","Sky Blue":"#87CEEB",
    "Green":"#505e4d","Pacific Blue":"#2d4e5c","Deep Blue":"#1a3a5c",
    "Cloud White":"#f4f1ea","Light Gold":"#e6d3a3","Soft Pink":"#f3c6c8","Coral":"#ff6f61"
  };

  var IPHONE_COLORS = {
    "iPhone 17 Pro Max":["Silver","Cosmic Orange","Deep Blue"],
    "iPhone 17 Pro":["Silver","Cosmic Orange","Deep Blue"],
    "iPhone 17":["Black","White","Mist Blue","Sage","Lavender"],
    "iPhone Air":["Space Black","Cloud White","Light Gold","Sky Blue"],
    "iPhone 17e":["Black","White","Soft Pink"],
    "iPhone 16e":["Black","White"],
    "iPhone 16E":["Black","White"],
    "iPhone 16 Pro Max":["Black Titanium","White Titanium","Natural Titanium","Desert Titanium"],
    "iPhone 16 Pro":["Black Titanium","White Titanium","Natural Titanium","Desert Titanium"],
    "iPhone 16 Plus":["Black","White","Pink","Teal","Ultramarine"],
    "iPhone 16":["Black","White","Pink","Teal","Ultramarine"],
    "iPhone 15 Pro Max":["Black Titanium","White Titanium","Blue Titanium","Natural Titanium"],
    "iPhone 15 Pro":["Black Titanium","White Titanium","Blue Titanium","Natural Titanium"],
    "iPhone 15 Plus":["Black","Blue","Green","Yellow","Pink"],
    "iPhone 15":["Black","Blue","Green","Yellow","Pink"],
    "iPhone 14 Pro Max":["Silver","Gold","Space Black","Deep Purple"],
    "iPhone 14 Pro":["Silver","Gold","Space Black","Deep Purple"],
    "iPhone 14 Plus":["Midnight","Starlight","Red","Blue","Purple","Yellow"],
    "iPhone 14":["Midnight","Starlight","Red","Blue","Purple","Yellow"],
    "iPhone 13 Pro Max":["Graphite","Gold","Silver","Sierra Blue","Alpine Green"],
    "iPhone 13 Pro":["Graphite","Gold","Silver","Sierra Blue","Alpine Green"],
    "iPhone 13":["Red","Starlight","Midnight","Blue","Pink","Green"],
    "iPhone 13 Mini":["Red","Starlight","Midnight","Blue","Pink","Green"],
    "iPhone 12 Pro Max":["Silver","Graphite","Gold","Pacific Blue"],
    "iPhone 12 Pro":["Silver","Graphite","Gold","Pacific Blue"],
    "iPhone 12":["Black","White","Red","Green","Blue","Purple"],
    "iPhone 12 Mini":["Black","White","Red","Green","Blue","Purple"],
    "iPhone 11 Pro Max":["Silver","Space Gray","Gold","Midnight Green"],
    "iPhone 11 Pro":["Silver","Space Gray","Gold","Midnight Green"],
    "iPhone 11":["Purple","Green","Yellow","Black","White","Red"],
    "iPhone SE 3rd Gen":["Midnight","Starlight","Red"],
    "iPhone SE 2nd Gen":["Black","White","Red"],
    "iPhone Xs Max":["Gold","Space Gray","Silver"],
    "iPhone Xs":["Gold","Space Gray","Silver"],
    "iPhone XR":["Black","White","Blue","Yellow","Coral","Red"],
    "iPhone X":["Silver","Space Gray"]
  };

  var MACBOOK_COLORS = {
    "A1932":["Space Gray","Gold","Silver"],"A2179":["Space Gray","Gold","Silver"],
    "A2337":["Space Gray","Gold","Silver"],"A2681":["Silver","Starlight","Space Gray","Midnight"],
    "A2941":["Silver","Starlight","Space Gray","Midnight"],"A3113":["Silver","Starlight","Space Gray","Midnight"],
    "A3114":["Silver","Starlight","Space Gray","Midnight"],"A3240":["Silver","Starlight","Sky Blue","Midnight"],
    "A3241":["Silver","Starlight","Sky Blue","Midnight"],
    "A2141":["Silver","Space Gray"],"A2485":["Silver","Space Gray"],"A2780":["Silver","Space Gray"],
    "A1707":["Silver","Space Gray"],"A1990":["Silver","Space Gray"],"A1989":["Silver","Space Gray"],
    "A1706":["Silver","Space Gray"],"A1708":["Silver","Space Gray"],"A2251":["Silver","Space Gray"],
    "A2289":["Silver","Space Gray"],"A2159":["Silver","Space Gray"],"A2338":["Silver","Space Gray"],
    "A2779":["Silver","Space Gray"],"A2918":["Silver","Space Gray"],"A2992":["Silver","Space Gray"],
    "A2442":["Silver","Space Gray"],
    "A2991":["Silver","Space Black"],"A2996":["Silver","Space Black"],"A2998":["Silver","Space Black"],
    "A3401":["Silver","Space Black"],"A3185":["Silver","Space Black"],"A3403":["Silver","Space Black"],
    "A3186":["Silver","Space Black"],"A3112":["Silver","Space Black"]
  };

  function getDeviceColors(device, model, repairType) {
    var needsColor = (device === 'iphone' && (repairType === 'rear-glass' || repairType === 'rear-camera-lens')) ||
                     (device === 'macbook' && repairType === 'trackpad') ||
                     (device === 'macbook' && repairType === 'screen' && modelIs15InchMacBookPro(model));
    if (!needsColor || !model) return null;

    if (device === 'iphone') {
      var colors = IPHONE_COLORS[model];
      if (!colors) {
        var keys = Object.keys(IPHONE_COLORS);
        for (var i = 0; i < keys.length; i++) {
          if (model.indexOf(keys[i]) !== -1 || keys[i].indexOf(model) !== -1) { colors = IPHONE_COLORS[keys[i]]; break; }
        }
      }
      return colors || null;
    }

    if (device === 'macbook') {
      var aMatches = model.match(/A\d{4}/g);
      if (aMatches) {
        for (var j = 0; j < aMatches.length; j++) {
          if (MACBOOK_COLORS[aMatches[j]]) return MACBOOK_COLORS[aMatches[j]];
        }
      }
      return null;
    }

    return null;
  }

  function buildChoiceCards(opt, label, choices) {
    if (!choices || !choices.length) return '';
    var h = '<div class="qw-opt-section"><div class="qw-opt-label">' + esc(label) + '</div><div class="qw-opt-row">';
    choices.forEach(function(choice) {
      h += '<div class="qw-opt-card" data-opt="' + esc(opt) + '" data-add="0" data-value="' + esc(choice.value) + '" tabindex="0">' +
        '<div class="qw-opt-name">' + esc(choice.label) + '</div></div>';
    });
    return h + '</div></div>';
  }

  function selectedChoice(opt) {
    var card = document.querySelector('.qw-opt-card.sel[data-opt="' + opt + '"]');
    return card ? (card.getAttribute('data-value') || '') : '';
  }

  function buildColorSelector(colors) {
    if (!colors || !colors.length) return '';
    var h = '<div class="qw-opt-section"><div class="qw-opt-label">What colour is your device?</div><div class="qw-color-grid" id="qwColorGrid">';
    colors.forEach(function(c) {
      var hex = COLOR_HEX[c] || '#ccc';
      h += '<div class="qw-color-btn" data-color="' + esc(c) + '" tabindex="0">' +
        '<div class="qw-color-swatch" style="background-color:' + hex + '"></div>' +
        '<span class="qw-color-name">' + esc(c) + '</span></div>';
    });
    h += '</div></div>';
    return h;
  }

  function wireColorSelector(container) {
    var grid = container.querySelector('#qwColorGrid');
    if (!grid) return;
    grid.querySelectorAll('.qw-color-btn').forEach(function(btn) {
      wireA11y(btn, 'Select ' + btn.dataset.color);
      btn.onclick = function() {
        grid.querySelectorAll('.qw-color-btn').forEach(function(b) { b.classList.remove('sel'); });
        btn.classList.add('sel');
      };
    });
  }

  /* =============================================
     STATE
     ============================================= */
  var S = { device: null, model: null, modelGroup: null, fault: null, issue: null, step: 1, collectionHandle: null, preFault: null, route: null, repairType: null, entrySource: null , preVariantId: null, preRepairType: null, liquidDeviceUsable: null };
  var _collectionCache = {}, _productCache = {}, _repairsMap = {}, _collectionProducts = [], _trackedSteps = {}, _trackedOps = {};
  var _stepStartTime = Date.now();
  var _suppressScroll = false;
  var _entryTracked = false;
  var _resolutionSeen = false;
  var _resolutionConverted = false;
  var _liquidGate = null;
  var _liquidIssue = null;

  function clearResolutionState() {
    _resolutionSeen = false;
    _resolutionConverted = false;
    _liquidGate = null;
    _liquidIssue = null;
    S.liquidDeviceUsable = null;
  }

  function clearTrackedStepsAfter(step) {
    Object.keys(_trackedSteps).forEach(function(key) {
      if (key === 'resolution') {
        if (step <= 4) delete _trackedSteps[key];
        return;
      }
      var n = parseInt(key, 10);
      if (!isNaN(n) && n > step) delete _trackedSteps[key];
    });
    if (step <= 4) clearResolutionState();
  }

  function buildWizardTrackPayload(extra) {
    var payload = {
      device: S.device,
      model: S.model,
      fault: S.fault,
      issue: S.issue,
      route: S.route || null,
      repairType: S.repairType || null,
      entrySource: S.entrySource || null
    };
    if (extra) {
      Object.keys(extra).forEach(function(key) {
        if (extra[key] !== undefined) payload[key] = extra[key];
      });
    }
    return payload;
  }
  function trackWizardGA4(eventName, extra) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, buildWizardTrackPayload((function() {
      var payload = {
        wizard_name: 'quote_wizard',
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_title: document.title
      };
      if (extra) {
        Object.keys(extra).forEach(function(key) {
          if (extra[key] !== undefined) payload[key] = extra[key];
        });
      }
      return payload;
    })()));
  }

  function trackWizardGA4Once(key, eventName, extra) {
    var ga4Key = 'ga4:' + key;
    if (_trackedOps[ga4Key]) return;
    _trackedOps[ga4Key] = true;
    trackWizardGA4(eventName, extra);
  }

  function trackWizardStart(extra) {
    trackWizardGA4Once('wizard_start', 'wizard_start', extra);
  }

  function trackWizardStepComplete(stepName, stepNumber, extra) {
    var payload = {
      step_name: stepName,
      step_number: stepNumber
    };
    if (extra) {
      Object.keys(extra).forEach(function(key) {
        if (extra[key] !== undefined) payload[key] = extra[key];
      });
    }
    trackWizardGA4('step_complete', payload);
  }

  function trackWizardSubmit(submissionType, extra) {
    var payload = {
      submission_type: submissionType
    };
    if (extra) {
      Object.keys(extra).forEach(function(key) {
        if (extra[key] !== undefined) payload[key] = extra[key];
      });
    }
    trackWizardGA4('wizard_submit', payload);
  }

  function trackWizardFormStart(formName, extra) {
    var payload = {
      form_name: formName
    };
    if (extra) {
      Object.keys(extra).forEach(function(key) {
        if (extra[key] !== undefined) payload[key] = extra[key];
      });
    }
    trackWizardGA4Once('form_start:' + formName, 'form_start', payload);
  }

  function trackWizardFormSubmit(formName, extra) {
    var payload = {
      form_name: formName
    };
    if (extra) {
      Object.keys(extra).forEach(function(key) {
        if (extra[key] !== undefined) payload[key] = extra[key];
      });
    }
    trackWizardGA4('form_submit', payload);
    trackWizardGA4('generate_lead', payload);
  }

  function getWizardTotalValue() {
    var totalEl = document.getElementById('qwPriceTotal');
    if (totalEl) {
      var parsed = parseFloat((totalEl.textContent || '').replace(/[^0-9.]/g, ''));
      if (!isNaN(parsed)) return parsed;
    }
    var resCard = document.getElementById('qwResCard');
    if (!resCard) return 0;
    var fallback = parseFloat(resCard.dataset.base || '0');
    return isNaN(fallback) ? 0 : fallback;
  }


  function trackWizardStep(step, extra) {
    if (!window.posthog) return;
    var key = String(step);
    if (_trackedSteps[key]) return;
    _trackedSteps[key] = true;
    var payload = {
      step: step,
      duration: Date.now() - _stepStartTime
    };
    if (extra) {
      Object.keys(extra).forEach(function(key) {
        if (extra[key] !== undefined) payload[key] = extra[key];
      });
    }
    posthog.capture('wizard_step', buildWizardTrackPayload(payload));
  }

  function trackWizardEvent(eventName, extra) {
    if (!window.posthog) return;
    posthog.capture(eventName, buildWizardTrackPayload(extra));
  }

  function trackWizardEventOnce(key, eventName, extra) {
    if (!window.posthog || _trackedOps[key]) return;
    _trackedOps[key] = true;
    trackWizardEvent(eventName, extra);
  }

  function courierTrackExtra(quote, extra) {
    if (window.ICorrectCourier && typeof window.ICorrectCourier.courierFunnelExtra === 'function') {
      return window.ICorrectCourier.courierFunnelExtra(quote, extra);
    }
    var payload = extra ? Object.assign({}, extra) : {};
    delete payload.postcode;
    return payload;
  }

  function trackCourierQuoteEvents(quote) {
    if (!quote || !quote.outward) return;
    if (!isFullPostcodeValue(currentPostcodeValue())) return;
    var extra = courierTrackExtra(quote);
    var outward = extra.outward;
    trackWizardEventOnce('pc:' + outward + ':' + String(extra.band), 'wizard_postcode_entered', {
      outward: extra.outward,
      band: extra.band
    });
    if (quote.service === 'courier' && quote.band) {
      trackWizardEventOnce(
        'quoted:' + outward + ':' + quote.band + ':' + quote.tier + ':' + quote.adjustment + ':' + quote.total,
        'wizard_courier_quoted',
        extra
      );
    }
    if (quote.forcedMailIn || !quote.band) {
      trackWizardEventOnce('ooa:' + outward, 'wizard_out_of_area', {
        outward: extra.outward,
        band: null
      });
    }
    var service = quote.service === 'mail-in' ? 'mail-in' : 'courier';
    trackWizardEventOnce('svc:' + outward + ':' + service, 'wizard_service_selected', {
      service: service,
      adjustment: extra.adjustment,
      total: extra.total,
      band: extra.band
    });
    if (service === 'mail-in') {
      trackWizardEventOnce('mailin:' + outward, 'wizard_mailin_confirmed', extra);
    }
  }

  function trackSlotSelected() {
    if (!_collectionSlot.date || !_collectionSlot.part) return;
    var extra = courierTrackExtra(_courierQuote, {
      collection_date: _collectionSlot.date.iso,
      collection_window: _collectionSlot.part.id,
      collection_window_label: _collectionSlot.part.windowLabel
        || ((_collectionSlot.part.label || '') + ' ' + (_collectionSlot.part.detail || '')).trim()
    });
    trackWizardEventOnce(
      'slot:' + extra.collection_date + ':' + extra.collection_window,
      'wizard_slot_selected',
      extra
    );
  }

  function trackWizardProceed() {
    var svcKind = selectedServiceKind();
    var service = svcKind === 'mailin' ? 'mail-in' : 'courier';
    trackWizardEvent('wizard_proceed', courierTrackExtra(_courierQuote, {
      service: service,
      total: getWizardTotalValue()
    }));
  }

  function trackWizardEntry(source, extra) {
    S.entrySource = source;
    if (_entryTracked) return;
    _entryTracked = true;
    trackWizardEvent('wizard_entry', (function() {
      var payload = { entrySource: source };
      if (extra) {
        Object.keys(extra).forEach(function(key) {
          if (extra[key] !== undefined) payload[key] = extra[key];
        });
      }
      return payload;
    })());
  }

  /* =============================================
     TRIAGE/ISSUE DATA (updated: Batch 2)
     ============================================= */
  var TS = {
    macbook: {
      'Screen / Display': [
        { label: 'Cracked or shattered screen', route: 'repair', repairType: 'screen', noTrueTone: true, copy: 'We replace your damaged MacBook screen with a genuine Apple display.' },
        { label: 'Cracked or shattered screen', route: 'repair', repairType: 'screen', trueToneOnly: true, copy: 'We replace your damaged MacBook screen with a genuine Apple display and keep True Tone working.' },
        { label: 'Thick bands, artefacts, or distortion', route: 'repair', repairType: 'screen', copy: 'Lines or colour issues on your display typically mean the display panel needs replacing. We use genuine displays with full colour calibration.', dustgateCheck: true },
        { label: 'Dead pixels or bright spots', route: 'repair', repairType: 'screen', copy: 'Dead or stuck pixels are a fault within the panel. We replace the display with a genuine Apple one.' },
        { label: 'No image, backlight on, external monitor works', route: 'repair', repairType: 'screen', copy: 'If your MacBook screen is not completely black but shows a blue or purple tint when the brightness is turned all the way up, while the MacBook still works normally on an external monitor, the LCD panel has failed and needs to be replaced. We complete the repair by replacing the LCD panel with a genuine Apple one and configuring it so all of the screen\u2019s original functionality is retained.' },
        { label: 'No image, no backlight or no external picture', route: 'diagnostic', repairType: 'diagnostic', copy: 'If your MacBook powers on but the screen stays completely black with no tint, no backlight, and nothing appears on an external monitor either, the fault could be with the display or the logic board.' },
        { label: 'Backlight fading or dim at angle', route: 'repair', repairType: 'screen', flexgateModelsOnly: true, flexgateCheck: true, copy: 'The backlight fading, or going dim when you tilt the screen, means the display panel has failed. We\'ll quote a display panel replacement.' },
        { label: 'Backlight fading or dim at angle', route: 'repair', repairType: 'screen', notFlexgateModels: true, copy: 'The backlight fading, or going dim when you tilt the screen, means the display panel has failed. We\'ll quote a display panel replacement. Flexgate only used to occur on the 13-inch A1706 (2016–2018), the 13-inch A1708 (2016–2017), and the 15-inch A1707 (2016–2017).' }
      ],
      'Power / Battery / Charging': [
        { label: 'Battery draining quickly', route: 'repair', repairType: 'battery', copy: 'We fit an original-specification battery with working battery health reporting.' },
        { label: '"Service Recommended" warning', route: 'repair', repairType: 'battery', copy: 'The "Service Recommended" warning means macOS has flagged the battery for replacement. We fit an original-specification battery with working battery health reporting.' },
        { label: 'Battery swollen or expanding', route: 'repair', repairType: 'battery', copy: 'We safely remove the swollen battery and fit a replacement.', urgent: true },
        { label: 'Won\'t turn on', route: 'diagnostic', repairType: 'diagnostic', copy: 'A MacBook showing no signs of life can have a fault with the battery, charging ports or logic board. For this reason, we need to carry out a full diagnostic to confirm exactly what has failed before quoting the repair.' },
        { label: 'Random shutdowns or reboots', route: 'diagnostic', repairType: 'diagnostic', copy: 'A MacBook that randomly shuts down or restarts can have several possible causes. Because the fault is intermittent, we need to run a full diagnostic and stress test the device to reproduce it and confirm the actual cause before quoting the repair.' },
        { label: 'Device powers on, but will not charge', route: 'repair', repairType: 'charging-port', copy: 'The MacBook turns on but will not charge. We\'ll replace the charging port and test it. If the logic board is the cause, we\'ll tell you before any extra work.' }
      ],
      'Trackpad / Keyboard': [
        { label: 'Keys not responding', route: 'repair', repairType: 'keyboard', copy: 'We replace the keyboard using genuine Apple keys. If testing reveals liquid damage, we\'ll contact you before any additional work.' },
        { label: 'Sticky, stuck, or crunchy keys', route: 'repair', repairType: 'keyboard', copy: 'We replace the keyboard using genuine Apple keys. If testing reveals liquid damage, we\'ll contact you before any additional work.' },
        { label: 'Trackpad not clicking', route: 'repair', repairType: 'trackpad', copy: 'A trackpad that won\'t click can be faulty or under pressure from a swollen battery. This quote covers the trackpad repair. We\'ll check the battery when the MacBook arrives and let you know if it is the cause.' },
        { label: 'Ghost typing or phantom input', route: 'repair', repairType: 'keyboard', copy: 'We replace the keyboard using genuine Apple keys. If testing reveals liquid damage, we\'ll contact you before any additional work.' },
        { label: 'Missing or broken keycap', route: 'repair', repairType: 'keyboard', copy: 'A physically broken or missing keycap means the keyboard mechanism is likely damaged too. We replace the keyboard using genuine Apple keys.' },
        { label: 'Physically damaged trackpad', route: 'repair', repairType: 'trackpad', copy: 'We replace the damaged trackpad with a genuine Apple one.' }
      ],
      'Touch Bar': [
        { label: 'Touch Bar not responding or frozen', route: 'repair', repairType: 'touch-bar', copy: 'A frozen Touch Bar usually means that the module failed. We fix the issue by replacing it.' },
        { label: 'Touch Bar flickering or displaying incorrectly', route: 'repair', repairType: 'touch-bar', copy: 'We replace the Touch Bar panel to fix flickering or display faults.' },
        { label: 'Touch Bar cracked or physically damaged', route: 'repair', repairType: 'touch-bar', copy: 'We replace the cracked Touch Bar module.' }
      ],
      'Audio / Mic / Speaker': [
        { label: 'No sound from speakers', route: 'contact', repairType: null, copy: 'Tell us what happens when you try to play sound. We\'ll confirm the repair options and cost for your MacBook.' },
        { label: 'Crackling or distorted audio', route: 'contact', repairType: null, copy: 'Distorted audio can come from the speaker or its circuit. Get in touch so we can check which repair you need.' },
        { label: 'Microphone not working', route: 'contact', repairType: null, copy: 'Get in touch about the microphone fault. We\'ll confirm whether a parts replacement is available for your model.' }
      ],
      'Water Damage': [
        { label: 'Spilled liquid recently (within 24 hours)', route: 'diagnostic', repairType: 'diagnostic', copy: 'Time is critical with liquid damage. We can\'t quote the full repair until we\'ve opened it, cleaned with ultrasonic, and seen what\'s affected.', urgent: true },
        { label: 'Spilled liquid (more than 24 hours ago)', route: 'diagnostic', repairType: 'diagnostic', copy: 'Liquid causes corrosion to spread. We inspect the MacBook internally to see what needs repairing or replacing.' },
        { label: 'Partial failure after liquid exposure', route: 'diagnostic', repairType: 'diagnostic', copy: 'When some functions still work after a spill, specific circuits are damaged. We can\'t quote the full repair until we\'ve mapped what\'s affected.' },
        { label: 'MacBook was submerged', route: 'diagnostic', repairType: 'diagnostic', copy: 'Full submersion needs a strip-down before we can quote. Bring it in without charging or turning it on. We\'ll assess and email the repair options.', urgent: true }
      ],
      'Data Recovery': [
        { label: 'Drive not mounting or not detected', route: 'diagnostic', repairType: 'diagnostic', copy: 'We check the storage drive, its connection and the logic board to find out why the drive isn\'t being detected.' },
        { label: 'Accidentally deleted files', route: 'contact', repairType: null, copy: 'Recovering deleted files depends on the type of storage in your MacBook. Get in touch so we can explain the options.' },
        { label: 'MacBook dead, need data', route: 'diagnostic', repairType: 'diagnostic', copy: 'If your MacBook won\'t turn on but you need the data, we\'ll diagnose the board. In many cases we can repair it enough to extract the data.' }
      ],
      'Other': [
        { label: 'Overheating or fans running loud', route: 'contact', repairType: null, copy: 'Heat and fan noise are often dust or dried thermal paste. Get in touch and we\'ll confirm the clean-and-service option for your model.' },
        { label: 'Slow performance', route: 'contact', repairType: null, copy: 'Performance issues are often software-related. Get in touch and we\'ll help work out whether it\'s hardware or software.' },
        { label: 'Something else', route: 'contact', repairType: null, copy: 'Describe the issue and we\'ll get back to you with the best repair option.' }
      ]
    },
    iphone: {
      'Screen / Display': [
        { label: 'Cracked glass (touch still works)', route: 'repair', repairType: 'screen', lcdOnly: true, copy: 'We replace the cracked screen with a genuine Apple LCD display and configure it so it is recognised in iOS Settings.' },
        { label: 'Cracked glass (touch still works)', route: 'repair', repairType: 'screen', oledOnly: true, copy: 'We replace the cracked screen with a genuine Apple OLED display and configure it so it is recognised in iOS Settings.' },
        { label: 'Touch not responding', route: 'repair', repairType: 'screen', copy: 'A dead touchscreen means the digitiser is damaged. A genuine screen replacement will restore full touch functionality.' },
        { label: 'Lines, discolouration, or green line', route: 'repair', repairType: 'screen', copy: 'Display lines or colour shifting indicate panel damage. A genuine screen replacement will fix it.' },
        { label: 'Black screen (phone still vibrates/rings)', route: 'repair', repairType: 'screen', copy: 'If your phone vibrates or makes sounds but the screen is black, the display has failed. A screen replacement will bring it back.' },
        { label: 'No display, no response', route: 'diagnostic', repairType: 'diagnostic', copy: 'If your iPhone shows no signs of life, it could be the display, battery, or logic board. We can\'t quote the full repair until we\'ve tested it.' }
      ],
      'Power / Battery / Charging': [
        { label: 'Battery drains fast', route: 'repair', repairType: 'battery', copy: 'Your battery has degraded below healthy capacity. We\'ll replace it with a genuine Apple battery and your battery health will read accurately again.' },
        { label: 'Won\'t turn on', route: 'diagnostic', repairType: 'diagnostic', copy: 'An iPhone that won\'t power on could be the battery, charging circuit, or logic board. Try a hard reset first: press Volume Up, press Volume Down, then hold the side button until the Apple logo appears. We can\'t quote the full repair until we\'ve looked.' },
        { label: 'Random shutdowns or reboots', route: 'diagnostic', repairType: 'diagnostic', copy: 'Unexpected shutdowns can be the battery or the logic board. We can\'t quote the full repair until we\'ve looked.' },
        { label: 'Swollen battery', route: 'repair', repairType: 'battery', copy: 'We\'ll replace the battery safely.', urgent: true },
        { label: 'Device powers on, but will not charge', route: 'repair', repairType: 'charging-port', faceIdOnly: true, copy: 'If the iPhone turns on and charges with a wireless charger, but the port does nothing, the charging port is the fault. We\'ll replace it and test charging.' },
        { label: 'Device powers on, but will not charge', route: 'repair', repairType: 'charging-port', noFaceIdOnly: true, copy: 'The iPhone turns on but will not charge from the port. We\'ll replace the charging port and test it. If the board is the cause, we\'ll tell you before any extra work.' },
        { label: 'Charges, but won\'t connect to a computer', route: 'repair', repairType: 'charging-port', copy: 'We\'ll replace the charging port, which usually fixes this, and confirm the fault during the repair. If it turns out the issue is with the logic board instead, we\'ll let you know and send you a quote before doing anything further. Nothing extra is ever done without your go-ahead.' }
      ],
      'Camera': [
        { label: 'Back camera blurry or shaking', route: 'repair', repairType: 'rear-camera', copy: 'A blurry or shaking back camera usually means the stabilisation system has failed. We\'ll replace the rear camera module.' },
        { label: 'Back camera: no preview or it freezes', route: 'diagnostic', repairType: 'diagnostic', copy: 'A black preview, or a back camera that freezes or crashes, can be the module or the board. We can\'t quote the full repair until we\'ve looked.' },
        { label: 'Front camera: Face ID error or TrueDepth message', route: 'repair', repairType: 'front-camera', faceIdOnly: true, copy: 'A TrueDepth camera message in Settings, or a Face ID error, means the front camera module needs replacing. The Face ID module needs to be ordered directly from Apple, so this repair takes 5-7 working days.' },
        { label: 'Front camera not working', route: 'repair', repairType: 'front-camera', noFaceIdOnly: true, copy: 'We replace the faulty front camera module.' },
        { label: 'Front camera: no preview or it freezes', route: 'diagnostic', repairType: 'diagnostic', copy: 'A black preview, or a front camera that freezes or crashes, can be the module or the board. We can\'t quote the full repair until we\'ve inspected both.' },
        { label: 'Condensation in camera', route: 'diagnostic', repairType: 'diagnostic', copy: 'Moisture inside the camera is a sign of liquid or a broken seal. We can\'t quote the full repair until we\'ve checked for internal corrosion.' },
        { label: 'Camera lens cover cracked', route: 'repair', repairType: 'rear-camera-lens', alsoListed: true, copy: 'A cracked camera lens cover lets dust and moisture in. We\'ll replace the lens cover to protect your cameras.' }
      ],
      'Audio / Mic / Speaker': [
        { label: 'No sound or low volume from speaker', route: 'repair', repairType: 'loudspeaker', copy: 'The loudspeaker module has likely failed. We\'ll replace it to restore full volume and clarity.' },
        { label: 'Earpiece quiet or silent during calls', route: 'repair', repairType: 'earpiece', copy: 'The earpiece speaker needs replacing. A quick swap will fix this.' },
        { label: 'Microphone not picking up voice', route: 'repair', repairType: 'microphone', copy: 'We\'ll quote a microphone replacement. If more than one mic or a flex is involved, we\'ll confirm that once the phone is here.' }
      ],
      'Buttons': [
        { label: 'Power button stuck or not responding', icon: 'power-button', route: 'repair', repairType: 'power-button', copy: 'The power button is stuck, loose, or does nothing. We\'ll replace the power button.' },
        { label: 'Volume buttons stuck or not responding', icon: 'volume-button', route: 'repair', repairType: 'volume-button', copy: 'The volume buttons are stuck, loose, or do nothing. We\'ll replace the volume buttons.' },
        { label: 'Mute switch stuck or not clicking', icon: 'mute-button', route: 'repair', repairType: 'mute-button', copy: 'The mute switch is stuck or will not click over. We\'ll replace the mute switch.' }
      ],
      'Rear Glass': [
        { label: 'Cracked back glass', route: 'repair', repairType: 'rear-glass', copy: 'We replace the rear glass with a genuine Apple housing in your original colour.' },
        { label: 'Camera lens cover cracked', route: 'repair', repairType: 'rear-camera-lens', copy: 'A cracked camera lens cover lets dust and moisture in. We\'ll replace the lens cover to protect your cameras.' }
      ],
      'Water Damage': [
        { label: 'Dropped in liquid (within 24 hours)', route: 'diagnostic', repairType: 'diagnostic', copy: 'Don\'t try to charge or turn on your iPhone. We\'ll open it up, perform an ultrasonic clean, and assess the damage.', urgent: true },
        { label: 'Liquid damage (more than 24 hours ago)', route: 'diagnostic', repairType: 'diagnostic', copy: 'Liquid causes corrosion that spreads over time. We need to open the phone, clean the corrosion, and check each circuit.' }
      ],
      'Data Recovery': [
        { label: 'Phone dead, need data', route: 'diagnostic', repairType: 'diagnostic', copy: 'We can attempt a data recovery repair to get the phone working long enough to back up. Success depends on the fault.' },
        { label: 'Forgotten passcode', route: 'dismiss', repairType: null, copy: 'We can\'t bypass an iPhone passcode or iCloud lock. If you\'re the original owner, Apple Support can help with account recovery.' }
      ],
      'Connectivity': [
        { label: 'No signal / "No Service" / "SOS only"', route: 'diagnostic', repairType: 'diagnostic', copy: 'Loss of cellular signal could be an antenna, baseband chip, or SIM reader. Book a diagnostic and we\'ll identify the fault before quoting a repair.' },
        { label: 'eSIM not detected', route: 'diagnostic', repairType: 'diagnostic', esimOnly: true, copy: 'A missing eSIM or "No SIM" message can be the eSIM profile or the board. There is no SIM tray on this iPhone. Book a diagnostic and we\'ll identify it before quoting a repair.' },
        { label: 'SIM not detected', route: 'diagnostic', repairType: 'diagnostic', simTrayOnly: true, copy: 'A missing SIM or "No SIM" message can be the tray, the reader, or the board. Book a diagnostic and we\'ll identify it before quoting a repair.' },
        { label: 'WiFi not connecting or greyed out', route: 'diagnostic', repairType: 'diagnostic', copy: 'A greyed-out WiFi toggle usually means a hardware fault on the logic board. Book a diagnostic and we\'ll confirm it before quoting a repair.' },
        { label: 'Bluetooth not working', route: 'diagnostic', repairType: 'diagnostic', copy: 'Bluetooth and WiFi share the same chip on iPhones. Book a diagnostic and we\'ll confirm the fault before quoting a repair.' },
        { label: 'Apple Pay / NFC not working', route: 'diagnostic', repairType: 'diagnostic', copy: 'We\'ll run a diagnostic to find the cause and send you a quote before doing any work.' },
        { label: 'Won\'t activate', route: 'diagnostic', repairType: 'diagnostic', copy: 'We\'ll run a diagnostic to find out what\'s causing it and send you a quote before doing any work.' }
      ],
      'Other': [
        { label: 'Vibration not working', route: 'contact', repairType: null, copy: 'The Taptic Engine may have failed. Get in touch and we\'ll confirm whether we can repair it for your model.' },
        { label: 'General diagnostic', route: 'diagnostic', repairType: 'diagnostic', copy: 'Not sure what\'s wrong, or want a second opinion? We\'ll run a full diagnostic and send you our findings with a quote before doing any work.' },
        { label: 'Board fault confirmed elsewhere', route: 'diagnostic', repairType: 'diagnostic', copy: 'We\'ll run our own diagnostic to confirm the fault and whether it can be repaired. You\'ll get our findings and a quote before we do anything.' },
        { label: 'Several parts damaged', route: 'contact', repairType: null, copy: 'If your device has a bent frame or more than one broken part, get in touch and we\'ll put together a quote for everything it needs.' },
        { label: 'Software issue', route: 'diagnostic', repairType: 'diagnostic', copy: 'Stuck on the Apple logo, restarting, or showing a restore or update error? We\'ll diagnose the cause and confirm the fix and price before going ahead.' },
        { label: 'Something else', route: 'contact', repairType: null, copy: 'Describe the issue and we\'ll get back to you with the best repair option.' }
      ]
    },
    ipad: {
      'Screen / Display': [
        { label: 'Cracked glass only (display still works)', route: 'repair', repairType: 'screen-glass', copy: 'We replace the cracked outer glass while keeping the working display.' },
        { label: 'Cracked glass only (display still works)', route: 'repair', repairType: 'screen', onlyWhenMissing: 'screen-glass', copy: 'The glass and display are bonded together on this model, so we replace the complete screen.' },
        { label: 'Touch not responding', route: 'repair', repairType: 'screen', copy: 'We replace the faulty touchscreen with a genuine display to restore touch response.' },
        { label: 'Blotches, lines, or a damaged display', route: 'repair', repairType: 'screen', copy: 'Blotches and lines affect the display itself. We need to replace the actual display panel.' },
        { label: 'Black screen (sound or buttons still work)', route: 'repair', repairType: 'screen', copy: 'If the iPad still responds, it means the display has failed. We fix the issue by installing a genuine Apple screen.' },
        { label: 'No display, no response', route: 'diagnostic', repairType: 'diagnostic', copy: 'If the iPad shows no signs of life, it could be the display, battery, or logic board. We can\'t quote the full repair until we\'ve tested it.' }
      ],
      'Power / Battery / Charging': [
        { label: 'Battery drains quickly', route: 'repair', repairType: 'battery', copy: 'Your iPad battery has degraded. We\'ll replace it with an original-spec battery.' },
        { label: 'Won\'t turn on', route: 'diagnostic', repairType: 'diagnostic', ipadHomeButton: true, copy: 'An iPad that won\'t power on could be the battery, charging port, or logic board. Try a hard reset first: hold the top button and the Home button until the Apple logo appears. We can\'t quote the full repair until we\'ve looked.' },
        { label: 'Won\'t turn on', route: 'diagnostic', repairType: 'diagnostic', ipadNoHomeButton: true, copy: 'An iPad that won\'t power on could be the battery, charging port, or logic board. Try a hard reset first: press Volume Up, press Volume Down, then hold the top button until the Apple logo appears. We can\'t quote the full repair until we\'ve looked.' },
        { label: 'Battery swollen or screen lifting', route: 'repair', repairType: 'battery', copy: 'A swollen battery is pushing the screen away from the frame. We\'ll safely remove it and fit a replacement.', urgent: true },
        { label: 'Device powers on, but will not charge', route: 'repair', repairType: 'charging-port', copy: 'The iPad turns on but will not charge from the port. We\'ll replace the charging port and test it. If the board is the cause, we\'ll tell you before any extra work.' },
        { label: 'Charges, but won\'t connect to a computer', route: 'repair', repairType: 'charging-port', copy: 'We\'ll replace the charging port, which usually fixes this, and confirm the fault during the repair. If it turns out the issue is with the logic board instead, we\'ll let you know and send you a quote before doing anything further. Nothing extra is ever done without your go-ahead.' }
      ],
      'Camera': [],
      'Water Damage': [
        { label: 'Dropped in liquid (within 24 hours)', route: 'diagnostic', repairType: 'diagnostic', copy: 'Time is critical. We\'ll open the iPad, clean affected components with ultrasonic cleaning, and assess which parts need replacing. Don\'t try to charge it.', urgent: true },
        { label: 'Liquid damage (more than 24 hours ago)', route: 'diagnostic', repairType: 'diagnostic', copy: 'Corrosion spreads over time even after the device dries out. We need to open it, clean the corrosion, and check each circuit.' },
        { label: 'Partial failure after liquid exposure', route: 'diagnostic', repairType: 'diagnostic', copy: 'When some functions still work after a spill, specific circuits are damaged. A diagnostic will map exactly what needs repair.' },
        { label: 'iPad was submerged', route: 'diagnostic', repairType: 'diagnostic', copy: 'Full submersion causes widespread corrosion. Bring it in without charging or turning it on. We\'ll do a full strip-down and assessment.', urgent: true }
      ],
      'Data Recovery': [
        { label: 'Need data from broken iPad', route: 'diagnostic', repairType: 'diagnostic', copy: 'We\'ll attempt to repair it enough to allow a backup. Success depends on the fault.' }
      ],
      'Other': [
        { label: 'No sound from speakers', route: 'contact', repairType: null, copy: 'iPad speaker faults vary by model. Tell us what you\'re hearing and we\'ll confirm the repair and price.' },
        { label: 'Microphone not working', route: 'contact', repairType: null, copy: 'iPad mic faults depend on the model. Get in touch and we\'ll confirm whether we can quote a parts repair.' },
        { label: 'WiFi not connecting', route: 'diagnostic', repairType: 'diagnostic', copy: 'WiFi issues can be the antenna, wireless chip, or software. We need to diagnose the device to quote the repair.' },
        { label: 'Bluetooth not working', route: 'diagnostic', repairType: 'diagnostic', copy: 'Bluetooth and WiFi share components on iPads. We need to diagnose the device to quote the repair.' },
        { label: 'NFC / Apple Pay not working', route: 'diagnostic', repairType: 'diagnostic', copy: 'We\'ll run a diagnostic to find the cause and send you a quote before doing any work.' },
        { label: 'General diagnostic', route: 'diagnostic', repairType: 'diagnostic', copy: 'Not sure what\'s wrong, or want a second opinion? We\'ll run a full diagnostic and send you our findings with a quote before doing any work.' },
        { label: 'Board fault confirmed elsewhere', route: 'diagnostic', repairType: 'diagnostic', copy: 'We\'ll run our own diagnostic to confirm the fault and whether it can be repaired. You\'ll get our findings and a quote before we do anything.' },
        { label: 'Several parts damaged', route: 'contact', repairType: null, copy: 'If your device has a bent frame or more than one broken part, get in touch and we\'ll put together a quote for everything it needs.' },
        { label: 'Software issue', route: 'diagnostic', repairType: 'diagnostic', copy: 'Stuck on the Apple logo, restarting, or showing a restore or update error? We\'ll diagnose the cause and confirm the fix and price before going ahead.' },
        { label: 'Something else', route: 'contact', repairType: null, copy: 'Describe the issue and we\'ll get back to you with the best repair option.' }
      ]
    },
    watch: {
      'Screen / Display': [
        { label: 'Cracked screen (display still works)', route: 'repair', repairType: 'screen-glass', copy: 'Your watch glass is cracked but the display works. We\'ll replace the glass and re-seal the watch.' },
        { label: 'Cracked screen (display damaged or bleeding)', route: 'repair', repairType: 'screen', copy: 'The OLED display is damaged. We\'ll fit a genuine panel and re-seal the watch.' },
        { label: 'Display dead or unresponsive', route: 'repair', repairType: 'screen', copy: 'If the Apple Watch is still powering on but the display has no image or is unresponsive, the screen has likely failed. We replace it with a genuine display and re-seal the Watch afterwards. If we find any additional battery or logic board faults once it arrives, we’ll contact you.' }
      ],
      'Power / Battery / Charging': [
        { label: 'Won\'t charge', route: 'diagnostic', repairType: 'diagnostic', copy: 'Charging failure on Apple Watch can be the coil, battery, or main board. We can\'t quote the full repair until we\'ve tested it.' },
        { label: 'Battery drains fast', route: 'repair', repairType: 'battery', copy: 'Your watch battery has degraded. We\'ll swap it and re-seal the watch.' },
        { label: 'Won\'t turn on', route: 'diagnostic', repairType: 'diagnostic', copy: 'If the watch won\'t power on, it could be the battery or a board-level fault. Try a restart first: hold the side button and the Digital Crown together for at least 10 seconds, until the Apple logo appears. We can\'t quote the full repair until we\'ve looked.' },
        { label: 'Battery swollen or back popping off', route: 'repair', repairType: 'battery', copy: 'A swollen battery is pushing the back off the watch. Stop wearing it immediately. We\'ll replace the battery and re-seal the case.', urgent: true }
      ],
      'Rear Glass': [
        { label: 'Cracked back crystal / sensor glass', route: 'repair', repairType: 'heart-rate-monitor', noBloodOxygen: true, copy: 'The rear crystal houses the heart rate sensor. We\'ll replace it to restore sensor accuracy and the water seal.' },
        { label: 'Cracked back crystal / sensor glass', route: 'repair', repairType: 'heart-rate-monitor', bloodOxygenOnly: true, copy: 'The rear crystal houses the heart rate and blood oxygen sensors. We\'ll replace it to restore sensor accuracy and the water seal.' }
      ],
      'Crown': [
        { label: 'Digital Crown stuck or not rotating', route: 'repair', repairType: 'crown', copy: 'The Digital Crown can get jammed by dirt or debris. We\'ll clean or replace the crown mechanism.' }
      ],
      'Water Damage': [
        { label: 'Water ingress despite water resistance', route: 'diagnostic', repairType: 'diagnostic', copy: 'Water-resistant seals can fail over time or after impact. We\'ll open the watch, clean any corrosion, and assess the damage.' },
        { label: 'Submerged beyond depth rating', route: 'diagnostic', repairType: 'diagnostic', copy: 'Exceeding the rated depth can force water past the seals. Don\'t charge the watch. We\'ll open it, clean the internals, and check each component.' }
      ],
      'Other': [
        { label: 'Bluetooth not connecting to phone', route: 'diagnostic', repairType: 'diagnostic', copy: 'Bluetooth pairing can be hardware or software. We need to diagnose the watch to quote the repair.' },
        { label: 'WiFi not working', route: 'diagnostic', repairType: 'diagnostic', copy: 'Watch WiFi faults are typically the antenna or wireless chip. We need to diagnose it to quote.' },
        { label: 'Something else', route: 'contact', repairType: null, copy: 'Describe the issue and we\'ll get back to you with the best repair option.' }
      ]
    }
  };

  /* =============================================
     IPHONE VISUAL GUIDE DB
     ============================================= */
  var VG_DB = [
    {n:"iPhone 17 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/17_pro_max_colours.png?v=1766237419",cams:"tri_plat",edges:"curved",screen:"island",size:"max"},
    {n:"iPhone 17 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/17_pro_max_colours.png?v=1766237419",cams:"tri_plat",edges:"curved",screen:"island",size:"pro"},
    {n:"iPhone 17",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/17_colours.png?v=1766237419",cams:"vert",edges:"flat",screen:"island",size:"std"},
    {n:"iPhone Air",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/air_colours.png?v=1766237418",cams:"single_plat",edges:"flat",screen:"island",size:"max"},
    {n:"iPhone 16 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/16_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"island",size:"max"},
    {n:"iPhone 16 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/16_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"island",size:"pro"},
    {n:"iPhone 16 Plus",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/16_colours.png?v=1766237419",cams:"vert",edges:"flat",screen:"island",size:"max"},
    {n:"iPhone 16",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/16_colours.png?v=1766237419",cams:"vert",edges:"flat",screen:"island",size:"std"},
    {n:"iPhone 16e",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/16e_colours.png?v=1766237418",cams:"single_std",edges:"flat",screen:"notch",size:"std"},
    {n:"iPhone 15 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/15_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"island",size:"max"},
    {n:"iPhone 15 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/15_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"island",size:"pro"},
    {n:"iPhone 15 Plus",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/15_colours.png?v=1766237419",cams:"diag",edges:"flat",screen:"island",size:"max"},
    {n:"iPhone 15",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/15_colours.png?v=1766237419",cams:"diag",edges:"flat",screen:"island",size:"std"},
    {n:"iPhone 14 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/14_pro_max_colours.png?v=1766237418",cams:"tri_std",edges:"flat",screen:"island",size:"max"},
    {n:"iPhone 14 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/14_pro_max_colours.png?v=1766237418",cams:"tri_std",edges:"flat",screen:"island",size:"pro"},
    {n:"iPhone 14 Plus",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/14_colours.png?v=1766237419",cams:"diag",edges:"flat",screen:"notch",size:"max"},
    {n:"iPhone 14",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/14_colours.png?v=1766237419",cams:"diag",edges:"flat",screen:"notch",size:"std"},
    {n:"iPhone 13 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/13_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"notch",size:"max"},
    {n:"iPhone 13 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/13_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"notch",size:"pro"},
    {n:"iPhone 13 Mini",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/13_colours.png?v=1766237419",cams:"diag",edges:"flat",screen:"notch",size:"mini"},
    {n:"iPhone 13",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/13_colours.png?v=1766237419",cams:"diag",edges:"flat",screen:"notch",size:"std"},
    {n:"iPhone 12 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/12_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"notch",size:"max"},
    {n:"iPhone 12 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/12_pro_max_colours.png?v=1766237419",cams:"tri_std",edges:"flat",screen:"notch",size:"pro"},
    {n:"iPhone 12 Mini",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/12_colours.png?v=1766237419",cams:"vert",edges:"flat",screen:"notch",size:"mini"},
    {n:"iPhone 12",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/12_colours.png?v=1766237419",cams:"vert",edges:"flat",screen:"notch",size:"std"},
    {n:"iPhone 11 Pro Max",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/11_pro_max.png?v=1766237419",cams:"tri_std",edges:"curved",screen:"notch",size:"max"},
    {n:"iPhone 11 Pro",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/11_pro_max.png?v=1766237419",cams:"tri_std",edges:"curved",screen:"notch",size:"pro"},
    {n:"iPhone 11",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/11_colours.png?v=1766237419",cams:"vert",edges:"curved",screen:"notch",size:"std"},
    {n:"iPhone SE (3rd Gen)",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/se3_colours.png?v=1766237418",cams:"single_std",edges:"curved",screen:"home",size:"std"},
    {n:"iPhone SE (2nd Gen)",img:"https://cdn.shopify.com/s/files/1/0728/7111/7053/files/se2_colours.png?v=1766237418",cams:"single_std",edges:"curved",screen:"home",size:"std"}
  ];

  /* MacBook model number lookup DB */
  var MB_NUMS = [
    {n:"A3403",m:"MacBook Pro 16-inch 'M4 Pro/Max' A3186/A3403 (2024)"},{n:"A3186",m:"MacBook Pro 16-inch 'M4 Pro/Max' A3186/A3403 (2024)"},
    {n:"A2991",m:"MacBook Pro 16-inch 'M3 Pro/Max' A2991 (2023)"},{n:"A2780",m:"MacBook Pro 16-inch 'M2 Pro/Max' A2780 (2023)"},
    {n:"A2485",m:"MacBook Pro 16-inch 'M1 Pro/Max' A2485 (2021)"},{n:"A2141",m:"MacBook Pro 16-inch A2141 (2019)"},
    {n:"A1990",m:"MacBook Pro 15-inch A1990 (2018-2019)"},{n:"A1707",m:"MacBook Pro 15-inch A1707 (2016-2017)"},
    {n:"A3401",m:"MacBook Pro 14-inch 'M4 Pro/Max' A3112/A3185/A3401 (2024)"},{n:"A3112",m:"MacBook Pro 14-inch 'M4 Pro/Max' A3112/A3185/A3401 (2024)"},{n:"A3185",m:"MacBook Pro 14-inch 'M4 Pro/Max' A3112/A3185/A3401 (2024)"},
    {n:"A2918",m:"MacBook Pro 14-inch 'M3 Pro/Max' A2918/A2992 (2023)"},{n:"A2992",m:"MacBook Pro 14-inch 'M3 Pro/Max' A2918/A2992 (2023)"},
    {n:"A2779",m:"MacBook Pro 14-inch 'M2 Pro/Max' A2779 (2023)"},{n:"A2442",m:"MacBook Pro 14-inch 'M1 Pro/Max' A2442 (2021)"},
    {n:"A2338",m:"MacBook Pro 13-inch 'M2' A2338 (2022)"},{n:"A2338",m:"MacBook Pro 13-inch 'M1' A2338 (2020)"},{n:"A2251",m:"MacBook Pro 13-inch A2251 (2020)"},
    {n:"A2289",m:"MacBook Pro 13-inch A2289 (2020)"},{n:"A2159",m:"MacBook Pro 13-inch A2159 (2019)"},
    {n:"A1989",m:"MacBook Pro 13-inch A1989 (2018-2019)"},{n:"A3241",m:"MacBook Air 15-inch 'M4' A3241 (2025)"},
    {n:"A3114",m:"MacBook Air 15-inch 'M3' A3114 (2024)"},{n:"A2941",m:"MacBook Air 15-inch 'M2' A2941 (2023)"},
    {n:"A3240",m:"MacBook Air 13-inch 'M4' A3240 (2025)"},{n:"A3113",m:"MacBook Air 13-inch 'M3' A3113 (2024)"},
    {n:"A2681",m:"MacBook Air 13-inch 'M2' A2681 (2022)"},{n:"A2337",m:"MacBook Air 13-inch 'M1' A2337 (2020)"},
    {n:"A2179",m:"MacBook Air 13-inch A2179 (2020)"},{n:"A1932",m:"MacBook Air 13-inch A1932 (2018-2019)"}
  ];

  /* =============================================
     FETCH + DATA FUNCTIONS
     ============================================= */
  function deriveRepairTypeFromHandle(handle) {
    var keys = Object.keys(HANDLE_SUFFIX_MAP);
    keys.sort(function(a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) { if (handle.endsWith(keys[i])) return HANDLE_SUFFIX_MAP[keys[i]]; }
    return null;
  }

  async function fetchCollection(handle) {
    if (_collectionCache[handle]) return _collectionCache[handle];
    try {
      var res = await fetch('/collections/' + handle + '/products.json?limit=250');
      if (!res.ok) {
        trackWizardEventOnce('collection-fetch:' + handle + ':' + res.status, 'wizard_collection_fetch_failed', {
          collectionHandle: handle,
          status: res.status,
          failureType: 'http'
        });
        return [];
      }
      var data = await res.json();
      _collectionCache[handle] = data.products;
      return data.products;
    } catch(e) {
      trackWizardEventOnce('collection-fetch:' + handle + ':network', 'wizard_collection_fetch_failed', {
        collectionHandle: handle,
        failureType: 'network',
        errorMessage: e && e.message ? e.message : null
      });
      return [];
    }
  }

  function buildRepairsMap(products) {
    var map = {};
    for (var i = 0; i < products.length; i++) {
      var rt = deriveRepairTypeFromHandle(products[i].handle);
      if (rt) map[rt] = products[i];
    }
    return map;
  }

  function getProductsForRepairType(repairType) {
    return (_collectionProducts || []).filter(function(product) {
      return deriveRepairTypeFromHandle(product.handle) === repairType;
    });
  }

  function pickProductByHandlePreference(products, patterns) {
    for (var i = 0; i < patterns.length; i++) {
      for (var j = 0; j < products.length; j++) {
        if (products[j].handle.indexOf(patterns[i]) !== -1) return products[j];
      }
    }
    return products[0] || null;
  }

  function resolveRepairProduct(repairType, issueLabel) {
    /* Prefer catalogue map entry (#53) — no HTML scrape for price/variant. */
    if (_repairsMap && _repairsMap[repairType]) {
      var mapped = _repairsMap[repairType];
      /* Product-page prefill: lock to the exact variant when known */
      if (S.preVariantId && mapped && mapped.variants && mapped.variants.length) {
        var locked = null;
        for (var vi = 0; vi < mapped.variants.length; vi++) {
          if (String(mapped.variants[vi].id) === String(S.preVariantId)) { locked = mapped.variants[vi]; break; }
        }
        if (locked) {
          return Object.assign({}, mapped, { variants: [locked] });
        }
      }
      return mapped;
    }
    var products = getProductsForRepairType(repairType);
    if (!products.length) return null;
    if (products.length === 1) return products[0];

    var issue = (issueLabel || '').toLowerCase();

    if (repairType === 'rear-glass') {
      return pickProductByHandlePreference(products, [
        'rear-glass-repair',
        'housing-rear-glass-repair',
        'housing-repair'
      ]);
    }

    if (repairType === 'screen') {
      if (issue.indexOf('black screen') !== -1 || issue.indexOf('no display') !== -1 || issue.indexOf('no screen') !== -1) {
        return pickProductByHandlePreference(products, [
          'original-lcd-screen-no-screen-message-repair',
          'display-screen-repair',
          'screen-repair',
          'original-screen-repair'
        ]);
      }
      return pickProductByHandlePreference(products, [
        'original-screen-repair',
        'display-screen-repair',
        'screen-repair',
        'original-lcd-screen-no-screen-message-repair'
      ]);
    }

    return products[0];
  }

  async function fetchProduct(handle) {
    if (_productCache[handle]) return _productCache[handle];
    try {
      var res = await fetch('/products/' + handle + '.json');
      if (!res.ok) throw new Error('http:' + res.status);
      var data = await res.json();
      _productCache[handle] = data.product;
      return data.product;
    } catch(e) {
      await new Promise(function(r) { setTimeout(r, 1000); });
      try {
        var res2 = await fetch('/products/' + handle + '.json');
        if (!res2.ok) {
          trackWizardEventOnce('product-fetch:' + handle + ':' + res2.status, 'wizard_product_fetch_failed', {
            productHandle: handle,
            status: res2.status,
            failureType: 'http'
          });
          return null;
        }
        var data2 = await res2.json();
        _productCache[handle] = data2.product;
        return data2.product;
      } catch(e2) {
        trackWizardEventOnce('product-fetch:' + handle + ':network', 'wizard_product_fetch_failed', {
          productHandle: handle,
          failureType: 'network',
          errorMessage: e2 && e2.message ? e2.message : (e && e.message ? e.message : null)
        });
        return null;
      }
    }
  }

  /* =============================================
     FAULT/ISSUE FILTERING
     ============================================= */
  function getAvailableFaults(device, repairsMap) {
    var available = {};
    var allowed = {};
    var list = FAULTS[device] || [];
    for (var i = 0; i < list.length; i++) allowed[list[i].v] = true;
    for (var rt in repairsMap) {
      var fault = REPAIR_TYPE_TO_FAULT[rt];
      if (!fault || fault === '_diagnostic') continue;
      if (allowed[fault]) {
        available[fault] = true;
      }
    }
    available['Water Damage'] = true;
    available['Data Recovery'] = true;
    available['Other'] = true;
    if (device === 'iphone') available['Connectivity'] = true;
    return list.filter(function(f) { return available[f.v]; });
  }

  /* Card, heading, and breadcrumb text. S.fault stays the internal key (v). */
  function faultDisplayLabel(device, fault) {
    var list = FAULTS[device] || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].v === fault) return list[i].label;
    }
    return fault || '';
  }

  function modelHasFaceId(model) {
    var name = String(model || '');
    if (/iPhone\s*SE\b/i.test(name)) return false;
    if (/\biPhone\s*8(\s*Plus)?\b/i.test(name)) return false;
    return true;
  }

  function modelHasIpadHomeButton(model) {
    var name = String(model || '');
    if (/iPad\s+Air\s+3/i.test(name)) return true;
    if (/iPad\s+Mini\s+5/i.test(name)) return true;
    if (/iPad\s+(5|6|7|8|9)th\s+Gen/i.test(name) && !/Air|Mini|Pro/i.test(name)) return true;
    return false;
  }

  function modelHasBloodOxygen(model) {
    var name = String(model || '');
    if (/Apple Watch SE\b/i.test(name)) return false;
    if (/Series\s*(2|3|4|5)\b/i.test(name)) return false;
    if (/Ultra/i.test(name)) return true;
    if (/Series\s*(6|7|8|9|10)\b/i.test(name)) return true;
    return false;
  }

  function modelHasTrueTone(model) {
    var name = String(model || '');
    if (/\bA1466\b/i.test(name)) return false;
    if (/\bA1706\b/i.test(name)) return false;
    if (/\bA1707\b/i.test(name)) return false;
    if (/\bA1708\b/i.test(name)) return false;
    return true;
  }

  function modelIsEsimOnly(model) {
    return /iPhone\s*Air\b/i.test(String(model || ''));
  }

  /* Flexgate: 13-inch A1706 and A1708, and 15-inch A1707. */
  function modelIsFlexgateModel(model) {
    var name = String(model || '');
    return /\bA1706\b/.test(name) || /\bA1707\b/.test(name) || /\bA1708\b/.test(name);
  }

  /* A real 15-inch marker only. A2159 contains the digits 15 and is a 13-inch. */
  function modelIs15InchMacBookPro(model) {
    var name = String(model || '');
    return /MacBook Pro/i.test(name) && /15\s*(?:["”″']|-?inch)/i.test(name);
  }

  /* Nano-texture glass was an option on iPad Pro M4, and on M5 when that model is listed. */
  function modelHasNanoTexture(model) {
    var name = String(model || '');
    return /iPad Pro/i.test(name) && /\bM[45]\b/.test(name);
  }

  function modelHasLcdScreen(model) {
    var name = String(model || '');
    if (/iPhone\s*SE\b/i.test(name)) return true;
    if (/iPhone\s*XR\b/i.test(name)) return true;
    if (/\biPhone\s*8(\s*Plus)?\b/i.test(name)) return true;
    if (/iPhone\s*11(?!\s*Pro)\b/i.test(name)) return true;
    return false;
  }

  function getAvailableIssues(device, fault, repairsMap) {
    var issues = TS[device] && TS[device][fault];
    if (!issues) return [];
    var faceId = modelHasFaceId(S.model);
    var lcd = modelHasLcdScreen(S.model);
    var esimOnly = modelIsEsimOnly(S.model);
    var trueTone = modelHasTrueTone(S.model);
    var bloodOxygen = modelHasBloodOxygen(S.model);
    var ipadHome = modelHasIpadHomeButton(S.model);
    var flexgateModel = modelIsFlexgateModel(S.model);
    return issues.filter(function(iss) {
      if (iss.flexgateModelsOnly && !flexgateModel) return false;
      if (iss.notFlexgateModels && flexgateModel) return false;
      if (iss.faceIdOnly && !faceId) return false;
      if (iss.noFaceIdOnly && faceId) return false;
      if (iss.lcdOnly && !lcd) return false;
      if (iss.oledOnly && lcd) return false;
      if (iss.esimOnly && !esimOnly) return false;
      if (iss.simTrayOnly && esimOnly) return false;
      if (iss.trueToneOnly && !trueTone) return false;
      if (iss.noTrueTone && trueTone) return false;
      if (iss.bloodOxygenOnly && !bloodOxygen) return false;
      if (iss.noBloodOxygen && bloodOxygen) return false;
      if (iss.ipadHomeButton && !ipadHome) return false;
      if (iss.ipadNoHomeButton && ipadHome) return false;
      if (iss.onlyWhenMissing && repairsMap[iss.onlyWhenMissing]) return false;
      if (iss.route === 'contact' || iss.route === 'dismiss') return true;
      if (iss.route === 'diagnostic') return !!repairsMap['diagnostic'];
      return !!repairsMap[iss.repairType];
    });
  }

  /* =============================================
     BADGE ICONS
     ============================================= */
  var BADGE_ICONS = {
    warranty:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>',
    turnaround:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',
    express:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
    parts:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>',
    service:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>',
    diagnostic:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>'
  };
  var BADGE_LABELS = { warranty:'Warranty', turnaround:'Turnaround', express:'Express', parts:'Parts', service:'Service', diagnostic:'Diagnostic' };

  function svcBadge(k, v) {
    return '<div class="qw-svc-r"><div class="qw-svc-i">' + (BADGE_ICONS[k]||'') + '</div><span class="qw-svc-l">' + (BADGE_LABELS[k]||k) + '</span><span class="qw-svc-v">' + v + '</span></div>';
  }

  /* Parts claim for trust badges:
     MacBook Silicon (M1+) / iPhone 12+ → "Original parts"
     MacBook Intel / iPhone 11 and older → "Original specification" */
  function isAppleSiliconModel(model) {
    return /(?:^|[^A-Za-z])M\d/i.test(String(model || ''));
  }

  function iphoneGenerationNumber(model) {
    var name = String(model || '');
    if (/iPhone\s*SE/i.test(name)) return 0;
    var gen = name.match(/iPhone\s*(\d{1,2})/i);
    if (gen) return parseInt(gen[1], 10) || 0;
    if (/iPhone\s*X/i.test(name)) return 10;
    return 0;
  }

  function partsClaimLabel(device, model) {
    if (device === 'macbook') {
      return isAppleSiliconModel(model) ? 'Original parts' : 'Original specification';
    }
    if (device === 'iphone') {
      return iphoneGenerationNumber(model) >= 12 ? 'Original parts' : 'Original specification';
    }
    /* Safer default for iPad / Watch until we have a model rule. */
    return 'Original specification';
  }

  /* [2.2] Device-specific badge builders */
  function buildRepairBadges(device, model) {
    var h = svcBadge('warranty', CFG.warrantyLabel || '2-year warranty');
    /* Same source as journey ETA + trust card (#53). */
    h += svcBadge('turnaround', turnaroundClaimLabel(device, { model: model }));
    h += svcBadge('parts', partsClaimLabel(device, model));
    return h;
  }

  function buildDiagnosticBadges(device) {
    return svcBadge('turnaround', CFG.diagnosticTurnaround || 'Quote in 1 working day') +
      svcBadge('diagnostic', 'Full report and quote sent via email');
  }

  /* Repair type + model for the turnaround clock. iPhone front camera /
     Face ID = 5-7 working days (Face ID module ordered from Apple). */
  var APPLE_FACE_ID_NOTE = 'The Face ID module needs to be ordered directly from Apple.';

  function repairClockOpts(opts) {
    opts = opts || {};
    var o = {
      diagnostic: !!(opts.diagnostic || S.route === 'diagnostic'),
      repairType: opts.repairType !== undefined ? opts.repairType : S.repairType,
      model: opts.model !== undefined ? opts.model : S.model
    };
    if (opts.repairTypes) o.repairTypes = opts.repairTypes;
    return o;
  }

  function needsAppleFaceIdModule(device, opts) {
    var o = repairClockOpts(opts);
    if (window.ICorrectRepairJourney && window.ICorrectRepairJourney.needsAppleFaceIdModule) {
      return window.ICorrectRepairJourney.needsAppleFaceIdModule(device, o);
    }
    if (o.diagnostic || device !== 'iphone' || (o.model && !modelHasFaceId(o.model))) return false;
    var types = [o.repairType].concat(o.repairTypes || []);
    for (var i = 0; i < types.length; i++) {
      var t = String(types[i] || '').toLowerCase();
      if (t === 'front-camera' || t === 'face-id') return true;
    }
    return false;
  }

  /* Client line explaining a longer clock, or ''. */
  function turnaroundNote(device, opts) {
    return needsAppleFaceIdModule(device, opts) ? APPLE_FACE_ID_NOTE : '';
  }

  /* Device bench days → label shared by journey ETA + repair badges. */
  function turnaroundClaimLabel(device, opts) {
    var o = repairClockOpts(opts);
    if (window.ICorrectRepairJourney) {
      return window.ICorrectRepairJourney.turnaroundClaimLabel(device, o);
    }
    if (o.diagnostic) {
      return CFG.diagnosticTurnaround || 'Quote in 1 working day';
    }
    if (needsAppleFaceIdModule(device, o)) return '5-7 working days';
    var days = repairBenchDays(device, o);
    if (days === 1) return '1 working day';
    return days + ' working days';
  }

  /* TrustCard 2×2 cross (reviews · parts · turnaround · warranty) + boxed price.
     Turnaround uses the same repairBenchDays source as the journey ETA. */
  function buildPriceTrustBlock(device, model, opts) {
    opts = opts || {};
    var parts = partsClaimLabel(device, model);
    var turnaround = turnaroundClaimLabel(device, { diagnostic: opts.diagnostic, model: model });
    var starSvg = '<svg width="12" height="12" viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1l1.8 3.8 4.2.6-3 2.9.7 4.1L7 10.5 3.3 12.4l.7-4.1-3-2.9 4.2-.6z" fill="currentColor"/></svg>';
    var stars = starSvg + starSvg + starSvg + starSvg + starSvg;
    var monitorSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8M12 16v4"/></svg>';
    var clockSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
    var shieldSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3l8 3v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3z"/><path d="M9 12l2 2 4-4"/></svg>';
    var gateCopy = opts.gateCopy || 'Enter your postcode above';
    var priceInner = opts.gate
      ? '<div class="qw-price-gate qw-price-gate--inline" id="qwPriceGate">' + esc(gateCopy) + '</div>' +
        '<div class="qw-price-big-wrap" id="qwPriceBigWrap" hidden>' +
          '<div class="qw-price-from">All-in total</div>' +
          '<div class="qw-price-big" id="qwPriceBig">' + (opts.priceHtml || '') + '</div>' +
        '</div>'
      : '<div class="qw-price-from">All-in total</div>' +
        '<div class="qw-price-big" id="qwPriceBig">' + (opts.priceHtml || '') + '</div>';
    return '<div class="qw-price-trust" id="qwPriceTrust">' +
      '<ul class="qw-trust-cross" role="list" aria-label="Trust signals">' +
        '<li class="qw-trust-cell qw-trust-reviews" aria-label="4.9 out of 5 from 719 Google reviews">' +
          '<span class="qw-trust-score">4.9</span>' +
          '<span class="qw-trust-reviews-meta">' +
            '<span class="qw-trust-stars" aria-hidden="true">' + stars + '</span>' +
            '<span class="qw-trust-sub">719 Google reviews</span>' +
          '</span>' +
        '</li>' +
        '<li class="qw-trust-cell qw-trust-parts">' +
          '<span class="qw-trust-ico" aria-hidden="true">' + monitorSvg + '</span>' +
          '<span class="qw-trust-copy">' +
            '<span class="qw-trust-title">' + esc(parts) + '</span>' +
            '<span class="qw-trust-sub">Calibrated in-house</span>' +
          '</span>' +
        '</li>' +
        '<li class="qw-trust-cell qw-trust-turnaround" aria-label="Turnaround: ' + esc(turnaround) + '">' +
          '<span class="qw-trust-ico" aria-hidden="true">' + clockSvg + '</span>' +
          '<span class="qw-trust-copy">' +
            '<span class="qw-trust-title">' + esc(turnaround) + '</span>' +
            '<span class="qw-trust-sub">' + (opts.diagnostic ? 'Diagnosis emailed to you' : (needsAppleFaceIdModule(device, { model: model }) ? 'Face ID module from Apple' : 'Typical repair time')) + '</span>' +
          '</span>' +
        '</li>' +
        '<li class="qw-trust-cell qw-trust-warranty" aria-label="2-year warranty">' +
          '<span class="qw-trust-ico" aria-hidden="true">' + shieldSvg + '</span>' +
          '<span class="qw-trust-copy">' +
            '<span class="qw-trust-title">2-yr warranty</span>' +
            '<span class="qw-trust-sub">Double the standard</span>' +
          '</span>' +
        '</li>' +
      '</ul>' +
      '<div class="qw-price-trust-price">' + priceInner + '</div>' +
    '</div>';
  }


  /* =============================================
     SERVICE STEP — courier OR mail-in only (#53)
     Postcode gates price; valid postcode auto-reveals band + slots.
     Walk-in / drop-off removed (Ricky 2026-09-11).
     ============================================= */
  var _courierQuote = null;
  var _postcodeResolved = false;
  var _quoteShownCaptured = false;
  var _collectionSlot = { date: null, part: null };
  var _collectionSlotDates = [];
  var SLOT_STRIP_COUNT = 5;
  var SLOT_CALENDAR_COUNT = 28;

  /* ---------- Service journey / estimated return (Ricky 2026-09-14) ---------- */
  var PACK_CUTOFF_HOUR = (window.ICorrectRepairJourney && window.ICorrectRepairJourney.PACK_CUTOFF_HOUR) || 15;

  /* Dates use the upper bound (7 for iPhone front camera / Face ID). */
  function repairBenchDays(device, opts) {
    var o = repairClockOpts(opts);
    if (window.ICorrectRepairJourney) return window.ICorrectRepairJourney.repairBenchDays(device, o);
    if (o.diagnostic) return 1;
    if (needsAppleFaceIdModule(device, o)) return 7;
    if (device === 'iphone') return 1;
    if (device === 'watch') return 3;
    return 2;
  }

  function parseISODate(iso) {
    if (!iso) return null;
    var p = String(iso).split('-');
    if (p.length !== 3) return null;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    return isNaN(d.getTime()) ? null : d;
  }

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function isWorkingDay(d) {
    var day = d.getDay();
    return day !== 0 && day !== 6;
  }

  function addWorkingDays(fromDate, n) {
    var d = startOfDay(fromDate);
    var left = n;
    if (left <= 0) return d;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (isWorkingDay(d)) left--;
    }
    return d;
  }

  function nextWorkingDayOnOrAfter(fromDate) {
    var d = startOfDay(fromDate);
    while (!isWorkingDay(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function formatJourneyDate(d) {
    if (!d) return '—';
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
  }

  /* Calendar day of the date rendered in the journey ETA. Same Date object as the visible label. */
  function isoJourneyDate(d) {
    if (!d || isNaN(d.getTime())) return '';
    var month = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
  }

  function journeyEtaDateHtml(d) {
    return '<span class="qw-journey-eta-date" data-iso="' + esc(isoJourneyDate(d)) + '">' + esc(formatJourneyDate(d)) + '</span>';
  }

  function londonWall(now) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(now || new Date());
    var get = function (type) {
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === type) return parts[i].value;
      }
      return '0';
    };
    return {
      date: new Date(parseInt(get('year'), 10), parseInt(get('month'), 10) - 1, parseInt(get('day'), 10)),
      hour: parseInt(get('hour'), 10) + parseInt(get('minute'), 10) / 60
    };
  }

  function packShipDate(now) {
    var lib = window.ICorrectRepairJourney;
    if (lib && typeof lib.packShipDate === 'function') return lib.packShipDate(now);
    var wall = londonWall(now);
    var d = startOfDay(wall.date);
    if (!isWorkingDay(d) || wall.hour >= PACK_CUTOFF_HOUR) {
      return addWorkingDays(d, 1);
    }
    return d;
  }

  function journeyStepHtml(num, title, meta) {
    return '<div class="qw-journey-step">' +
      '<div class="qw-journey-num" aria-hidden="true">' + num + '</div>' +
      '<div class="qw-journey-copy">' +
        '<div class="qw-journey-title">' + esc(title) + '</div>' +
        (meta ? '<div class="qw-journey-meta">' + esc(meta) + '</div>' : '') +
      '</div></div>';
  }

  function buildCourierJourneyModel() {
    var diagnostic = S.route === 'diagnostic';
    var collect = _collectionSlot.date && _collectionSlot.date.iso
      ? parseISODate(_collectionSlot.date.iso)
      : null;
    var lib = window.ICorrectRepairJourney;
    var model = diagnostic
      ? (lib ? lib.courierDiagnosticJourney(collect) : null)
      : (lib ? lib.courierRepairJourney(S.device, collect, repairClockOpts({ diagnostic: false })) : null);
    if (model) return formatJourneyModel(model);
    if (diagnostic) {
      return {
        kind: 'diagnostic',
        steps: [
          { title: 'We collect', meta: collect ? formatJourneyDate(collect) : 'Pick a collection window' },
          { title: 'We diagnose & email your quote', meta: collect ? formatJourneyDate(addWorkingDays(collect, 1)) : '1 working day after collection' },
          { title: 'You decide next', meta: 'Device stays with us until you approve' }
        ],
        returnDate: null,
        quoteDate: collect ? addWorkingDays(collect, 1) : null
      };
    }
    var bench = repairBenchDays(S.device);
    if (!collect) {
      return {
        kind: 'repair',
        steps: [
          { title: 'We collect', meta: 'Pick a collection window' },
          { title: 'We repair', meta: turnaroundClaimLabel(S.device) },
          { title: 'Back to you', meta: 'After repair' }
        ],
        returnDate: null,
        quoteDate: null
      };
    }
    var returnDate = addWorkingDays(collect, bench);
    return {
      kind: 'repair',
      steps: [
        { title: 'We collect', meta: formatJourneyDate(collect) },
        { title: 'We repair', meta: turnaroundClaimLabel(S.device) },
        { title: 'Back to you', meta: formatJourneyDate(returnDate) }
      ],
      returnDate: returnDate,
      quoteDate: null,
      note: turnaroundNote(S.device)
    };
  }

  function formatJourneyModel(model) {
    function fmt(v) {
      if (!v) return v;
      if (v instanceof Date) return formatJourneyDate(v);
      return v;
    }
    return {
      kind: model.kind,
      steps: (model.steps || []).map(function(s) {
        return { title: s.title, meta: fmt(s.meta) };
      }),
      returnDate: model.returnDate || null,
      quoteDate: model.quoteDate || null,
      note: model.note || ''
    };
  }

  function buildMailinJourneyModel() {
    var diagnostic = S.route === 'diagnostic';
    var lib = window.ICorrectRepairJourney;
    var model = diagnostic
      ? (lib ? lib.mailinDiagnosticJourney(new Date()) : null)
      : (lib ? lib.mailinRepairJourney(S.device, new Date(), repairClockOpts({ diagnostic: false })) : null);
    if (model) return formatJourneyModel(model);
    var bench = repairBenchDays(S.device, { diagnostic: diagnostic });
    var ship = packShipDate(new Date());
    var weReceive = addWorkingDays(ship, 1);
    var youPostBy = weReceive;
    if (diagnostic) {
      var quoteDate = addWorkingDays(weReceive, 1);
      return {
        kind: 'diagnostic',
        steps: [
          { title: 'We send packaging', meta: formatJourneyDate(ship) },
          { title: 'You post the device', meta: formatJourneyDate(youPostBy) },
          { title: 'We diagnose & email your quote', meta: formatJourneyDate(quoteDate) },
          { title: 'You decide next', meta: 'Device stays with us until you approve' }
        ],
        returnDate: null,
        quoteDate: quoteDate
      };
    }
    var repairDone = addWorkingDays(weReceive, bench);
    var returnDate = addWorkingDays(repairDone, 1);
    return {
      kind: 'repair',
      steps: [
        { title: 'We send packaging', meta: formatJourneyDate(ship) },
        { title: 'You post the device', meta: formatJourneyDate(youPostBy) },
        { title: 'We repair', meta: turnaroundClaimLabel(S.device) },
        { title: 'Back to you', meta: formatJourneyDate(returnDate) }
      ],
      returnDate: returnDate,
      quoteDate: null,
      note: turnaroundNote(S.device)
    };
  }

  function renderServiceJourney(kind) {
    var host = document.getElementById('qwJourney');
    if (!host) return;
    var model = kind === 'mailin' ? buildMailinJourneyModel() : buildCourierJourneyModel();
    var stepsHtml = model.steps.map(function(s, i) {
      return journeyStepHtml(i + 1, s.title, s.meta);
    }).join('');
    var quoteDate = model.quoteDate;
    var diagnostic = model.kind === 'diagnostic' || S.route === 'diagnostic';
    var eta;
    if (diagnostic && quoteDate) {
      eta = '<div class="qw-journey-eta">' +
          '<span class="qw-journey-eta-label">We\'ll tell you what\'s wrong by</span>' +
          journeyEtaDateHtml(quoteDate) +
          '<span class="qw-journey-eta-note">Device stays with us until you approve a repair</span>' +
        '</div>';
    } else if (diagnostic) {
      eta = '<div class="qw-journey-eta qw-journey-eta--pending"><span class="qw-journey-eta-note">Select a collection window to see when we diagnose and email your quote</span></div>';
    } else if (model.returnDate) {
      eta = '<div class="qw-journey-eta">' +
          '<span class="qw-journey-eta-label">Estimated return by</span>' +
          journeyEtaDateHtml(model.returnDate) +
          '<span class="qw-journey-eta-note">' + esc(model.note || 'Often sooner') + '</span>' +
        '</div>';
    } else {
      eta = '<div class="qw-journey-eta qw-journey-eta--pending"><span class="qw-journey-eta-note">Select a collection window to see your return estimate</span></div>';
    }
    host.innerHTML =
      '<div class="qw-journey" data-kind="' + esc(kind) + '">' +
        '<div class="qw-journey-steps">' + stepsHtml + '</div>' +
        eta +
      '</div>';
    host.hidden = false;
  }

  function hideServiceJourney() {
    var host = document.getElementById('qwJourney');
    if (host) { host.hidden = true; host.innerHTML = ''; }
  }

  function refreshServiceJourney() {
    if (!_postcodeResolved) { hideServiceJourney(); return; }
    var kind = selectedServiceKind();
    if (kind === 'courier' && _courierQuote && _courierQuote.courierAvailable === false) {
      kind = 'mailin';
    }
    renderServiceJourney(kind === 'mailin' ? 'mailin' : 'courier');
  }

  function collectionWindowCopy(band) {
    if (band === 'B1' || band === 'B2') {
      return { headline: 'Central London', detail: 'Choose a collection window below.' };
    }
    if (band === 'B3' || band === 'B4') {
      return { headline: 'Greater London', detail: 'Choose a collection window below.' };
    }
    return { headline: 'Collection', detail: 'Choose a collection window below.' };
  }

  function ensureCourierAssets() {
    var jobs = [];
    if (!window.__QW_BANDS && CFG.bandsUrl) {
      jobs.push(fetch(CFG.bandsUrl).then(function(r){ return r.json(); }).then(function(j){ window.__QW_BANDS = j; }));
    }
    if (!window.__QW_CATALOGUE && CFG.catalogueUrl) {
      jobs.push(fetch(CFG.catalogueUrl).then(function(r){ return r.json(); }).then(function(j){ window.__QW_CATALOGUE = j; }));
    }
    if (!window.__QW_SERVICE_ADJUSTMENTS && CFG.serviceAdjustmentsUrl) {
      jobs.push(fetch(CFG.serviceAdjustmentsUrl).then(function(r){ return r.json(); }).then(function(j){
        window.__QW_SERVICE_ADJUSTMENTS = j;
        if (j && !j.prices && CFG.serviceAdjustmentPrices) j.prices = CFG.serviceAdjustmentPrices;
        if (j && j.variants) CFG.serviceAdjustments = Object.assign({}, CFG.serviceAdjustments || {}, j.variants);
        return fetch('/products/service-adjustment.js', { headers: { 'Accept': 'application/json' } })
          .then(function(res){ return res.ok ? res.json() : null; })
          .then(function(product){
            if (product && window.ICorrectCourier && typeof window.ICorrectCourier.applyShelfPrices === 'function') {
              window.ICorrectCourier.applyShelfPrices(window.__QW_SERVICE_ADJUSTMENTS, product);
            }
          })
          .catch(function(){ /* seeded prices remain */ });
      }).catch(function(){ /* inline CFG IDs remain */ }));
    }
    if (!window.__QW_COLLECTION_PREFILL && CFG.collectionPrefillUrl) {
      jobs.push(fetch(CFG.collectionPrefillUrl).then(function(r){ return r.json(); }).then(function(j){ window.__QW_COLLECTION_PREFILL = j; }));
    }
    return Promise.all(jobs);
  }

  function currentRepairTags() {
    var card = document.getElementById('qwResCard');
    if (card && card.dataset.tags) {
      try { return JSON.parse(card.dataset.tags); } catch (e) {}
    }
    if (S.repairType && _repairsMap[S.repairType] && _repairsMap[S.repairType].tags) {
      var t = _repairsMap[S.repairType].tags;
      return Array.isArray(t) ? t : String(t).split(',').map(function(x){ return x.trim(); });
    }
    return [];
  }

  function currentRepairPrice() {
    var card = document.getElementById('qwResCard');
    if (card && card.dataset.base) {
      var n = parseFloat(card.dataset.base);
      if (!isNaN(n)) return n;
    }
    return 0;
  }

  /* Full UK postcode only (outward + inward, space optional). Partial input
     such as "W1W 8J" must not show a courier or mail-in result or fire events. */
  function isFullPostcodeValue(value) {
    var lib = window.ICorrectCourier;
    if (lib && typeof lib.isFullPostcode === 'function') return lib.isFullPostcode(value);
    var compact = String(value || '').toUpperCase().replace(/\s+/g, '');
    return /^(?:[A-Z]{1,2}[0-9]{1,2}|[A-Z]{1,2}[0-9][A-Z])[0-9][A-Z]{2}$/.test(compact);
  }

  function currentPostcodeValue() {
    var el = document.getElementById('qwPostcode');
    return el ? String(el.value || '').trim() : '';
  }

  function selectedServiceKind() {
    var card = document.querySelector('.qw-opt-card.sel[data-opt="svc"]');
    return card ? (card.getAttribute('data-svc') || 'courier') : 'courier';
  }

  /* Quote-events beacon (#53) — outward half only, never a full postcode. */
  function outwardHalfOnly(value) {
    if (value == null || value === '') return null;
    var compact = String(value).toUpperCase().replace(/\s+/g, '');
    if (!compact) return null;
    if (compact.length >= 5 && /\d[A-Z]{2}$/.test(compact)) {
      return compact.slice(0, -3);
    }
    return compact;
  }

  function quoteNumber(n) {
    if (typeof n === 'number' && isFinite(n)) return n;
    var parsed = parseFloat(n);
    return isFinite(parsed) ? parsed : null;
  }

  function syncIcorrectQuote() {
    try {
      var q = window.__icorrectQuote || {};
      q.device = S.device || null;
      q.model = S.model || null;
      q.fault = S.fault || null;
      q.issue = S.issue || null;
      var quotedCard = document.getElementById('qwResCard');
      q.repair = (quotedCard && quotedCard.dataset.repair) || null;
      q.repair_handle = (quotedCard && quotedCard.dataset.repairHandle) || null;
      q.repair_type = (quotedCard && quotedCard.dataset.repairType) || S.repairType || null;
      q.route = (quotedCard && quotedCard.dataset.route) || S.route || null;

      var outward = (_courierQuote && _courierQuote.outward) || null;
      if (!outward) {
        var pcInput = document.getElementById('qwPostcode');
        var pc = pcInput ? String(pcInput.value || '').trim() : '';
        if (pc && window.ICorrectCourier && typeof window.ICorrectCourier.extractOutwardCode === 'function') {
          outward = window.ICorrectCourier.extractOutwardCode(pc);
        } else if (pc) {
          outward = pc;
        }
      }
      q.outward_code = outwardHalfOnly(outward);

      if (_courierQuote && _postcodeResolved) {
        q.band = _courierQuote.band || null;
        q.tier = _courierQuote.tier || null;
        q.repair_price = quoteNumber(_courierQuote.repair_price);
        if (q.repair_price == null) q.repair_price = quoteNumber(currentRepairPrice());
        q.adjustment = quoteNumber(_courierQuote.adjustment);
        q.total = quoteNumber(_courierQuote.total);
        var kind = selectedServiceKind();
        if (_courierQuote.forcedMailIn || _courierQuote.service === 'mail-in' || kind === 'mailin') {
          q.service_selected = 'mail-in';
        } else {
          q.service_selected = 'courier';
        }
        var resCard = document.getElementById('qwResCard');
        if (resCard) {
          var base = parseFloat(resCard.dataset.base || 0);
          var total = base;
          resCard.querySelectorAll('.qw-opt-card.sel').forEach(function(c) {
            if (c.getAttribute('data-opt') === 'svc') return;
            total += parseFloat(c.dataset.add || 0);
          });
          total += serviceCharge(_courierQuote);
          if (isFinite(base)) q.repair_price = base;
          if (isFinite(total)) q.total = total;
        }
      } else {
        q.band = null;
        q.tier = null;
        q.repair_price = null;
        q.adjustment = null;
        q.total = null;
        q.service_selected = null;
      }

      if (q.service_selected === 'courier' && _collectionSlot.date && _collectionSlot.date.iso) {
        q.collection_date = _collectionSlot.date.iso;
        var slotProps = window.ICorrectCourierSlots
          ? window.ICorrectCourierSlots.slotCartProperties(_collectionSlot.date, _collectionSlot.part)
          : null;
        q.collection_window = slotProps ? slotProps['Collection Window'] : null;
        if (!q.collection_window && _collectionSlot.part) {
          q.collection_window = _collectionSlot.part.windowLabel || _collectionSlot.part.label || null;
        }
      } else {
        q.collection_date = null;
        q.collection_window = null;
      }

      window.__icorrectQuote = q;
    } catch (e) {}
  }

  function maybeFireQuoteShown() {
    try {
      syncIcorrectQuote();
      if (_quoteShownCaptured || !_postcodeResolved) return;
      var q = window.__icorrectQuote || {};
      if (typeof q.total !== 'number' && typeof q.repair_price !== 'number') return;
      _quoteShownCaptured = true;
      if (window.icorrectQuoteEvents && typeof window.icorrectQuoteEvents.captureQuoteShown === 'function') {
        window.icorrectQuoteEvents.captureQuoteShown();
      }
    } catch (e) {}
  }

  function fireQuoteProceeded() {
    try {
      syncIcorrectQuote();
      if (window.icorrectQuoteEvents && typeof window.icorrectQuoteEvents.captureQuoteProceeded === 'function') {
        window.icorrectQuoteEvents.captureQuoteProceeded();
      }
    } catch (e) {}
  }

  function fireQuoteEmailRequested(contact) {
    try {
      syncIcorrectQuote();
      if (window.icorrectQuoteEvents && typeof window.icorrectQuoteEvents.captureQuoteEmailRequested === 'function') {
        window.icorrectQuoteEvents.captureQuoteEmailRequested(contact);
      }
    } catch (e) {}
  }

  function serviceVariantsAsset() {
    if (window.__QW_SERVICE_ADJUSTMENTS) {
      if (!window.__QW_SERVICE_ADJUSTMENTS.prices && CFG.serviceAdjustmentPrices) {
        window.__QW_SERVICE_ADJUSTMENTS.prices = CFG.serviceAdjustmentPrices;
      }
      return window.__QW_SERVICE_ADJUSTMENTS;
    }
    return {
      variants: CFG.serviceAdjustments || {},
      prices: CFG.serviceAdjustmentPrices || {}
    };
  }

  /* Pounds the basket adds. £0 Shopify variants stay off the wizard total. */
  function serviceCharge(quote) {
    if (!quote) return 0;
    if (typeof quote.charged === 'number' && isFinite(quote.charged)) return quote.charged;
    var n = Number(quote.adjustment);
    return isFinite(n) ? n : 0;
  }

  function quoteForService(serviceKind, postcode) {
    if (!window.ICorrectCourier || !window.__QW_BANDS) return null;
    var mapped = S.repairType && _repairsMap[S.repairType] ? _repairsMap[S.repairType] : null;
    return window.ICorrectCourier.quoteServiceAdjustment({
      postcode: postcode || '',
      productTags: currentRepairTags(),
      bands: window.__QW_BANDS,
      service: serviceKind === 'mailin' ? 'mail-in' : 'courier',
      repairPrice: currentRepairPrice(),
      variants: serviceVariantsAsset(),
      device: S.device,
      repairType: S.repairType,
      title: mapped && mapped.title ? mapped.title : '',
      handle: mapped && mapped.handle ? mapped.handle : ''
    });
  }

  /* Status chips only — never a fee line. Before postcode: prompt to enter one. */
  function formatServiceCardHint(quote, kind) {
    if (!_postcodeResolved || !quote) return '—';
    if (kind === 'mailin') {
      var mailQuote = quote.service === 'mail-in' ? quote : null;
      if (!mailQuote) {
        var pcInput = document.getElementById('qwPostcode');
        mailQuote = quoteForService('mailin', pcInput ? pcInput.value : '');
      }
      return serviceCharge(mailQuote || quote) > 0 ? 'Tracked pack' : 'Free pack';
    }
    if (!quote.courierAvailable && quote.forcedMailIn) return 'Not in area';
    if (quote.service === 'courier' && serviceCharge(quote) === 0) return 'Included';
    if (quote.service === 'courier') return 'Available';
    return '—';
  }

  /* Hide mail-in only when the basket charge for courier is £0 or lower
     than mail-in. Under £200 B1/B2 courier is still +£25, so both stay. */
  function shouldHideMailInOption(quote, postcode) {
    if (!quote || quote.courierAvailable === false) return false;
    var pc = postcode || '';
    var courierQ = quote.service === 'courier' && !quote.forcedMailIn
      ? quote
      : quoteForService('courier', pc);
    if (!courierQ || courierQ.courierAvailable === false || courierQ.forcedMailIn) return false;
    var courierAdj = serviceCharge(courierQ);
    /* Free courier (B1/B2 ≥£200, or a £0 variant): mail-in adds nothing. */
    if (courierAdj === 0) return true;
    var mailQuote = quoteForService('mailin', pc);
    if (!mailQuote) return false;
    var mailAdj = serviceCharge(mailQuote);
    if (!isFinite(mailAdj)) mailAdj = 0;
    return courierAdj < mailAdj;
  }

  function setMailInOptionVisible(show) {
    var mailCard = document.querySelector('.qw-opt-card[data-svc="mailin"]');
    var courierCard = document.querySelector('.qw-opt-card[data-svc="courier"]');
    var grid = document.getElementById('qwDeliveryGrid');
    var choice = document.getElementById('qwDeliveryChoice');
    var choiceLabel = document.getElementById('qwDeliveryChoiceLabel');
    if (mailCard) {
      mailCard.hidden = !show;
      mailCard.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) {
        mailCard.classList.remove('sel', 'active');
      }
    }
    if (grid) grid.classList.toggle('qw-delivery-grid-solo', !show);
    /* Solo free-courier on mobile: drop choice chrome so slots + journey + price fit.
       Only reached when shouldHideMailInOption is true (courier free/cheaper). */
    if (!show && isMobileQuoteLayout()) {
      if (choice) choice.hidden = true;
      if (courierCard) courierCard.hidden = true;
      return;
    }
    if (choice) choice.hidden = false;
    /* Mobile: keep unavailable courier fully removed (desktop stays greyed). */
    if (courierCard) {
      var courierUnavailable = courierCard.classList.contains('qw-opt-disabled');
      if (courierUnavailable && isMobileQuoteLayout()) {
        courierCard.hidden = true;
        courierCard.setAttribute('aria-hidden', 'true');
        if (grid) grid.classList.add('qw-delivery-grid-solo');
      } else {
        courierCard.hidden = false;
        courierCard.setAttribute('aria-hidden', 'false');
      }
    }
    if (choiceLabel) {
      var courierVisible = !!(courierCard && !courierCard.hidden);
      choiceLabel.hidden = !show || !courierVisible;
    }
  }

  function setPriceVisibility(show) {
    var gate = document.getElementById('qwPriceGate');
    var total = document.getElementById('qwPriceTotalWrap');
    var big = document.getElementById('qwPriceBigWrap');
    if (gate) gate.hidden = !!show;
    if (total) total.hidden = !show;
    if (big) big.hidden = !show;
    var bookBtn = document.getElementById('qwBookBtn');
    if (bookBtn) {
      bookBtn.disabled = !show;
      bookBtn.classList.toggle('qw-btn-prompt', !show);
    }
    if (show) {
      var totalEl = document.getElementById('qwPriceTotal');
      if (totalEl) setupStickyCTA(totalEl.textContent);
    } else {
      destroyStickyCTA();
    }
  }

  function refreshAllInTotal() {
    var resCard = document.getElementById('qwResCard');
    if (!resCard) return;
    if (!_postcodeResolved) {
      setPriceVisibility(false);
      syncIcorrectQuote();
      return;
    }
    var base = parseFloat(resCard.dataset.base || 0);
    var total = base;
    resCard.querySelectorAll('.qw-opt-card.sel').forEach(function(c) {
      if (c.getAttribute('data-opt') === 'svc') return;
      total += parseFloat(c.dataset.add || 0);
    });
    total += serviceCharge(_courierQuote);
    var totalEl = document.getElementById('qwPriceTotal');
    if (totalEl) totalEl.textContent = gbp.format(total);
    var bigEl = document.getElementById('qwPriceBig');
    if (bigEl) bigEl.textContent = gbp.format(total);
    setPriceVisibility(true);
    maybeFireQuoteShown();
  }

  function selectServiceCard(svc) {
    var grid = document.getElementById('qwDeliveryGrid');
    if (!grid) return;
    grid.querySelectorAll('.qw-opt-card[data-opt="svc"]').forEach(function(c) {
      var on = c.getAttribute('data-svc') === svc;
      c.classList.toggle('sel', on);
      c.classList.toggle('active', on);
    });
  }

  /* Price slot after collection/journey so one mobile screen can show slots + ETA + price. */
  var QW_PRICE_SLOT = '<!--QW_PRICE_SLOT-->';

  function injectServicePrice(serviceHtml, priceHtml) {
    var block = priceHtml
      ? ('<div class="qw-res-price" id="qwResPrice">' + priceHtml + '</div>')
      : '';
    return String(serviceHtml || '').split(QW_PRICE_SLOT).join(block);
  }

  function buildServiceCards() {
    return '<div class="qw-opt-section qw-service-mapper">' +
      '<div class="qw-section-label">Where should we collect from?</div>' +
      '<div class="qw-postcode-card" id="qwPostcodeCard">' +
        '<label class="qw-postcode-label" for="qwPostcode">Enter your postcode to see your all-in price' +
          '<span class="qw-postcode-hint">London postcodes unlock courier collection windows. Outside London we use tracked mail-in.</span>' +
        '</label>' +
        '<div class="qw-postcode-row">' +
          '<input type="text" id="qwPostcode" class="qw-postcode-input qw-courier-inp" placeholder="e.g. SW11 8BJ" autocomplete="postal-code" inputmode="text" enterkeyhint="done">' +
        '</div>' +
        '<span class="qw-postcode-wait" id="qwPostcodeWait" style="display:none">Enter your full postcode, for example W1W 8JQ.</span>' +
        '<div class="qw-courier-result" id="qwCourierResult" hidden></div>' +
      '</div>' +
      '<div class="qw-delivery-reveal" id="qwDeliveryReveal" hidden>' +
        '<div class="qw-delivery-choice" id="qwDeliveryChoice">' +
          '<div class="qw-section-label" id="qwDeliveryChoiceLabel">How do you want to get it to us?</div>' +
          '<div class="qw-delivery-grid qw-opt-row qw-svc-row" id="qwDeliveryGrid">' +
            '<button type="button" class="qw-delivery-card qw-opt-card sel active" data-opt="svc" data-svc="courier" data-add="0">' +
              '<span class="qw-delivery-radio" aria-hidden="true"><span></span></span>' +
              '<span class="qw-delivery-body">' +
                '<span class="qw-delivery-title qw-opt-name">Courier collection</span>' +
                '<span class="qw-delivery-sub qw-opt-meta">We collect from your door across London</span>' +
              '</span>' +
              '<span class="qw-delivery-price qw-opt-price" id="qwCourierPriceLbl">—</span>' +
            '</button>' +
            '<button type="button" class="qw-delivery-card qw-opt-card" data-opt="svc" data-svc="mailin" data-add="0">' +
              '<span class="qw-delivery-radio" aria-hidden="true"><span></span></span>' +
              '<span class="qw-delivery-body">' +
                '<span class="qw-delivery-title qw-opt-name">Post it — mail-in pack</span>' +
                '<span class="qw-delivery-sub qw-opt-meta">Tracked, insured pack within 24h</span>' +
              '</span>' +
              '<span class="qw-delivery-price qw-opt-price" id="qwMailinPriceLbl">—</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="qw-slot-panel" id="qwSlotPanel" hidden>' +
          '<div class="qw-section-label">Pick a collection window</div>' +
          '<div class="qw-date-row">' +
            '<div class="qw-date-strip" id="qwSlotDates" role="listbox" aria-label="Collection dates"></div>' +
            '<button type="button" class="qw-date-more" id="qwDateMore" aria-label="Open calendar for more dates" title="More dates">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="qw-window-strip" id="qwSlotParts" role="listbox" aria-label="Collection times"></div>' +
        '</div>' +
        '<div class="qw-cal-modal" id="qwCalModal" hidden>' +
          '<div class="qw-cal-backdrop" data-cal-close="1"></div>' +
          '<div class="qw-cal-sheet" role="dialog" aria-modal="true" aria-labelledby="qwCalTitle">' +
            '<div class="qw-cal-head">' +
              '<div class="qw-cal-title" id="qwCalTitle">Choose a date</div>' +
              '<button type="button" class="qw-cal-close" data-cal-close="1" aria-label="Close calendar">×</button>' +
            '</div>' +
            '<div class="qw-cal-grid" id="qwCalGrid"></div>' +
          '</div>' +
        '</div>' +
        '<div class="qw-mailin-panel" id="qwMailinPanel" hidden></div>' +
        '<div class="qw-journey-host" id="qwJourney" hidden></div>' +
      '</div>' +
      QW_PRICE_SLOT +
      '<div class="qw-courier-err" id="qwServiceErr"></div>' +
    '</div>';
  }

  function dateButtonHtml(d, active) {
    return '<button type="button" class="qw-date-btn' + (active ? ' active' : '') + '" data-iso="' + d.iso + '" role="option" aria-selected="' + (active ? 'true' : 'false') + '">' +
      '<span class="qw-date-dow">' + (d.headline || d.labelDow) + '</span>' +
      '<span class="qw-date-day">' + d.labelDay + '</span>' +
      '<span class="qw-date-mon">' + d.labelMon + '</span></button>';
  }

  function stripDatesAround(allDates, selectedIso, count) {
    if (!allDates || !allDates.length) return [];
    var n = Math.min(count || SLOT_STRIP_COUNT, allDates.length);
    var idx = 0;
    for (var i = 0; i < allDates.length; i++) {
      if (allDates[i].iso === selectedIso) { idx = i; break; }
    }
    var start = Math.max(0, Math.min(idx - Math.floor((n - 1) / 2), allDates.length - n));
    return allDates.slice(start, start + n);
  }

  function findSlotDate(iso) {
    for (var i = 0; i < _collectionSlotDates.length; i++) {
      if (_collectionSlotDates[i].iso === iso) return _collectionSlotDates[i];
    }
    return null;
  }

  function closeCollectionCalendar() {
    var modal = document.getElementById('qwCalModal');
    if (modal) modal.hidden = true;
  }

  function openCollectionCalendar() {
    var modal = document.getElementById('qwCalModal');
    var grid = document.getElementById('qwCalGrid');
    if (!modal || !grid || !_collectionSlotDates.length) return;
    var selectedIso = _collectionSlot.date && _collectionSlot.date.iso;
    grid.innerHTML = _collectionSlotDates.map(function(d) {
      var on = d.iso === selectedIso;
      return '<button type="button" class="qw-cal-day' + (on ? ' active' : '') + '" data-iso="' + d.iso + '">' +
        '<span class="qw-cal-dow">' + d.labelDow + '</span>' +
        '<span class="qw-cal-num">' + d.labelDay + '</span>' +
        '<span class="qw-cal-mon">' + d.labelMon + '</span></button>';
    }).join('');
    grid.querySelectorAll('.qw-cal-day').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectCollectionDate(btn.getAttribute('data-iso'));
        closeCollectionCalendar();
      });
    });
    modal.hidden = false;
  }

  function paintDateStrip() {
    var datesEl = document.getElementById('qwSlotDates');
    if (!datesEl || !_collectionSlotDates.length) return;
    var selectedIso = (_collectionSlot.date && _collectionSlot.date.iso) || _collectionSlotDates[0].iso;
    var strip = stripDatesAround(_collectionSlotDates, selectedIso, SLOT_STRIP_COUNT);
    datesEl.innerHTML = strip.map(function(d) {
      return dateButtonHtml(d, d.iso === selectedIso);
    }).join('');
    datesEl.querySelectorAll('.qw-date-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectCollectionDate(btn.getAttribute('data-iso'));
      });
    });
  }

  function selectCollectionDate(iso) {
    var found = findSlotDate(iso);
    if (!found) return;
    _collectionSlot.date = found;
    paintDateStrip();
    syncIcorrectQuote();
    refreshServiceJourney();
    trackSlotSelected();
  }

  function renderCollectionSlots(band) {
    var panel = document.getElementById('qwSlotPanel');
    var datesEl = document.getElementById('qwSlotDates');
    var partsEl = document.getElementById('qwSlotParts');
    var moreBtn = document.getElementById('qwDateMore');
    var modal = document.getElementById('qwCalModal');
    if (!panel || !datesEl || !partsEl || !window.ICorrectCourierSlots) {
      if (panel) panel.hidden = true;
      return;
    }
    var listed = window.ICorrectCourierSlots.listCollectionDates(band, {
      count: SLOT_CALENDAR_COUNT,
      includeWeekends: false
    });
    _collectionSlotDates = listed.dates || [];
    if (!_collectionSlotDates.length) {
      panel.hidden = true;
      return;
    }

    var keepIso = _collectionSlot.date && _collectionSlot.date.iso;
    _collectionSlot.date = (keepIso && findSlotDate(keepIso)) || _collectionSlotDates[0];
    paintDateStrip();

    var parts = window.ICorrectCourierSlots.dayParts();
    var keepPart = _collectionSlot.part && _collectionSlot.part.id;
    var activePart = parts.filter(function(p) { return p.id === keepPart; })[0] || parts[0] || null;
    _collectionSlot.part = activePart;
    partsEl.innerHTML = parts.map(function(p) {
      var on = activePart && p.id === activePart.id;
      return '<button type="button" class="qw-window-btn' + (on ? ' active' : '') + '" data-part="' + p.id + '" role="option" aria-selected="' + (on ? 'true' : 'false') + '">' +
        '<span class="qw-window-label">' + p.label + '</span>' +
        '<span class="qw-window-detail">' + p.detail + '</span></button>';
    }).join('');
    partsEl.querySelectorAll('.qw-window-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        partsEl.querySelectorAll('.qw-window-btn').forEach(function(b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        var id = btn.getAttribute('data-part');
        _collectionSlot.part = parts.filter(function(p) { return p.id === id; })[0] || null;
        syncIcorrectQuote();
        refreshServiceJourney();
        trackSlotSelected();
      });
    });

    if (moreBtn && !moreBtn._qwWired) {
      moreBtn._qwWired = true;
      moreBtn.addEventListener('click', openCollectionCalendar);
    }
    if (modal && !modal._qwWired) {
      modal._qwWired = true;
      modal.addEventListener('click', function(e) {
        var t = e.target;
        if (t && t.getAttribute && t.getAttribute('data-cal-close')) closeCollectionCalendar();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal && !modal.hidden) closeCollectionCalendar();
      });
    }

    panel.hidden = false;
    refreshServiceJourney();
    trackSlotSelected();
  }

  /* UK display form the postcode field already uses: upper case, outward
     then a space then the inward code. Incomplete codes stay as typed. */
  function formatDisplayPostcode(value) {
    var upper = String(value || '').trim().toUpperCase().replace(/\s+/g, ' ');
    if (!upper) return '';
    var compact = upper.replace(/ /g, '');
    if (/^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/.test(compact)) {
      return compact.slice(0, -3) + ' ' + compact.slice(-3);
    }
    return upper;
  }

  function outwardFromPostcode(postcode) {
    var courier = (typeof window !== 'undefined' && window.ICorrectCourier) ? window.ICorrectCourier : null;
    if (courier && typeof courier.extractOutwardCode === 'function') {
      return courier.extractOutwardCode(postcode);
    }
    var cleaned = String(postcode || '').trim().toUpperCase().replace(/\s+/g, ' ');
    if (!cleaned) return null;
    return cleaned.split(' ')[0] || null;
  }

  function shouldShowCollectionNotice(postcodeResolved, quote, selectedKind, postcode) {
    if (!postcodeResolved || !quote) return false;
    if (quote.forcedMailIn || quote.service !== 'courier') return false;
    if (selectedKind !== 'courier') return false;
    var pc = String(postcode || '').trim();
    if (!pc || pc.replace(/\s+/g, '').length < 5) return false;
    if (quote.outward && outwardFromPostcode(pc) !== quote.outward) return false;
    return true;
  }

  function collectionNoticePostcode() {
    var pcInput = document.getElementById('qwPostcode');
    return pcInput ? String(pcInput.value || '').trim() : '';
  }

  var COLLECT_PIN_SVG = '<svg class="qw-collect-pin" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.4a7 7 0 0 0-7 7c0 5.2 7 12.2 7 12.2s7-7 7-12.2a7 7 0 0 0-7-7z"/><circle cx="12" cy="9.4" r="2.35" fill="#FFF7E6"/></svg>';

  function updateCollectionNotice() {
    var el = document.getElementById('qwCollectionNotice');
    var res = document.getElementById('qwResCard');
    var pc = collectionNoticePostcode();
    var show = shouldShowCollectionNotice(_postcodeResolved, _courierQuote, selectedServiceKind(), pc);
    if (res) res.classList.toggle('qw-res--collect-note', !!show);
    if (!el) return;
    if (!show) {
      el.hidden = true;
      if (el.getAttribute('data-pc')) {
        el.removeAttribute('data-pc');
        el.innerHTML = '';
      }
      return;
    }
    var formatted = formatDisplayPostcode(pc);
    if (!formatted) {
      el.hidden = true;
      el.removeAttribute('data-pc');
      el.innerHTML = '';
      if (res) res.classList.remove('qw-res--collect-note');
      return;
    }
    if (el.getAttribute('data-pc') !== formatted) {
      el.innerHTML = COLLECT_PIN_SVG +
        '<p class="qw-collect-copy"><strong class="qw-collect-strong">Collecting from ' + esc(formatted) + '.</strong><span class="qw-collect-rest">Please use this address as your shipping address at checkout.</span></p>';
      el.setAttribute('data-pc', formatted);
    }
    el.hidden = false;
  }

  function applyCourierQuoteToUI(quote) {
    _courierQuote = quote;
    var reveal = document.getElementById('qwDeliveryReveal');
    var slotPanel = document.getElementById('qwSlotPanel');
    var mailPanel = document.getElementById('qwMailinPanel');
    var priceLbl = document.getElementById('qwCourierPriceLbl');
    var mailLbl = document.getElementById('qwMailinPriceLbl');
    var result = document.getElementById('qwCourierResult');
    var courierCard = document.querySelector('.qw-opt-card[data-svc="courier"]');
    var mailCard = document.querySelector('.qw-opt-card[data-svc="mailin"]');
    var pcCard = document.getElementById('qwPostcodeCard');
    var pcInput = document.getElementById('qwPostcode');
    var postcode = pcInput ? String(pcInput.value || '').trim() : '';

    if (!quote) {
      _postcodeResolved = false;
      _quoteShownCaptured = false;
      syncIcorrectQuote();
      if (reveal) reveal.hidden = true;
      if (slotPanel) { slotPanel.hidden = true; _collectionSlot = { date: null, part: null }; _collectionSlotDates = []; }
      if (mailPanel) mailPanel.hidden = true;
      if (result) { result.hidden = true; result.innerHTML = ''; }
      if (pcCard) pcCard.classList.remove('qw-postcode-card-resolved');
      if (priceLbl) priceLbl.textContent = '—';
      if (mailLbl) mailLbl.textContent = '—';
      if (courierCard) {
        courierCard.classList.remove('qw-opt-disabled');
        courierCard.removeAttribute('aria-disabled');
        courierCard.removeAttribute('aria-hidden');
        courierCard.hidden = false;
      }
      setMailInOptionVisible(true);
      setPriceVisibility(false);
      hideServiceJourney();
      closeCollectionCalendar();
      updateCollectionNotice();
      return;
    }

    _postcodeResolved = true;
    if (reveal) reveal.hidden = false;
    if (pcCard) pcCard.classList.add('qw-postcode-card-resolved');
    if (priceLbl) priceLbl.textContent = formatServiceCardHint(quote, 'courier');
    if (mailLbl) mailLbl.textContent = formatServiceCardHint(quote, 'mailin');

    if (courierCard) {
      courierCard.dataset.add = '0';
      if (quote.courierAvailable === false || quote.forcedMailIn) {
        courierCard.classList.add('qw-opt-disabled');
        courierCard.setAttribute('aria-disabled', 'true');
      } else {
        courierCard.classList.remove('qw-opt-disabled');
        courierCard.removeAttribute('aria-disabled');
        courierCard.removeAttribute('aria-hidden');
      }
    }

    var hideMail = shouldHideMailInOption(quote, postcode);
    setMailInOptionVisible(!hideMail);
    if (hideMail && quote.courierAvailable !== false && !quote.forcedMailIn) {
      /* Prefer courier when mail-in is pointless; re-quote if UI had mail-in selected. */
      if (quote.service !== 'courier') {
        var courierOnly = quoteForService('courier', postcode);
        if (courierOnly && courierOnly.service === 'courier') quote = courierOnly;
        _courierQuote = quote;
        if (priceLbl) priceLbl.textContent = formatServiceCardHint(quote, 'courier');
      }
    }

    if (quote.service === 'courier') {
      selectServiceCard('courier');
      /* No band badge — postcode already implies the area; jump straight to slots. */
      if (result) { result.hidden = true; result.innerHTML = ''; }
      if (mailPanel) mailPanel.hidden = true;
      renderCollectionSlots(quote.band);
      if (!_suppressScroll) focusCollectionPanel();
    } else if (quote.forcedMailIn || quote.service === 'mail-in') {
      selectServiceCard('mailin');
      setMailInOptionVisible(true);
      if (slotPanel) { slotPanel.hidden = true; _collectionSlot = { date: null, part: null }; _collectionSlotDates = []; }
      if (mailPanel) mailPanel.hidden = false;
      if (result) {
        result.hidden = false;
        if (quote.forcedMailIn) {
          result.innerHTML = '<div class="qw-courier-confirm qw-courier-confirm--compact">' +
            '<div class="qw-courier-confirm-title">Same Day Courier isn\'t available for your postcode.</div>' +
            '<div class="qw-courier-confirm-detail">We\'ve switched you to tracked mail-in.</div></div>';
        } else {
          result.innerHTML = '<div class="qw-courier-confirm qw-courier-confirm--compact">' +
            '<div class="qw-courier-confirm-title">Mail-in pack</div>' +
            '<div class="qw-courier-confirm-detail">Total below is the all-in price.</div></div>';
        }
      }
      refreshServiceJourney();
      if (!_suppressScroll) {
        var mailTarget = document.getElementById('qwMailinPanel') || document.getElementById('qwDeliveryReveal');
        scrollToEl(mailTarget, 140, isMobileQuoteLayout() ? 'start' : 'nearest');
      }
    }

    refreshAllInTotal();
    updateCollectionNotice();
    if (!_suppressScroll) focusPriceAndProceed();
    trackCourierQuoteEvents(_courierQuote);
  }

  function wireCourierService(container) {
    ensureCourierAssets().catch(function(){});
    _postcodeResolved = false;
    setPriceVisibility(false);
    var input = document.getElementById('qwPostcode');
    if (!input) return;

    function syncFromSelection() {
      var err = document.getElementById('qwServiceErr');
      if (err) err.textContent = '';
      var slotPanel = document.getElementById('qwSlotPanel');
      var mailPanel = document.getElementById('qwMailinPanel');
      var svc = selectedServiceKind();
      if (!_postcodeResolved) return;
      if (svc === 'courier') {
        if (mailPanel) mailPanel.hidden = true;
        if (_courierQuote && _courierQuote.service === 'courier') {
          renderCollectionSlots(_courierQuote.band);
        } else if (slotPanel) {
          slotPanel.hidden = true;
          hideServiceJourney();
        }
      } else {
        if (slotPanel) { slotPanel.hidden = true; _collectionSlot = { date: null, part: null }; }
        if (mailPanel) mailPanel.hidden = false;
        refreshServiceJourney();
      }
      runLookup();
    }

    container.querySelectorAll('.qw-opt-card[data-opt="svc"]').forEach(function(card) {
      card.addEventListener('click', function(){
        if (card.classList.contains('qw-opt-disabled')) return;
        container.querySelectorAll('.qw-opt-card[data-opt="svc"]').forEach(function(c) {
          c.classList.remove('sel', 'active');
        });
        card.classList.add('sel', 'active');
        updateCollectionNotice();
        setTimeout(syncFromSelection, 0);
      });
    });

    var timer = null;
    function showPostcodeWait(show) {
      var wait = document.getElementById('qwPostcodeWait');
      if (wait) wait.style.display = show ? '' : 'none';
    }
    /* settled = blur or Enter: a partial postcode then gets a neutral hint.
       While typing, a partial postcode shows nothing. */
    function runLookup(settled) {
      var pc = String(input.value || '').trim();
      if (!pc) {
        showPostcodeWait(false);
        applyCourierQuoteToUI(null);
        return;
      }
      /* Full UK postcode only (outward + inward, space optional). No courier
         or mail-in result and no funnel events until then. */
      if (!isFullPostcodeValue(pc)) {
        showPostcodeWait(settled === true);
        if (_postcodeResolved || _courierQuote) applyCourierQuoteToUI(null);
        return;
      }
      showPostcodeWait(false);
      if (!window.ICorrectCourier || !window.__QW_BANDS) {
        ensureCourierAssets().then(function () { runLookup(settled); }); return;
      }
      var kind = selectedServiceKind();
      /* Always probe courier first so we can auto-route to mail-in when forced */
      var courierQuote = quoteForService('courier', pc);
      if (courierQuote && courierQuote.forcedMailIn) {
        applyCourierQuoteToUI(courierQuote);
        return;
      }
      var quote = quoteForService(kind, pc);
      applyCourierQuoteToUI(quote);
    }
    input.addEventListener('input', function(){
      clearTimeout(timer);
      updateCollectionNotice();
      timer = setTimeout(function () { runLookup(false); }, 220);
    });
    input.addEventListener('blur', function(){ clearTimeout(timer); runLookup(true); });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); runLookup(true); }
    });
    setTimeout(function(){ try { input.focus(); } catch (e) {} }, 120);
  }

  /* Turnaround cards: detected dynamically from the product page HTML.
     The product template renders .turn_arround_time-wrapper only if the
     turnaround metafield exists. We fetch the page, check for that marker,
     and parse the express price. Cached per handle. Zero maintenance. */
  var _expressCache = {};
  async function detectExpressFromPage(handle) {
    if (_expressCache[handle] !== undefined) return _expressCache[handle];
    try {
      var res = await fetch('/products/' + handle);
      if (!res.ok) { _expressCache[handle] = null; return null; }
      var html = await res.text();
      var marker = html.indexOf('turn_arround_time-wrapper');
      if (marker === -1) { _expressCache[handle] = null; return null; }
      var priceMatch = html.match(/id="one_day-btn"[^>]*data-price="([^"]+)"/);
      var price = priceMatch ? parseFloat(priceMatch[1]) : 0;
      var variantMatch = html.match(/id="one_day-btn"[^>]*value="(\d+)"/);
      var variantId = variantMatch ? parseInt(variantMatch[1], 10) : null;
      if (!price) {
        var fastSection = html.substring(marker, marker + 2000);
        var moneyMatch = fastSection.match(/\+[£](\d+(?:\.\d+)?)/);
        price = moneyMatch ? parseFloat(moneyMatch[1]) : 0;
      }
      if (!variantId) {
        var vidMatch = html.match(/name="turn_arround_time"[^>]*value="(\d+)"/);
        if (!vidMatch) vidMatch = html.match(/id="one_day-btn"[^>]*value="(\d+)"/);
        variantId = vidMatch ? parseInt(vidMatch[1], 10) : null;
      }
      var result = price ? { price: price, variantId: variantId } : null;
      _expressCache[handle] = result;
      return result;
    } catch(e) { _expressCache[handle] = null; return null; }
  }

  function buildTurnaroundCards(expressData) {
    if (!expressData || !expressData.price) return '';
    /* No Fast option when the Face ID module has to come from Apple. */
    if (needsAppleFaceIdModule(S.device)) return '';
    var standardMeta = turnaroundClaimLabel(S.device);
    var fastMeta = repairBenchDays(S.device) <= 1 ? 'Priority' : '1 working day';
    return '<div class="qw-opt-section">' +
      '<div class="qw-opt-label">Repair turnaround</div>' +
      '<div class="qw-opt-row">' +
        '<div class="qw-opt-card sel" data-opt="speed" data-add="0" data-vid="0" tabindex="0">' +
          '<div class="qw-opt-name">Standard</div>' +
          '<div class="qw-opt-meta">' + esc(standardMeta) + '</div>' +
          '<div class="qw-opt-price free">Included</div>' +
        '</div>' +
        '<div class="qw-opt-card" data-opt="speed" data-add="' + expressData.price + '" data-vid="' + (expressData.variantId || 0) + '" tabindex="0">' +
          '<div class="qw-opt-name">Fast</div>' +
          '<div class="qw-opt-meta">' + esc(fastMeta) + '</div>' +
          '<div class="qw-opt-price">+' + gbp.format(expressData.price) + '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* =============================================
     NAVIGATION + BREADCRUMB + PROGRESS
     ============================================= */
  /* Hold the wizard chrome at the same viewport Y across step swaps so
     Device → Model → Fault doesn't jump when content height changes.
     Only pin when the chrome was already on-screen. Never yank the page
     down to the wizard (that hijacked homepage load when the module sits
     below the hero). */
  function pinWizardChrome(beforeTop) {
    if (_suppressScroll) return;
    if (typeof beforeTop !== 'number') return;
    var anchor = document.querySelector('.qw-prog') || document.querySelector('.qw-wizard');
    if (!anchor) return;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    /* Chrome started below the fold / off-page — leave scroll alone. */
    if (beforeTop > vh * 0.9 || beforeTop < -120) return;
    var rect = anchor.getBoundingClientRect();
    var delta = rect.top - beforeTop;
    if (Math.abs(delta) > 1) {
      try { window.scrollBy(0, delta); } catch (e) {}
    }
  }

  function go(n) {
    var anchor = document.querySelector('.qw-prog') || document.querySelector('.qw-wizard');
    var beforeTop = anchor ? anchor.getBoundingClientRect().top : null;
    if (n < S.step) clearTrackedStepsAfter(n);
    S.step = n;
    _stepStartTime = Date.now();
    history.pushState({ step: n, device: S.device, model: S.model, fault: S.fault }, '');
    document.querySelectorAll('.qw-step').forEach(function(el) { el.classList.remove('on'); });
    var stepEl = document.getElementById('qw-s' + n);
    if (stepEl) stepEl.classList.add('on');
    updateProg(n);
    updateCrumb();
    requestAnimationFrame(function() { pinWizardChrome(beforeTop); });
  }

  /* Issue → service/pricing is a full-screen transition (same feel as device → model). */
  function openResolutionScreen(title, sub) {
    var tC = document.getElementById('qw-tC');
    if (tC) tC.hidden = true;
    var rP = document.getElementById('qw-rP');
    if (rP) {
      rP.hidden = false;
      rP.removeAttribute('style');
    }
    var titleEl = document.getElementById('qw-s4t');
    if (titleEl && title) titleEl.textContent = title;
    var subEl = document.getElementById('qw-s4s');
    if (subEl && sub !== undefined) {
      subEl.textContent = sub;
      subEl.hidden = !sub;
    }
    updateProg(4);
    /* Don't scroll to progress pills — focusQuoteEntry runs after the card renders. */
  }

  function hideResolutionPanel() {
    var rP = document.getElementById('qw-rP');
    if (rP) {
      rP.hidden = true;
      rP.innerHTML = '';
      rP.removeAttribute('style');
    }
  }

  function resolutionScreenOpen() {
    var rP = document.getElementById('qw-rP');
    return !!(rP && !rP.hidden && rP.innerHTML);
  }

  function updateProg(step) {
    var mono = document.getElementById('qwProgMono');
    if (mono) mono.textContent = 'Step ' + step + ' of 4';
    document.querySelectorAll('.qw-prog-s').forEach(function(el) {
      var s = parseInt(el.dataset.s, 10);
      el.classList.remove('on', 'done', 'current');
      if (s < step) {
        el.classList.add('done');
        el.disabled = false;
        el.setAttribute('aria-current', 'false');
      } else if (s === step) {
        el.classList.add('on', 'current');
        el.disabled = false;
        el.setAttribute('aria-current', 'step');
      } else {
        el.disabled = true;
        el.setAttribute('aria-current', 'false');
      }
    });
  }

  /* [4.3] Breadcrumb */
  function updateCrumb() {
    var el = document.getElementById('qw-crumb');
    if (!el) return;
    var parts = [];
    if (S.device) parts.push({ label: DN[S.device] || S.device, step: 1 });
    if (S.model) parts.push({ label: S.model, step: 2 });
    if (S.fault && S.step >= 4) parts.push({ label: faultDisplayLabel(S.device, S.fault), step: 3 });
    if (parts.length === 0) { el.innerHTML = ''; return; }
    el.innerHTML = parts.map(function(p, i) {
      var sep = i > 0 ? '<span class="qw-crumb-sep">&rsaquo;</span>' : '';
      return sep + '<button class="qw-crumb-btn" data-go="' + p.step + '">' + esc(p.label) + '</button>';
    }).join('');
    el.querySelectorAll('.qw-crumb-btn').forEach(function(btn) {
      btn.onclick = function() { var t = parseInt(btn.dataset.go); if (t < S.step) go(t); };
    });
  }

  /* [4.4] Clickable progress dots */
  function wireProgDots() {
    document.querySelectorAll('.qw-prog-s').forEach(function(el) {
      el.style.cursor = 'pointer';
      el.onclick = function() {
        var target = parseInt(el.dataset.s);
        if (target < S.step) go(target);
      };
    });
  }

  /* =============================================
     STEP 1: DEVICES
     ============================================= */
  function renderDevices() {
    var g = document.getElementById('qw-devGrid');
    if (!g) return;
    var existing = g.querySelectorAll('.qw-dev[data-dev]');
    if (existing.length) {
      existing.forEach(function(c) {
        var id = c.getAttribute('data-dev');
        var lbl = c.querySelector('.qw-dev-lbl');
        wireA11y(c, 'Select ' + (lbl ? lbl.textContent : id));
        c.onclick = function() { pickDev(id, c); };
      });
      return;
    }
    g.innerHTML = '';
    DEVS.forEach(function(d) {
      var c = document.createElement('div');
      c.className = 'qw-dev';
      c.setAttribute('data-dev', d.id);
      c.innerHTML = '<div class="qw-dev-ico">' + d.icon + '</div><span class="qw-dev-lbl">' + d.label + '</span>';
      wireA11y(c, 'Select ' + d.label);
      c.onclick = function() { pickDev(d.id, c); };
      g.appendChild(c);
    });
  }

  function pickDev(id, el) {
    S.device = id; S.model = null; S.modelGroup = null; S.fault = null; S.issue = null; S.route = null; S.repairType = null;
    S.collectionHandle = null; _repairsMap = {};
    syncIcorrectQuote();
    clearTrackedStepsAfter(1);
    document.querySelectorAll('#qw-s1 .qw-dev').forEach(function(c) { c.classList.remove('sel'); });
    if (el) el.classList.add('sel');
    trackWizardStart({
      start_step: 'device',
      step_name: 'device',
      step_number: 1
    });
    trackWizardStepComplete('device', 1, {
      selected_device: id
    });
    trackWizardStep(2);
    setTimeout(function() { renderModels(id); go(2); }, 150);
  }

  /* =============================================
     STEP 2: MODELS (accordion + auto-expand)
     ============================================= */
  /* Sort models: newest year first, then highest M-chip first within same year */
  function sortModels(models) {
    return models.slice().sort(function(a, b) {
      var ya = parseInt((a.name.match(/\((\d{4})\)/) || [])[1]) || 0;
      var yb = parseInt((b.name.match(/\((\d{4})\)/) || [])[1]) || 0;
      if (yb !== ya) return yb - ya;
      /* Extract M-chip number: M4=4, M3=3, M2=2, M1=1, none=0 */
      var ma = parseInt((a.name.match(/M(\d)/i) || [])[1]) || 0;
      var mb = parseInt((b.name.match(/M(\d)/i) || [])[1]) || 0;
      if (mb !== ma) return mb - ma;
      /* Within same chip, Max > Pro > base */
      var ra = a.name.indexOf('Max') !== -1 ? 3 : a.name.indexOf('Pro') !== -1 ? 2 : 1;
      var rb = b.name.indexOf('Max') !== -1 ? 3 : b.name.indexOf('Pro') !== -1 ? 2 : 1;
      return rb - ra;
    });
  }

  /* Model step mirrors workshop-os walk-in intake:
     device → series/range screen → exact model (e.g. MacBook A2338). */
  function renderModels(dev) {
    S.modelGroup = null;
    renderModelGroups(dev);
  }

  function renderModelGroups(dev) {
    var c = document.getElementById('qw-mC');
    if (!c) return;
    c.innerHTML = '';
    var titleEl = document.getElementById('qw-s2t');
    if (titleEl) titleEl.textContent = 'Which ' + DN[dev] + ' is it?';
    var subEl = document.getElementById('qw-s2s') || document.querySelector('#qw-s2 .qw-s-sub');
    if (subEl) subEl.textContent = 'Choose the series first, then we’ll show the exact models.';
    var hP = document.getElementById('qw-hP');
    if (hP) { hP.classList.remove('open'); hP.innerHTML = ''; }
    var hT = document.getElementById('qw-hT');
    if (hT) hT.style.display = '';

    var groups = MODELS[dev];
    if (!groups || groups.length === 0) {
      c.innerHTML = '<div class="qw-empty"><p>We don\'t have pricing for this model yet. Get in touch for a quote.</p><a href="/pages/contact" class="qw-btn-book">Get in touch</a></div>';
      return;
    }

    /* Single series → skip straight to models (still one clear screen). */
    if (groups.length === 1) {
      pickModelGroup(dev, groups[0]);
      return;
    }

    var w = document.createElement('div'); w.className = 'qw-series-grid';
    groups.forEach(function(g) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qw-series-card';
      btn.innerHTML =
        '<span class="qw-series-name">' + esc(g.group) + '</span>' +
        '<span class="qw-series-count">' + g.models.length + ' model' + (g.models.length === 1 ? '' : 's') + '</span>' +
        '<svg class="qw-series-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';
      wireA11y(btn, 'Select ' + g.group);
      btn.onclick = function() { pickModelGroup(dev, g); };
      w.appendChild(btn);
    });
    c.appendChild(w);
    renderHelper(dev);
  }

  function pickModelGroup(dev, group) {
    S.modelGroup = group.group;
    renderModelList(dev, group);
  }

  /* Leave a prefilled / selected model and return to the model selector. */
  function changeModelSelection() {
    S.model = null;
    S.collectionHandle = null;
    S.modelGroup = null;
    S.fault = null;
    S.issue = null;
    S.route = null;
    S.repairType = null;
    S.preFault = null;
    S.preRepairType = null;
    _repairsMap = {};
    syncIcorrectQuote();
    clearTrackedStepsAfter(1);
    if (!S.device) {
      go(1);
      return;
    }
    renderModelGroups(S.device);
    go(2);
  }

  function buildMacBookModelHint() {
    var url = CFG.macbookModelHintUrl;
    if (!url) return null;
    var wrap = document.createElement('div');
    wrap.className = 'qw-macbook-hint';
    wrap.innerHTML =
      '<div class="qw-macbook-hint-media">' +
        '<img src="' + esc(url) + '" alt="MacBook underside with model number near the hinge highlighted" width="640" height="360" loading="lazy">' +
      '</div>' +
      '<p class="qw-macbook-hint-caption">Turn the MacBook over. The model number starts with A and is printed near the hinge.</p>';
    return wrap;
  }

  function renderModelList(dev, group) {
    var c = document.getElementById('qw-mC');
    if (!c) return;
    c.innerHTML = '';
    var seriesLabel = group.group || DN[dev];
    var titleEl = document.getElementById('qw-s2t');
    if (titleEl) titleEl.textContent = 'Which model is it?';
    var subEl = document.getElementById('qw-s2s') || document.querySelector('#qw-s2 .qw-s-sub');
    if (subEl) {
      subEl.textContent = 'Choose the exact ' + (DN[dev] || '') + ' model from ' + seriesLabel + '.';
    }
    var hT = document.getElementById('qw-hT');
    if (hT) hT.style.display = 'none';
    var hP = document.getElementById('qw-hP');
    if (hP) { hP.classList.remove('open'); hP.innerHTML = ''; }

    if (dev === 'macbook') {
      var hint = buildMacBookModelHint();
      if (hint) c.appendChild(hint);
    }

    var list = document.createElement('div'); list.className = 'qw-m-list qw-m-list--flat';
    var sorted = sortModels(group.models || []);
    sorted.forEach(function(m) {
      var it = document.createElement('button');
      it.type = 'button';
      it.className = 'qw-m-item qw-choice-btn';
      it.innerHTML = '<span class="qw-mn">' + esc(m.name) + '</span>';
      wireA11y(it, 'Select ' + m.name);
      it.onclick = function() { pickModel(m.name, m.collectionHandle, it); };
      list.appendChild(it);
    });

    /* Wrong-model escape: go back to series/model picker (essential on PDP prefill). */
    if (sorted.length > 0) {
      var change = document.createElement('button');
      change.type = 'button';
      change.className = 'qw-m-item qw-choice-btn qw-m-item--change-model';
      change.innerHTML = '<span class="qw-mn">Choose a different model</span>';
      wireA11y(change, 'Choose a different model');
      change.onclick = function() { changeModelSelection(); };
      list.appendChild(change);
    }

    c.appendChild(list);
  }

  async function pickModel(name, handle, el) {
    S.model = name; S.collectionHandle = handle; S.fault = null; S.issue = null; S.route = null; S.repairType = null;
    syncIcorrectQuote();
    clearTrackedStepsAfter(2);
    /* [3.6] Auto-close helper */
    var hP = document.getElementById('qw-hP');
    if (hP) hP.classList.remove('open');
    document.querySelectorAll('.qw-m-item').forEach(function(c) { c.classList.remove('sel'); });
    if (el) el.classList.add('sel');

    var fGrid = document.querySelector('#qw-s3 .qw-f-grid');
    if (fGrid) fGrid.innerHTML = '<div class="qw-loading"><div class="qw-spinner"></div><p>Loading repairs for ' + esc(name) + '...</p></div>';

    await ensureCourierAssets().catch(function(){});
    var cat = window.ICorrectCatalogue;
    if (cat && window.__QW_CATALOGUE) {
      _repairsMap = cat.repairsMapForModel(window.__QW_CATALOGUE, S.device, name) || {};
      _collectionProducts = Object.keys(_repairsMap).map(function(k){ return _repairsMap[k]; });
    } else {
      _repairsMap = {};
      _collectionProducts = [];
    }
    /* Catalogue map is authoritative — no collection HTML scrape (#53). */
    trackWizardStart({
      start_step: 'model',
      step_name: 'model',
      step_number: 2
    });
    trackWizardStepComplete('model', 2, {
      collection_handle: handle
    });

    trackWizardStep(3);

    var pf = S.preFault; S.preFault = null;
    /* Prefilled fault only if this model has issues for it; otherwise show the fault picker. */
    if (pf && !getAvailableIssues(S.device, pf, _repairsMap).length) pf = null;
    if (pf) {
      S.fault = pf;
      syncIcorrectQuote();
      renderFaults(S.device);
      renderIssues(S.device, pf);
      trackWizardStep(4);
      go(4);
      /* Product pages stay sequential: fault → postcode → price.
         Only auto-advance when skip_to_service is explicitly on (rare deep-links). */
      if (CONTEXT.skipToService) {
        autoPickIssueForPrefill(pf);
      }
      return;
    }
    renderFaults(S.device);
    go(3);
    focusWizardStep(3);
  }


  function autoPickIssueForPrefill(faultKey) {
    var issues = getAvailableIssues(S.device, faultKey, _repairsMap);
    if (!issues || !issues.length) return;
    var wantType = S.preRepairType || null;
    S.preRepairType = null;
    var match = null;
    var i;
    if (wantType) {
      for (i = 0; i < issues.length; i++) {
        if (issues[i].repairType === wantType && issues[i].route === 'repair') { match = issues[i]; break; }
      }
    }
    if (!match) {
      for (i = 0; i < issues.length; i++) {
        if (issues[i].route === 'repair' && _repairsMap[issues[i].repairType]) { match = issues[i]; break; }
      }
    }
    if (!match) match = issues[0];
    if (match) pickIssue(match, null);
  }

  /* =============================================
     MODEL HELPERS
     ============================================= */
  function renderHelper(dev) {
    var hT = document.getElementById('qw-hT');
    var hP = document.getElementById('qw-hP');
    if (!hT || !hP) return;
    hT.style.display = '';
    hP.innerHTML = '';
    hT.onclick = function() { hP.classList.toggle('open'); };
    if (dev === 'iphone') renderIphoneVG(hP);
    else if (dev === 'macbook') renderMacbookHelper(hP);
    else renderGenericHelper(hP);
  }

  /* [3.1] iPhone VG with dead-end filtering */
  function renderIphoneVG(panel) {
    var vgS = {};
    var VK = { 1: 'cams', 2: 'edges', 3: 'screen', 4: 'size' };
    var CDN = 'https://cdn.shopify.com/s/files/1/0728/7111/7053/files/';

    function vgOpt(val, img, lbl) { return '<div class="qw-vg-opt" data-v="' + val + '"><img src="' + img + '" class="qw-vg-img"><div class="qw-vg-lbl">' + lbl + '</div></div>'; }
    var VG_PHONE_HEIGHTS = { max: 64, pro: 54, std: 46, mini: 38 };
    function vgSize(val, lbl, det) {
      var h = VG_PHONE_HEIGHTS[val] || 50;
      var w = Math.round(h * 0.48);
      var svg = '<svg viewBox="0 0 24 44" fill="none" stroke="var(--qw-text-2)" stroke-width="1.5" width="' + w + '" height="' + h + '" style="display:block;"><rect x="2" y="1" width="20" height="42" rx="4.5"/><line x1="9" y1="3.5" x2="15" y2="3.5" stroke-linecap="round" opacity="0.4"/><line x1="8" y1="39" x2="16" y2="39" stroke-linecap="round" opacity="0.3"/></svg>';
      return '<div class="qw-vg-opt" data-v="' + val + '"><div style="height:70px;display:flex;align-items:flex-end;justify-content:center;padding-bottom:2px;">' + svg + '</div><div class="qw-vg-lbl">' + lbl + '<br><span style="font-weight:400;color:var(--qw-text-3);font-size:11px;">' + det + '</span></div></div>';
    }

    var html = '<div class="qw-help-card"><div id="qwVgWiz">';
    html += '<div class="qw-vg-step on" data-vs="1"><div class="qw-vg-title">Rear cameras</div><div class="qw-vg-sub">What does the back look like?</div><div class="qw-vg-grid">';
    html += vgOpt('tri_plat',CDN+'17pm.png?v=1766083751','3 Cameras<br>(Plateau)');
    html += vgOpt('tri_std',CDN+'16pm.png?v=1766083961','3 Cameras<br>(Standard)');
    html += vgOpt('diag',CDN+'15.png?v=1766083751','2 Cameras<br>(Diagonal)');
    html += vgOpt('vert',CDN+'16.png?v=1766083751','2 Cameras<br>(Vertical)');
    html += vgOpt('single_plat',CDN+'air.png?v=1766083751','1 Camera<br>(Plateau)');
    html += vgOpt('single_std',CDN+'16e.png?v=1766083751','1 Camera<br>(Standard)');
    html += '</div></div>';
    html += '<div class="qw-vg-step" data-vs="2"><button class="qw-vg-back" data-from="2"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Back</button><div class="qw-vg-title">Frame shape</div><div class="qw-vg-sub">Check the metal edge</div><div class="qw-vg-grid">';
    html += vgOpt('flat',CDN+'squared.png?v=1766085750','Flat (Square)');
    html += vgOpt('curved',CDN+'round.png?v=1766085749','Curved (Round)');
    html += '</div></div>';
    html += '<div class="qw-vg-step" data-vs="3"><button class="qw-vg-back" data-from="3"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Back</button><div class="qw-vg-title">Screen type</div><div class="qw-vg-sub">Look at the top of the display</div><div class="qw-vg-grid">';
    html += vgOpt('island',CDN+'dynamic_island.png?v=1766085749','Dynamic Island');
    html += vgOpt('notch',CDN+'notch.png?v=1766085750','Notch');
    html += '</div></div>';
    html += '<div class="qw-vg-step" data-vs="4"><button class="qw-vg-back" data-from="4"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Back</button><div class="qw-vg-title">Size</div><div class="qw-vg-sub">How big is it?</div><div class="qw-vg-grid">';
    html += vgSize('max','Pro Max / Plus','6.5" - 6.9"');
    html += vgSize('pro','Pro','5.8" - 6.3"');
    html += vgSize('std','Standard','4.7" - 6.1"');
    html += vgSize('mini','Mini','5.4"');
    html += '</div></div>';
    html += '<div class="qw-vg-step" data-vs="result"><div class="qw-vg-result" id="qwVgResult"></div></div>';
    html += '</div><button class="qw-help-close">Close</button></div>';
    panel.innerHTML = html;
    panel.querySelector('.qw-help-close').onclick = function() { panel.classList.remove('open'); };

    function vgGoTo(n) {
      panel.querySelectorAll('.qw-vg-step').forEach(function(s) { s.classList.remove('on'); });
      var target = panel.querySelector('.qw-vg-step[data-vs="' + n + '"]');
      if (target) target.classList.add('on');
      vgApplyFilters();
    }

    /* [3.1] Filter logic: hide options that produce zero matches */
    function vgApplyFilters() {
      for (var step = 1; step <= 4; step++) {
        var key = VK[step];
        var tempState = {};
        for (var s = 1; s < step; s++) { if (vgS[VK[s]]) tempState[VK[s]] = vgS[VK[s]]; }
        var allowed = {};
        VG_DB.forEach(function(m) {
          if (tempState.cams && m.cams !== tempState.cams) return;
          if (tempState.edges && m.edges !== tempState.edges) return;
          if (tempState.screen && m.screen !== tempState.screen) return;
          if (tempState.size && m.size !== tempState.size) return;
          allowed[m[key]] = true;
        });
        var stepEl = panel.querySelector('.qw-vg-step[data-vs="' + step + '"]');
        if (stepEl) {
          var visibleCount = 0;
          stepEl.querySelectorAll('.qw-vg-opt').forEach(function(opt) {
            if (allowed[opt.dataset.v]) { opt.style.display = ''; visibleCount++; }
            else { opt.style.display = 'none'; }
          });
          /* Auto-skip: if only one option visible and we're on this step, auto-select it */
        }
      }
    }

    panel.querySelectorAll('.qw-vg-back').forEach(function(btn) {
      btn.onclick = function() {
        var from = parseInt(btn.dataset.from);
        delete vgS[VK[from]];
        vgGoTo(from - 1);
      };
    });

    panel.querySelectorAll('.qw-vg-opt').forEach(function(o) {
      o.onclick = function() {
        if (o.style.display === 'none') return;
        var vs = parseInt(o.closest('.qw-vg-step').dataset.vs);
        vgS[VK[vs]] = o.dataset.v;
        if (vs === 1 && o.dataset.v === 'single_plat') { vgShowResult(); return; }
        if (vs === 1 && o.dataset.v === 'tri_plat') { vgS.edges = 'curved'; vgS.screen = 'island'; vgGoTo(4); return; }
        if (vs === 2 && vgS.cams === 'single_std' && o.dataset.v === 'flat') { vgS.screen = 'notch'; vgGoTo(4); return; }
        if (vs === 2 && vgS.cams === 'single_std' && o.dataset.v === 'curved') { vgS.screen = 'home'; vgGoTo(4); return; }
        if (vs >= 4) { vgShowResult(); return; }
        vgGoTo(vs + 1);
      };
    });

    function vgShowResult() {
      var matches = VG_DB.filter(function(m) {
        if (vgS.cams && m.cams !== vgS.cams) return false;
        if (vgS.edges && m.edges !== vgS.edges) return false;
        if (vgS.screen && m.screen !== vgS.screen) return false;
        if (vgS.size && m.size !== vgS.size) return false;
        return true;
      });
      var rc = document.getElementById('qwVgResult');
      if (!rc) return;
      if (matches.length === 1) {
        var m = matches[0];
        rc.innerHTML = '<img src="' + m.img + '" style="max-width:220px;max-height:170px;object-fit:contain;margin-bottom:14px;"><div class="qw-vg-result-name">' + m.n + '</div><button class="qw-vg-btn qw-vg-btn-p" id="qwVgSel">Select this model</button> <button class="qw-vg-btn qw-vg-btn-s" id="qwVgReset2">Try again</button>';
        document.getElementById('qwVgSel').onclick = function() { vgSelect(m.n); };
        document.getElementById('qwVgReset2').onclick = vgReset;
      } else if (matches.length > 1) {
        var h = '<div class="qw-vg-title" style="margin-bottom:14px;">Which one?</div><div class="qw-vg-grid">';
        matches.forEach(function(m) {
          h += '<div class="qw-vg-opt" data-vgname="' + esc(m.n) + '"><img src="' + m.img + '" style="max-width:140px;max-height:110px;object-fit:contain;"><div class="qw-vg-lbl">' + m.n + '</div></div>';
        });
        h += '</div><button class="qw-vg-btn qw-vg-btn-s" style="margin-top:14px;" id="qwVgReset3">Try again</button>';
        rc.innerHTML = h;
        rc.querySelectorAll('[data-vgname]').forEach(function(el) { el.onclick = function() { vgSelect(el.dataset.vgname); }; });
        document.getElementById('qwVgReset3').onclick = vgReset;
      } else {
        /* Should not happen with filtering, but just in case */
        rc.innerHTML = '<div class="qw-vg-title">Could not match your device</div><button class="qw-vg-btn qw-vg-btn-s" id="qwVgReset">Try again</button>';
        document.getElementById('qwVgReset').onclick = vgReset;
      }
      vgGoTo('result');
    }

    function vgReset() { for (var k in vgS) delete vgS[k]; vgGoTo(1); }

    /* [3.3] Robust name matching: exact first, then contains (longest wins) */
    function vgSelect(name) {
      var groups = MODELS[S.device] || [];
      /* Pass 1: exact */
      for (var g = 0; g < groups.length; g++) {
        for (var m = 0; m < groups[g].models.length; m++) {
          if (groups[g].models[m].name === name) { panel.classList.remove('open'); pickModel(groups[g].models[m].name, groups[g].models[m].collectionHandle, null); return; }
        }
      }
      /* Pass 2: contains (longest match) */
      var best = null, bestLen = 0;
      for (var g2 = 0; g2 < groups.length; g2++) {
        for (var m2 = 0; m2 < groups[g2].models.length; m2++) {
          var mn = groups[g2].models[m2].name;
          if (mn.indexOf(name) !== -1 || name.indexOf(mn) !== -1) {
            var matchLen = Math.min(mn.length, name.length);
            if (matchLen > bestLen) { best = groups[g2].models[m2]; bestLen = matchLen; }
          }
        }
      }
      if (best) { panel.classList.remove('open'); pickModel(best.name, best.collectionHandle, null); return; }
      /* [3.2] No fallback with broken state - show message */
      var rc2 = document.getElementById('qwVgResult');
      if (rc2) rc2.innerHTML = '<div class="qw-vg-title">Could not match to a model in our system</div><p style="font-size:13px;color:var(--qw-text-2);margin:8px 0;">Please pick your model from the list above instead.</p><button class="qw-vg-btn qw-vg-btn-s" id="qwVgResetFail">Close</button>';
      var rb = document.getElementById('qwVgResetFail');
      if (rb) rb.onclick = function() { panel.classList.remove('open'); };
    }

    vgApplyFilters();
  }

  /* [3.4] MacBook helper with reference image */
  function renderMacbookHelper(panel) {
    panel.innerHTML =
      '<div class="qw-help-card"><div class="qw-help-body qw-help-split">' +
      '<div class="qw-help-left"><img src="https://cdn.shopify.com/s/files/1/0728/7111/7053/files/MacBook_Model_Number_7104995a-bc9e-4b6d-9a9b-5578f42b4a7b.png?v=1773930835" alt="Where to find your MacBook model number" class="qw-help-img"></div>' +
      '<div class="qw-help-right">' +
      '<p class="qw-help-inst">Flip your MacBook over. The model number (e.g. <code>A1989</code>) is printed on the bottom case near the hinge.</p>' +
      '<div class="qw-help-row"><input class="qw-help-input" type="text" id="qwMbSearch" placeholder="Type model number, e.g. A1989"></div>' +
      '<div class="qw-help-results" id="qwMbRes"></div>' +
      '</div></div><button class="qw-help-close">Close</button></div>';
    panel.querySelector('.qw-help-close').onclick = function() { panel.classList.remove('open'); };

    function findConfiguredModelByName(name) {
      var exact = null;
      var best = null;
      var bestLen = 0;
      var groups = MODELS['macbook'] || [];
      for (var g = 0; g < groups.length; g++) {
        for (var m = 0; m < groups[g].models.length; m++) {
          var model = groups[g].models[m];
          if (model.name === name) return model;
          if (model.name.indexOf(name) !== -1 || name.indexOf(model.name) !== -1) {
            var matchLen = Math.min(model.name.length, name.length);
            if (matchLen > bestLen) {
              best = model;
              bestLen = matchLen;
            }
          }
        }
      }
      return exact || best;
    }

    var groups = MODELS['macbook'] || [];

    function mbFilter() {
      var q = (document.getElementById('qwMbSearch').value || '').trim().toUpperCase();
      var r = document.getElementById('qwMbRes');
      if (!r) return;
      r.innerHTML = '';
      if (!q) return;
      var f = MB_NUMS.filter(function(n) { return n.n.toUpperCase().indexOf(q) !== -1 || n.m.toUpperCase().indexOf(q) !== -1; });
      if (!f.length) { r.innerHTML = '<div style="padding:10px;font-size:13px;color:var(--qw-text-3);">No match. Check the number and try again.</div>'; return; }
      /* Deduplicate by model name to avoid showing A2338 twice with same target */
      var seen = {};
      f.forEach(function(n) {
        if (seen[n.m]) return;
        seen[n.m] = true;
        var d = document.createElement('div'); d.className = 'qw-help-hit';
        d.innerHTML = '<span class="qw-hn">' + n.n + '</span><span class="qw-hm">' + n.m + '</span><span class="qw-hs">Select</span>';
        d.onclick = function() {
          var model = findConfiguredModelByName(n.m);
          if (model) {
            panel.classList.remove('open');
            pickModel(model.name, model.collectionHandle, null);
          } else {
            r.innerHTML = '<div style="padding:10px;font-size:13px;color:var(--qw-text-3);">This model isn\'t configured in our system yet. Please pick from the list above.</div>';
          }
        };
        r.appendChild(d);
      });
    }
    document.getElementById('qwMbSearch').oninput = mbFilter;
  }

  function renderGenericHelper(panel) {
    panel.innerHTML = '<div class="qw-help-card"><div style="padding:20px;"><p class="qw-help-inst">Go to <code>Settings > General > About</code> on your device. The model number is listed there.</p></div><button class="qw-help-close">Close</button></div>';
    panel.querySelector('.qw-help-close').onclick = function() { panel.classList.remove('open'); };
  }

  /* =============================================
     STEP 3: FAULTS
     ============================================= */
  function renderFaults(dev) {
    var c = document.getElementById('qw-fC');
    if (!c) return;
    c.innerHTML = '';
    var titleEl = document.getElementById('qw-s3t');
    if (titleEl) titleEl.textContent = "What's wrong with your " + DN[dev] + "?";

    var faults = getAvailableFaults(dev, _repairsMap);
    if (faults.length === 0) {
      c.innerHTML = '<div class="qw-empty"><p>We\'re setting up pricing for this model. Get in touch for a quote.</p><a href="/pages/contact" class="qw-btn-book">Get in touch</a></div>';
      return;
    }
    faults.forEach(function(f) {
      var card = document.createElement('div');
      card.className = 'qw-f-card';
      card.innerHTML = '<div class="qw-f-ico">' + (FAULT_ICONS[f.icon] || FAULT_ICONS.other) + '</div><span class="qw-f-lbl">' + esc(f.label) + '</span>';
      wireA11y(card, f.label);
      card.onclick = function() { pickFault(f.v, card); };
      c.appendChild(card);
    });
  }

  function pickFault(v, el) {
    S.fault = v; S.issue = null; S.route = null; S.repairType = null;
    syncIcorrectQuote();
    clearTrackedStepsAfter(3);
    document.querySelectorAll('#qw-s3 .qw-f-card').forEach(function(c) { c.classList.remove('sel'); });
    if (el) el.classList.add('sel');
    trackWizardStart({
      start_step: 'fault',
      step_name: 'fault',
      step_number: 3
    });
    trackWizardStepComplete('fault', 3, {
      selected_fault: v
    });
    trackWizardStep(4);

    /* MacBook and Watch Other stays a contact shortcut.
       iPhone and iPad open the Other list (diagnostics and contact options). */
    if (v === 'Other' && (S.device === 'macbook' || S.device === 'watch')) {
      S.issue = 'Other';
      syncIcorrectQuote();
      setTimeout(function() {
        var tC = document.getElementById('qw-tC'); if (tC) { tC.innerHTML = ''; tC.hidden = true; }
        hideResolutionPanel();
        go(4);
        showResolution({ label: 'Other', route: 'contact', repairType: null, copy: 'Tell us what\'s happening with your ' + (DN[S.device] || 'device') + ' and we\'ll point you in the right direction.' }, {
          title: 'Tell us what\'s going on',
          sub: 'Describe the issue and we\'ll get back to you with the right repair option.'
        });
      }, 150);
      return;
    }

    setTimeout(function() { renderIssues(S.device, v); go(4); }, 150);
  }

  /* =============================================
     STEP 4: ISSUES
     ============================================= */
  function renderIssues(dev, fault) {
    var c = document.getElementById('qw-tC');
    if (!c) return;
    c.hidden = false;
    c.innerHTML = '';
    hideResolutionPanel();
    destroyStickyCTA();

    var issues = getAvailableIssues(dev, fault, _repairsMap);
    var titleEl = document.getElementById('qw-s4t');
    if (titleEl) titleEl.textContent = faultDisplayLabel(dev, fault);
    var subEl = document.getElementById('qw-s4s');
    if (subEl) {
      subEl.hidden = false;
      subEl.textContent = 'Which best describes the problem?';
    }

    var faultObj = (FAULTS[dev] || []).find(function(f) { return f.v === fault; });
    var faultIcon = (faultObj && faultObj.icon) || 'other';

    if (issues.length === 0) {
      c.innerHTML = '<div class="qw-empty"><p>No specific issues found. Get in touch and we\'ll help.</p><a href="/pages/contact" class="qw-btn-book">Get in touch</a></div>';
      return;
    }
    issues.forEach(function(iss) {
      var card = document.createElement('div');
      card.className = 'qw-t-card';
      var fi = FAULT_ICONS[iss.icon || faultIcon] || FAULT_ICONS[faultIcon] || FAULT_ICONS.other;
      card.innerHTML = '<div class="qw-tw">' + fi + '</div><span class="qw-tt">' + esc(iss.label) + '</span>';
      wireA11y(card, iss.label);
      card.onclick = function() { pickIssue(iss, card); };
      c.appendChild(card);
    });
  }

  function pickIssue(iss, el) {
    S.issue = iss.label;
    S.route = iss.route || null;
    S.repairType = iss.repairType || null;
    syncIcorrectQuote();
    delete _trackedSteps.resolution;
    document.querySelectorAll('#qw-s4 .qw-t-card').forEach(function(c) { c.classList.remove('sel'); });
    if (el) el.classList.add('sel');
    trackWizardStart({
      start_step: 'issue',
      step_name: 'issue',
      step_number: 4
    });
    trackWizardStepComplete('issue', 4, {
      selected_issue: iss.label,
      outcome_route: iss.route || null
    });
    trackWizardStep('resolution');

    /* Advance to the service/pricing screen (same pattern as device → model). */
    setTimeout(function() {
      if (S.fault === 'Water Damage') {
        showLiquidUsableQuestion(iss);
      } else if (iss.dustgateCheck && _repairsMap['dustgate']) {
        showDustgateQuestion(iss);
      } else if (iss.flexgateCheck && _repairsMap['flexgate'] && modelIsFlexgateModel(S.model)) {
        showFlexgateQuestion(iss);
      } else {
        S.liquidDeviceUsable = null;
        _liquidGate = null;
        _liquidIssue = null;
        showResolution(iss);
      }
    }, 150);
  }

  /* Locked liquid-damage data note (Michael). Do not rewrite. */
  var LIQUID_USABLE_QUESTION = 'Is the device turning on and usable right now?';
  var LIQUID_YES_LABEL = 'Yes (usable)';
  var LIQUID_NO_LABEL = 'No (won\'t turn on / isn\'t usable)';
  var LIQUID_COPY_USABLE = 'If you can, please back up your device. Liquid damage is unpredictable and may still affect your data, though we\'ll still take every care with your device.';
  var LIQUID_COPY_NOT_USABLE = 'Liquid damage can be unpredictable. There\'s a small chance your data could be affected. During the diagnostic we\'ll prioritise protecting your data wherever we can.';

  function liquidUsableLabel() {
    if (S.fault !== 'Water Damage') return '';
    if (S.liquidDeviceUsable === true) return 'Yes';
    if (S.liquidDeviceUsable === false) return 'No';
    return '';
  }

  function liquidAcknowledgedCopy() {
    if (S.liquidDeviceUsable === true) return LIQUID_COPY_USABLE;
    if (S.liquidDeviceUsable === false) return LIQUID_COPY_NOT_USABLE;
    return '';
  }

  function showLiquidUsableQuestion(iss) {
    var p = document.getElementById('qw-rP');
    if (!p) return;
    _liquidGate = 'question';
    _liquidIssue = iss;
    S.liquidDeviceUsable = null;
    openResolutionScreen(LIQUID_USABLE_QUESTION, '');
    p.innerHTML =
      '<div class="qw-res"><div class="qw-res-top" style="padding-bottom:24px;">' +
        '<div class="qw-m-list qw-m-list--flat" role="group" aria-labelledby="qw-s4t">' +
          '<button type="button" class="qw-m-item qw-choice-btn" id="qwLiqYes"><span class="qw-mn">' + esc(LIQUID_YES_LABEL) + '</span></button>' +
          '<button type="button" class="qw-m-item qw-choice-btn" id="qwLiqNo"><span class="qw-mn">' + esc(LIQUID_NO_LABEL) + '</span></button>' +
        '</div>' +
      '</div></div>';
    var yesBtn = document.getElementById('qwLiqYes');
    var noBtn = document.getElementById('qwLiqNo');
    wireA11y(yesBtn, LIQUID_YES_LABEL);
    wireA11y(noBtn, LIQUID_NO_LABEL);
    yesBtn.onclick = function() { showLiquidDataNotice(iss, true); };
    noBtn.onclick = function() { showLiquidDataNotice(iss, false); };
    if (!_suppressScroll) focusQuoteEntry();
  }

  function showLiquidDataNotice(iss, usable) {
    var p = document.getElementById('qw-rP');
    if (!p) return;
    _liquidGate = 'notice';
    _liquidIssue = iss;
    S.liquidDeviceUsable = !!usable;
    var copy = usable ? LIQUID_COPY_USABLE : LIQUID_COPY_NOT_USABLE;
    openResolutionScreen('Water Damage', '');
    /* One panel for both answers. Shared .qw-res-p is a 480px quote column;
       this card must keep the message and button on the same left/right edge. */
    p.innerHTML =
      '<div class="qw-res qw-liq-ack">' +
        '<p class="qw-liq-ack-copy">' + esc(copy) + '</p>' +
        '<button type="button" class="qw-btn-book" id="qwLiqOk">I understand</button>' +
      '</div>';
    document.getElementById('qwLiqOk').onclick = function() {
      _liquidGate = null;
      showResolution(iss);
    };
    if (!_suppressScroll) focusQuoteEntry();
  }

  function showDustgateQuestion(originalIss) {
    var p = document.getElementById('qw-rP');
    if (!p) return;
    openResolutionScreen('Quick check', 'Do the marks on your screen look like this?');
    p.innerHTML =
      '<div class="qw-res"><div class="qw-res-top" style="padding-bottom:24px;">' +
        '<h3 class="qw-res-h">Do the marks on your screen look like this?</h3>' +
        '<p class="qw-res-p">Dustgate is a known design flaw on 2016-2020 MacBook Pro models. Dust accumulates in the hinge and damages the display flex cable, causing purple lines or screen corruption at certain angles.</p>' +
        '<div class="qw-dustgate-imgs">' +
          '<img src="https://cdn.shopify.com/s/files/1/0728/7111/7053/files/dustgate_example_1.jpg?v=1773931594" alt="Dustgate example 1">' +
          '<img src="https://cdn.shopify.com/s/files/1/0728/7111/7053/files/dustgate_example_2.jpg?v=1773931593" alt="Dustgate example 2">' +
        '</div>' +
        '<div class="qw-res-cta" style="padding:0;">' +
          '<button class="qw-btn-book" id="qwDgYes">Yes, that\'s what I see</button>' +
          '<button class="qw-btn-q" id="qwDgNo">No, it looks different</button>' +
        '</div>' +
      '</div></div>';
    document.getElementById('qwDgYes').onclick = function() {
      showResolution({ label: 'Dustgate repair', route: 'repair', repairType: 'dustgate', copy: 'Dustgate is a known design flaw on 2016–2020 MacBook Pro models. Dust works into the hinge and damages the display flex cable. We repair the flex at component level so you don\'t need a full screen replacement.' });
    };
    document.getElementById('qwDgNo').onclick = function() {
      showResolution(originalIss);
    };
  }

  function showFlexgateQuestion(originalIss) {
    var p = document.getElementById('qw-rP');
    if (!p) return;
    openResolutionScreen('Quick check', 'Does your screen look like this?');
    p.innerHTML =
      '<div class="qw-res"><div class="qw-res-top" style="padding-bottom:24px;">' +
        '<h3 class="qw-res-h">Does your screen look like this?</h3>' +
        '<p class="qw-res-p">On this MacBook Pro the backlight flex cable was too short. The backlight fades or fails, usually from the bottom of the screen. If this is what you see, we repair the flex instead of replacing the whole display.</p>' +
        '<div class="qw-dustgate-imgs">' +
          '<img src="https://cdn.shopify.com/s/files/1/0728/7111/7053/files/flexgate_1.webp?v=1773951159" alt="Flexgate example 1">' +
          '<img src="https://cdn.shopify.com/s/files/1/0728/7111/7053/files/flexgate_2.jpg?v=1773951159" alt="Flexgate example 2">' +
        '</div>' +
        '<div class="qw-res-cta" style="padding:0;">' +
          '<button class="qw-btn-book" id="qwFgYes">Yes, that\'s what I see</button>' +
          '<button class="qw-btn-q" id="qwFgNo">No, it looks different</button>' +
        '</div>' +
      '</div></div>';
    document.getElementById('qwFgYes').onclick = function() {
      showResolution({ label: 'Flexgate repair', route: 'repair', repairType: 'flexgate', copy: 'The backlight flex cable on this MacBook Pro was too short. Opening and closing the lid wears through the cable. We repair the snapped flex at component level.' });
    };
    document.getElementById('qwFgNo').onclick = function() {
      showResolution(originalIss);
    };
  }

  /* Shopify hides Delivery when every SKU is digital. Home address is the
     checkout shipping address; billing can stay different. Prefill the
     wizard postcode so ME23 vs card-billing mismatches are obvious. */
  function checkoutUrlWithHomeAddress(postcode) {
    var params = [];
    try {
      if (window.posthog && typeof posthog.get_distinct_id === 'function') {
        params.push('ph_distinct_id=' + encodeURIComponent(posthog.get_distinct_id()));
      }
    } catch (e) {}
    var pc = String(postcode || '').trim();
    if (pc) {
      params.push('checkout[shipping_address][country]=' + encodeURIComponent('United Kingdom'));
      params.push('checkout[shipping_address][zip]=' + encodeURIComponent(pc.toUpperCase()));
    }
    return params.length ? '/checkout?' + params.join('&') : '/checkout';
  }

  /* =============================================
     CART
     ============================================= */

  function buildCartItems() {
    var err = document.getElementById('qwServiceErr');
    if (err) err.textContent = '';
    var items = [];

    var resCard = document.getElementById('qwResCard');
    var mainVid = resCard ? parseInt(resCard.dataset.vid, 10) : null;
    if (!mainVid) return null;

    var needsColor = resCard.dataset.needsColor === '1';
    var selectedColor = '';
    if (needsColor) {
      var colorBtn = document.querySelector('#qwColorGrid .qw-color-btn.sel');
      if (!colorBtn) {
        if (err) err.textContent = 'Please select your device colour.';
        return null;
      }
      selectedColor = colorBtn.dataset.color || '';
    }

    var mappedRepair = (S.repairType && _repairsMap[S.repairType]) ? _repairsMap[S.repairType] : null;
    var repairTypeLabel = (window.ICorrectCourier && typeof window.ICorrectCourier.repairTypeCartLabel === 'function')
      ? window.ICorrectCourier.repairTypeCartLabel({
          device: S.device,
          repairType: S.repairType,
          route: S.route,
          title: mappedRepair && mappedRepair.title,
          handle: mappedRepair && mappedRepair.handle
        })
      : ((String(S.repairType || S.route || '').toLowerCase() === 'diagnostic') ? 'Diagnostic' : 'Repair');
    var mainProps = {
      '_device': DN[S.device] || S.device,
      '_model': S.model || '',
      '_fault': S.fault || '',
      '_issue': S.issue || '',
      'Repair Type': repairTypeLabel
    };
    if (selectedColor) mainProps['Device Color'] = selectedColor;
    var usableLabel = liquidUsableLabel();
    if (usableLabel) mainProps['Device usable'] = usableLabel;

    if (resCard.dataset.needsGlass === '1') {
      var glass = selectedChoice('glass');
      if (!glass) {
        if (err) err.textContent = 'Please say whether the screen is standard or nano-texture.';
        return null;
      }
      mainProps['Display glass'] = glass;
    }
    if (resCard.dataset.needsConnect === '1') {
      var connectivity = selectedChoice('connect');
      if (!connectivity) {
        if (err) err.textContent = 'Please say whether the iPad is Wi-Fi or Wi-Fi + Cellular.';
        return null;
      }
      mainProps['Connectivity'] = connectivity;
    }

    items.push({ id: mainVid, quantity: 1, properties: mainProps });

    var speedCard = document.querySelector('.qw-opt-card.sel[data-opt="speed"]');
    if (speedCard) {
      var speedVid = parseInt(speedCard.dataset.vid || '0', 10);
      if (speedVid && speedVid > 0) {
        items.push({ id: speedVid, quantity: 1 });
      }
    }

    var svcCard = document.querySelector('.qw-opt-card.sel[data-opt="svc"]');
    var svcKind = svcCard ? (svcCard.getAttribute('data-svc') || 'courier') : 'courier';
    var errBox = document.getElementById('qwServiceErr') || err;

    var enteredPostcode = currentPostcodeValue();
    if (enteredPostcode && !isFullPostcodeValue(enteredPostcode)) {
      if (errBox) errBox.textContent = 'Enter your full postcode, for example W1W 8JQ.';
      return null;
    }

    if (svcKind === 'courier') {
      var postcodeInput = document.getElementById('qwPostcode');
      var postcode = postcodeInput ? String(postcodeInput.value || '').trim() : '';
      if (!postcode) {
        if (errBox) errBox.textContent = 'Enter your collection postcode.';
        return null;
      }
      if (!_courierQuote || _courierQuote.service !== 'courier') {
        if (errBox) errBox.textContent = 'Courier isn\'t available for that postcode — choose mail-in instead.';
        return null;
      }
      if (!_collectionSlot.date || !_collectionSlot.part) {
        if (errBox) errBox.textContent = 'Pick a collection date and window.';
        return null;
      }
      var slotProps = window.ICorrectCourierSlots
        ? window.ICorrectCourierSlots.slotCartProperties(_collectionSlot.date, _collectionSlot.part)
        : null;
      items[0].properties['Service Type'] = 'Courier collection';
      items[0].properties['Postcode'] = postcode.toUpperCase();
      items[0].properties['Band'] = _courierQuote.band || '';
      if (slotProps) {
        items[0].properties['Collection Date'] = slotProps['Collection Date'];
        items[0].properties['Collection Window'] = slotProps['Collection Window'];
      } else {
        var win = collectionWindowCopy(_courierQuote.band);
        items[0].properties['Collection Window'] = win.headline;
      }
    } else {
      items[0].properties['Service Type'] = 'Mail-in';
      var postcodeInputMi = document.getElementById('qwPostcode');
      var postcodeMi = postcodeInputMi ? String(postcodeInputMi.value || '').trim() : '';
      if (postcodeMi) items[0].properties['Postcode'] = postcodeMi.toUpperCase();
      if (_courierQuote && _courierQuote.band) items[0].properties['Band'] = _courierQuote.band;
      /* Do not add mail-in-service (Shopify £20). ≥£200 postage is already
         in the all-in quote (adjustment 0). Paid postage is the adjustment variant. */
    }

    /* Service adjustment variant — null-safe: missing ID already forced free mail-in in quote */
    if (_courierQuote && _courierQuote.adjustment > 0 && !(svcKind === 'mailin' && currentRepairPrice() >= 200)) {
      if (_courierQuote.variantMode === 'fallback-free-mail-in') {
        items[0].properties['Service Type'] = 'Mail-in';
        delete items[0].properties['Collection Window'];
      } else if (_courierQuote.variantId) {
        items.push({
          id: parseInt(_courierQuote.variantId, 10),
          quantity: 1,
          properties: {
            'Service Type': items[0].properties['Service Type'] || '',
            'Postcode': items[0].properties['Postcode'] || '',
            'Band': items[0].properties['Band'] || ''
          }
        });
      } else {
        console.warn('[quote-wizard] quoted adjustment £' + _courierQuote.adjustment + ' without variantId — not adding a £0 line');
      }
    }

    var homeVid = CFG.homeAddress && parseInt(CFG.homeAddress.variantId, 10);
    if (homeVid) {
      items.push({
        id: homeVid,
        quantity: 1,
        properties: {
          'Address type': 'Home / collection / mail-in pack'
        }
      });
    }

    /* Snapshot the date already on screen. Do not recompute it at click time. */
    var promiseEl = document.querySelector('#qwJourney:not([hidden]) .qw-journey-eta-date');
    var promiseIso = promiseEl ? (promiseEl.getAttribute('data-iso') || '') : '';
    if (promiseIso) {
      items[0].properties[S.route === 'diagnostic' ? 'Quote by' : 'Return by'] = promiseIso;
    }

    items[0].properties['Order summary'] = orderSummaryText(items[0].properties);
    return items;
  }

  function orderSummaryText(props) {
    var lines = [];
    function add(label, key) {
      if (props[key]) lines.push(label + ': ' + props[key]);
    }
    add('Device', '_model');
    add('Fault', '_fault');
    add('Issue', '_issue');
    add('Device usable', 'Device usable');
    add('Repair', 'Repair Type');
    add('Colour', 'Device Color');
    add('Display glass', 'Display glass');
    add('Connectivity', 'Connectivity');
    add('Service', 'Service Type');
    add('Collection date', 'Collection Date');
    add('Collection window', 'Collection Window');
    add('Return by', 'Return by');
    add('Quote by', 'Quote by');
    add('Postcode', 'Postcode');
    add('Band', 'Band');
    return lines.join('\n');
  }

  function getShopifyRoot() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  }

  async function ensureCleanWizardCart() {
    var root = getShopifyRoot();
    var cartRes = await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
    if (!cartRes.ok) throw new Error('Could not check the current cart.');

    var cart = await cartRes.json();
    var items = cart && cart.items ? cart.items : [];
    if (!items.length) return true;

    var confirmed = window.confirm('Your cart already has items in it. Continuing with this repair booking will replace them. Do you want to continue?');
    if (!confirmed) {
      trackWizardEvent('wizard_cart_replace_cancelled', {
        cartItemCount: items.length
      });
      return false;
    }

    trackWizardEvent('wizard_cart_replace_confirmed', {
      cartItemCount: items.length
    });

    var clearRes = await fetch(root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    if (!clearRes.ok) throw new Error('Could not prepare a clean checkout. Please try again.');
    return true;
  }

  async function addToCartAndCheckout() {
    var items = buildCartItems();
    if (!items) {
      if (window.posthog) {
        var errEl = document.getElementById('qwWalkinErr');
        posthog.capture('book_now_validation_failed', buildWizardTrackPayload({
          reason: errEl && errEl.textContent ? errEl.textContent : 'unknown'
        }));
      }
      return;
    }

    trackWizardProceed();

    var btn = document.getElementById('qwBookBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Redirecting...'; }

    try {
      var shouldContinue = await ensureCleanWizardCart();
      if (!shouldContinue) {
        if (btn) { btn.disabled = false; btn.textContent = 'Proceed to checkout'; }
        return;
      }

      var addItems = items;
      try {
        if (window.icorrectQuoteEvents && typeof window.icorrectQuoteEvents.withPhCartAttribute === 'function') {
          addItems = window.icorrectQuoteEvents.withPhCartAttribute(items);
        }
      } catch (e) { addItems = items; }

      var addRes = await fetch(getShopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: addItems })
      });

      if (!addRes.ok) {
        var errData = null;
        try { errData = await addRes.json(); } catch (e) {}
        throw new Error((errData && (errData.description || errData.message)) || 'Cart error');
      }

      await addRes.json();
      try {
        var phId = window.icorrectQuoteEvents && typeof window.icorrectQuoteEvents.phDistinctId === 'function'
          ? window.icorrectQuoteEvents.phDistinctId()
          : '';
        if (phId) {
          await fetch(getShopifyRoot() + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ attributes: { _ph_distinct_id: phId } })
          }).catch(function () {});
        }
      } catch (e) {}
      trackWizardSubmit('checkout', {
        route: S.route || null,
        value: getWizardTotalValue(),
        currency: 'GBP',
        item_count: items.length
      });
      trackWizardGA4('begin_checkout', {
        route: S.route || null,
        value: getWizardTotalValue(),
        currency: 'GBP',
        item_count: items.length
      });
      var homePostcode = (items[0] && items[0].properties && items[0].properties.Postcode) || '';
      var postEl = document.getElementById('qwPostcode');
      if (!homePostcode && postEl) homePostcode = String(postEl.value || '').trim();
      window.location.href = checkoutUrlWithHomeAddress(homePostcode);
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Proceed to checkout'; }
      alert(err.message || 'Something went wrong. Please try again.');
    }
  }

  /* =============================================
     RESOLUTION CARDS
     ============================================= */
  async function showResolution(iss, screenOpts) {
    var p = document.getElementById('qw-rP');
    if (!p) return;
    S.route = iss.route || null;
    S.repairType = iss.repairType || null;
    _resolutionSeen = true;
    _resolutionConverted = false;
    var title = (screenOpts && screenOpts.title) || 'Your repair quote';
    var sub = (screenOpts && screenOpts.sub);
    if (sub === undefined) {
      sub = iss.route === 'repair' || iss.route === 'diagnostic'
        ? 'Enter your postcode to see your all-in price and book collection.'
        : 'Next steps for your device.';
    }
    openResolutionScreen(title, sub);
    p.innerHTML = '<div class="qw-loading"><div class="qw-spinner"></div></div>';
    if (iss.route === 'repair') await showRepairCard(iss, p);
    else if (iss.route === 'diagnostic') await showDiagnosticCard(iss, p);
    else if (iss.route === 'dismiss') showDismissCard(iss, p);
    else showContactCard(iss, p);
    if (!_suppressScroll) focusQuoteEntry();
    if (window.posthog) posthog.capture('wizard_resolution', buildWizardTrackPayload({
      route: iss.route,
      resolutionLabel: iss.label
    }));
  }

  /* ---- REPAIR CARD ---- */
  async function showRepairCard(iss, container) {
    var product = resolveRepairProduct(iss.repairType, iss.label);
    if (!product) { showContactCard(iss, container); return; }

    /* Price + variant from catalogue map; optional fetch only for express upsell HTML. */
    var basePrice = product.variants && product.variants[0] ? parseFloat(product.variants[0].price) : 0;
    var mainVariantId = product.variants && product.variants[0] ? product.variants[0].id : 0;
    var fullProduct = null;
    if (!basePrice || !mainVariantId) {
      fullProduct = await fetchProduct(product.handle);
      basePrice = fullProduct ? parseFloat(fullProduct.variants[0].price) : 0;
      mainVariantId = fullProduct ? fullProduct.variants[0].id : 0;
    }

    var urgentHtml = iss.urgent ? '<div class="qw-urgent" role="alert"><span>\u26A0\uFE0F Safety concern: stop using the device and don\'t charge it.</span></div>' : '';

    /* Postcode first; price trust sits after collection so mobile can see slots + ETA + price together. */
    var expressData = await detectExpressFromPage(product.handle);
    var turnaroundHtml = buildTurnaroundCards(expressData);
    var deviceColors = getDeviceColors(S.device, S.model, iss.repairType);
    var colorHtml = buildColorSelector(deviceColors);
    var needsGlass = S.device === 'ipad' && (iss.repairType === 'screen' || iss.repairType === 'screen-glass') && modelHasNanoTexture(S.model);
    var needsConnect = S.device === 'ipad' && (iss.repairType === 'screen' || iss.repairType === 'screen-glass');
    var glassHtml = needsGlass ? buildChoiceCards('glass', 'Which screen glass is it?', [
      { value: 'Standard', label: 'Standard' },
      { value: 'Nano-texture', label: 'Nano-texture' }
    ]) : '';
    var connectHtml = needsConnect ? buildChoiceCards('connect', 'Wi-Fi or Wi-Fi + Cellular?', [
      { value: 'Wi-Fi', label: 'Wi-Fi' },
      { value: 'Wi-Fi + Cellular', label: 'Wi-Fi + Cellular' }
    ]) : '';

    var priceTrustHtml = basePrice
      ? buildPriceTrustBlock(S.device, S.model, { gate: true, priceHtml: gbp.format(basePrice) })
      : '';
    var totalHtml = basePrice
      ? ('<div class="qw-price-total-wrap" id="qwPriceTotalWrap" hidden>' +
           '<div class="qw-price-total"><span class="qw-price-total-label">Total</span>' +
           '<span class="qw-price-total-val" id="qwPriceTotal">' + gbp.format(basePrice) + '</span></div>' +
         '</div>')
      : '';
    var serviceHtml = injectServicePrice(buildServiceCards(), priceTrustHtml + totalHtml);

    container.innerHTML = urgentHtml +
      '<div class="qw-res" id="qwResCard" data-base="' + basePrice + '" data-vid="' + mainVariantId + '" data-needs-color="' + (deviceColors ? '1' : '0') + '" data-needs-glass="' + (needsGlass ? '1' : '0') + '" data-needs-connect="' + (needsConnect ? '1' : '0') + '">' +
        '<div class="qw-res-top">' +
          '<div class="qw-res-badge qw-badge-green"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>We can fix this</div>' +
          '<h3 class="qw-res-h">' + esc(product.title) + '</h3>' +
          '<p class="qw-res-p">' + esc(iss.copy) + '</p>' +
          (iss.refImages ? '<div class="qw-dustgate-imgs">' + iss.refImages.map(function(src,i){ return '<img src="' + src + '" alt="Reference image ' + (i+1) + '">'; }).join('') + '</div>' : '') +
        '</div>' +
        '<div class="qw-res-service" style="padding:0 24px 8px;">' + serviceHtml + '</div>' +
        '<div class="qw-res-extras" style="padding:0 24px 8px;">' + colorHtml + glassHtml + connectHtml + turnaroundHtml + '</div>' +
        '<div class="qw-res-cta">' +
          '<div class="qw-collect-notice" id="qwCollectionNotice" role="note" hidden></div>' +
          '<button class="qw-btn-book" id="qwBookBtn" disabled>Proceed to checkout <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>' +
          '<button class="qw-btn-email" id="qwEmailQuote"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/></svg>Email me this quote</button>' +
          '<button class="qw-btn-q" id="qwToggleCF"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>I have a question first</button>' +
        '</div>' +
        buildContactAccordion() +
      '</div>' +
      '<button class="qw-restart" id="qwRestart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>Start over</button>';

    wireOptCards(container);
    wireColorSelector(container);
    (function stampRepairTags(){
      var resEl = document.getElementById('qwResCard');
      if (!resEl || !product) return;
      var tagList = Array.isArray(product.tags) ? product.tags.slice() :
        (typeof product.tags === 'string' ? product.tags.split(',').map(function(t){ return t.trim(); }) : []);
      if (product.courierTier) tagList.push('courier:' + product.courierTier);
      resEl.dataset.tags = JSON.stringify(tagList);
      if (iss && iss.repairType) S.repairType = iss.repairType;
      if (window.ICorrectQuotedRepair) {
        window.ICorrectQuotedRepair.stampQuotedRepair(resEl, {
          title: product.title || '',
          handle: product.handle || '',
          repairType: iss.repairType || '',
          route: 'repair'
        });
      }
    })();
    wireCourierService(container);
    wireCFToggle(container);
    wireRestart(container);

    var bookBtn = container.querySelector('#qwBookBtn');
    if (bookBtn) {
      bookBtn.onclick = function() {
        _resolutionConverted = true;
        fireQuoteProceeded();
        if (window.posthog) {
          var payload = buildWizardTrackPayload({ action: 'book_repair', route: 'repair' });
          posthog.capture('book_now_clicked', payload);
          posthog.capture('proceed_to_checkout_clicked', payload);
          posthog.capture('wizard_conversion', payload);
        }
        addToCartAndCheckout();
      };
    }
        wireEmailQuote(container, product.title, basePrice ? '\u00A3' + basePrice : '', 'repair', product.handle);
    /* Sticky CTA waits for postcode — refreshAllInTotal will unlock book button. */
    setPriceVisibility(false);
  }

  /* ---- DIAGNOSTIC CARD ---- */
  async function showDiagnosticCard(iss, container) {
    var diagProduct = _repairsMap['diagnostic'];
    if (!diagProduct) { showContactCard(iss, container); return; }

    var fullDiag = await fetchProduct(diagProduct.handle);
    var diagPrice = fullDiag ? parseFloat(fullDiag.variants[0].price) : 0;

    var urgentHtml = iss.urgent ? '<div class="qw-urgent" role="alert"><span>\u26A0\uFE0F Safety concern: stop using the device and don\'t charge it.</span></div>' : '';

    var priceHtml = ''; /* price moved into service via trust block */

    /* Build estimate rows: diagnostic + likely repair + logic board (where relevant) */
    var estimateRows = '';
    estimateRows += '<div class="qw-estimate-row"><span>Diagnostic</span><span>' + gbp.format(diagPrice) + '</span></div>';

    if (iss.likelyRepair && _repairsMap[iss.likelyRepair]) {
      try {
        var likelyProd = await fetchProduct(_repairsMap[iss.likelyRepair].handle);
        var likelyPrice = likelyProd ? parseFloat(likelyProd.variants[0].price) : 0;
        if (likelyPrice && iss.likelyCopy) {
          estimateRows += '<div class="qw-estimate-row"><span>' + esc(iss.likelyCopy) + '</span><span>from ' + gbp.format(likelyPrice) + '</span></div>';
        }
      } catch(e) {}
    }

    /* Logic board line: show for issues where the board could be the cause */
    var boardIssues = ['Won\'t turn on', 'Random shutdowns', 'Won\'t charge', 'No display, no response',
      'No image, no backlight or no external picture', 'No sound from speakers', 'Microphone not working',
      'Ghost typing', 'Touch Bar not responding', 'Won\'t charge or charger not recognised'];
    var showBoard = boardIssues.some(function(bi) { return S.issue && S.issue.toLowerCase().indexOf(bi.toLowerCase().substring(0, 12)) !== -1; });
    /* Also show for water damage and generic diagnostics */
    if (S.fault === 'Water Damage' || !iss.likelyRepair) showBoard = true;
    if (showBoard) {
      var boardFloor = (S.device === 'macbook') ? 249 : 199;
      estimateRows += '<div class="qw-estimate-row"><span>Should the logic board need repair</span><span>from ' + gbp.format(boardFloor) + '</span></div>';
    }

    var likelyHtml = estimateRows ? '<div class="qw-estimate">' + estimateRows + '</div>' : '';

    var priceTrustHtml = diagPrice
      ? buildPriceTrustBlock(S.device, S.model, { gate: true, diagnostic: true, priceHtml: gbp.format(diagPrice) })
      : '';
    var totalHtml = diagPrice
      ? ('<div class="qw-price-total-wrap" id="qwPriceTotalWrap" hidden>' +
           '<div class="qw-price-total"><span class="qw-price-total-label">Total</span>' +
           '<span class="qw-price-total-val" id="qwPriceTotal">' + gbp.format(diagPrice) + '</span></div>' +
         '</div>')
      : '';
    var serviceHtml = injectServicePrice(buildServiceCards(), priceTrustHtml + totalHtml);

    var diagVariantId = fullDiag ? fullDiag.variants[0].id : 0;

    var feeOff = '';
    if (S.device === 'macbook') {
      feeOff = ' Collection and return are included. If you go ahead with the repair, we take the £49 off the repair price.';
    } else if (S.device === 'iphone' || S.device === 'ipad') {
      feeOff = ' Collection and return are included. If you go ahead with the repair, we take the £69 off the repair price.';
    }
    var guideCopy = 'The repair prices below are a guide. We\'ll complete the diagnostic within 1 working day of receiving your device and email you a quote. The device stays with us while you decide whether to proceed.' + feeOff;

    container.innerHTML = urgentHtml +
      '<div class="qw-res" id="qwResCard" data-base="' + diagPrice + '" data-vid="' + diagVariantId + '">' +
        '<div class="qw-res-top">' +
          '<div class="qw-res-badge qw-badge-amber"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>We need to take a look</div>' +
          '<h3 class="qw-res-h">Book a Diagnostic</h3>' +
          '<p class="qw-res-p">' + esc(iss.copy) + '</p>' +
          '<p class="qw-res-p">' + esc(guideCopy) + '</p>' +
          likelyHtml +
        '</div>' +
        '<div class="qw-res-service" style="padding:0 24px 8px;">' + serviceHtml + '</div>' +
        '<div class="qw-res-cta">' +
          '<div class="qw-collect-notice" id="qwCollectionNotice" role="note" hidden></div>' +
          '<button class="qw-btn-book" id="qwBookBtn" disabled>Proceed to checkout <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>' +
          '<button class="qw-btn-email" id="qwEmailQuote"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/></svg>Email me this quote</button>' +
          '<button class="qw-btn-q" id="qwToggleCF"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>I have a question first</button>' +
          '<a href="#" class="qw-btn-chat" id="qwIntercomBtn" style="display:none"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>Chat with us now</a>' +
        '</div>' +
        buildContactAccordion() +
      '</div>' +
      '<button class="qw-restart" id="qwRestart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>Start over</button>';

    /* Show Intercom button if available */
    var icBtn = document.getElementById('qwIntercomBtn');
    if (icBtn && window.Intercom) {
      icBtn.style.display = '';
      icBtn.onclick = function(e) { e.preventDefault(); Intercom('show'); };
    }

    wireOptCards(container);
    wireCourierService(container);
    wireCFToggle(container);
    wireRestart(container);

    (function stampDiagnosticRepair(){
      var resEl = document.getElementById('qwResCard');
      if (!resEl) return;
      if (window.ICorrectQuotedRepair) {
        window.ICorrectQuotedRepair.stampQuotedRepair(resEl, {
          title: (fullDiag && fullDiag.title) || diagProduct.title || 'Diagnostic',
          handle: diagProduct.handle || '',
          repairType: 'diagnostic',
          route: 'diagnostic'
        });
      }
    })();

    var bookBtn = container.querySelector('#qwBookBtn');
    if (bookBtn) {
      bookBtn.onclick = function() {
        _resolutionConverted = true;
        fireQuoteProceeded();
        if (window.posthog) {
          var payload = buildWizardTrackPayload({ action: 'book_diagnostic', route: 'diagnostic' });
          posthog.capture('book_now_clicked', payload);
          posthog.capture('proceed_to_checkout_clicked', payload);
          posthog.capture('wizard_conversion', payload);
        }
        addToCartAndCheckout();
      };
    }
        wireEmailQuote(container, 'Diagnostic', diagPrice ? '\u00A3' + diagPrice : '', 'diagnostic', diagProduct.handle);
    setPriceVisibility(false);
  }

  /* ---- DISMISS CARD (dead-end, no form) ---- */
  function showDismissCard(iss, container) {
    container.innerHTML =
      '<div class="qw-res">' +
        '<div class="qw-res-top" style="padding-bottom:24px;">' +
          '<div class="qw-res-badge qw-badge-amber"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4h.01M5.07 19h13.86c1.5 0 2.47-1.6 1.73-2.88L13.73 4.13c-.74-1.28-2.72-1.28-3.46 0L3.34 16.12C2.6 17.4 3.57 19 5.07 19z"/></svg>We can\'t help with this one</div>' +
          '<h3 class="qw-res-h">Contact Apple Support</h3>' +
          '<p class="qw-res-p">' + esc(iss.copy) + '</p>' +
          '<a href="https://support.apple.com" target="_blank" rel="noopener" class="qw-btn-book" style="max-width:280px;">Visit Apple Support <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/></svg></a>' +
        '</div>' +
      '</div>' +
      '<button class="qw-restart" id="qwRestart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>Start over</button>';
    wireRestart(container);
  }

  /* ---- CONTACT CARD ---- */
  function showContactCard(iss, container) {
    var urgentHtml = iss.urgent ? '<div class="qw-urgent" role="alert"><span>\u26A0\uFE0F Safety concern: stop using the device and don\'t charge it.</span></div>' : '';
    container.innerHTML = urgentHtml +
      '<div class="qw-res">' +
        '<div class="qw-res-top">' +
          '<div class="qw-res-badge qw-badge-blue"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>Let\'s chat about this</div>' +
          '<h3 class="qw-res-h">Get in Touch</h3>' +
          '<p class="qw-res-p">' + esc(iss.copy) + '</p>' +
        '</div>' +
        '<div class="qw-c-inner-open">' +
          buildContactSummary() +
          buildContactFormHTML('qwCFD', true) +
        '</div>' +
      '</div>' +
      '<button class="qw-restart" id="qwRestart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>Start over</button>';
    wireContactForm('qwCFD', 'contact');
    trackWizardFormStart('quote_wizard_contact', {
      form_context: 'contact'
    });
    wireRestart(container);
  }

  /* ---- SHARED CONTACT FORM BUILDERS ---- */
  function buildContactSummary() {
    return '<div class="qw-c-sum"><strong>Device:</strong> ' + esc(DN[S.device] || '') + ' &bull; <strong>Model:</strong> ' + esc(S.model || 'N/A') + ' &bull; <strong>Fault:</strong> ' + esc(faultDisplayLabel(S.device, S.fault) || 'N/A') + ' &bull; <strong>Issue:</strong> ' + esc(S.issue || 'N/A') + '</div>';
  }

  function buildContactFormHTML(prefix, visible) {
    var cust = CUST || {};
    return '<form class="qw-cf" id="' + prefix + 'Form" novalidate' + (visible ? '' : ' style="display:none"') + '>' +
      '<div class="qw-f-row two">' +
        '<div class="qw-f-grp"><label class="qw-f-lbl" for="' + prefix + 'N">Name<span class="qw-req">*</span></label><input class="qw-f-inp" type="text" id="' + prefix + 'N" placeholder="Full name" required value="' + esc(cust.name || '') + '"><span class="qw-f-err" id="' + prefix + 'NErr"></span></div>' +
        '<div class="qw-f-grp"><label class="qw-f-lbl" for="' + prefix + 'E">Email<span class="qw-req">*</span></label><input class="qw-f-inp" type="email" id="' + prefix + 'E" placeholder="you@email.com" required value="' + esc(cust.email || '') + '"><span class="qw-f-err" id="' + prefix + 'EErr"></span></div>' +
      '</div>' +
      '<div class="qw-f-row"><div class="qw-f-grp"><label class="qw-f-lbl" for="' + prefix + 'P">Phone<span class="qw-req">*</span></label><input class="qw-f-inp" type="tel" id="' + prefix + 'P" placeholder="+44 7000 000000" required><span class="qw-f-err" id="' + prefix + 'PErr"></span></div></div>' +
      '<div class="qw-f-row"><div class="qw-f-grp"><label class="qw-f-lbl" for="' + prefix + 'M">Your question</label><textarea class="qw-f-ta" id="' + prefix + 'M" placeholder="What do you need help with?"></textarea></div></div>' +
      '<button type="submit" class="qw-f-sub" disabled>Send question</button>' +
    '</form>' +
    '<div class="qw-f-ok" id="' + prefix + 'Ok" hidden><h3>Sent!</h3><p>We\'ll be in touch shortly.</p></div>';
  }

  function buildContactAccordion() {
    return '<div class="qw-c-acc" id="qwCAcc">' +
      '<div class="qw-c-inner">' + buildContactSummary() + buildContactFormHTML('qwCFA', true) + '</div>' +
    '</div>';
  }

  async function postQuoteWizardWebhook(payload) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, 30000);

    try {
      var res = await fetch('https://api.icorrect.co.uk/intake/contact-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      var contentType = res.headers.get('content-type') || '';
      var data = null;
      if (contentType.indexOf('application/json') !== -1) {
        try { data = await res.json(); } catch (e) {}
      } else {
        try { await res.text(); } catch (e2) {}
      }

      if (!res.ok) {
        throw new Error((data && data.error) || 'Unable to submit right now. Please try again.');
      }
      if (data && data.success === false) {
        throw new Error(data.error || 'Unable to submit right now. Please try again.');
      }

      return data || { success: true };
    } catch (error) {
      clearTimeout(timeoutId);
      if (error && error.name === 'AbortError') {
        throw new Error('Request timed out. Please try again.');
      }
      throw error;
    }
  }

  /* [4.2] Inline validation */
  function wireContactForm(prefix, source) {
    var form = document.getElementById(prefix + 'Form');
    if (!form || form._wired) return;
    form._wired = true;
    var nIn = document.getElementById(prefix + 'N');
    var eIn = document.getElementById(prefix + 'E');
    var pIn = document.getElementById(prefix + 'P');
    var nErr = document.getElementById(prefix + 'NErr');
    var eErr = document.getElementById(prefix + 'EErr');
    var pErr = document.getElementById(prefix + 'PErr');
    var sub = form.querySelector('.qw-f-sub');

    function validate() {
      var valid = true;
      if (!nIn.value || nIn.value.trim().length < 2) { nErr.textContent = 'Please enter your name'; valid = false; } else { nErr.textContent = ''; }
      var ev = (eIn.value || '').trim();
      if (!ev || ev.indexOf('@') === -1 || ev.indexOf('.') === -1) { eErr.textContent = 'Please enter a valid email'; valid = false; } else { eErr.textContent = ''; }
      var digits = (pIn.value || '').replace(/\D/g, '');
      if (digits.length < 8) { pErr.textContent = 'Please enter a valid phone number'; valid = false; } else { pErr.textContent = ''; }
      sub.disabled = !valid;
      return valid;
    }
    nIn.addEventListener('input', validate);
    eIn.addEventListener('input', validate);
    pIn.addEventListener('input', validate);
    /* Pre-validate if pre-filled */
    if (nIn.value || eIn.value) validate();

    form.onsubmit = async function(e) {
      e.preventDefault();
      if (!validate()) return;
      sub.disabled = true; sub.textContent = 'Sending...';

      var userName = nIn.value.trim();
      var userEmail = eIn.value.trim();
      var userPhone = pIn.value.trim();
      var userMsg = (document.getElementById(prefix + 'M').value || '').trim();

      /* Build structured body: device context + customer message */
      var deviceParts = [];
      if (S.fault) deviceParts.push('Fault: ' + faultDisplayLabel(S.device, S.fault));
      if (S.issue && S.issue !== S.fault) deviceParts.push('Issue: ' + S.issue);
      var usableLabel = liquidUsableLabel();
      if (usableLabel) deviceParts.push('Device usable: ' + usableLabel);
      var fullBody = deviceParts.length ? deviceParts.join('\n') : '';
      if (userMsg) fullBody += (fullBody ? '\n\n' : '') + 'Message:\n' + userMsg;

      try {
        /* Wrap in contact-form-interceptor shape so the intake service routes
           this as a consumer contact-form submission (sourceType: consumer).
           Without `source` + `contact: {...}`, the intake rejects with
           "Unsupported source." See POST-DEPLOY-INCIDENT-2026-04-17.md. */
        await postQuoteWizardWebhook({
          contact: {
            name: userName,
            email: userEmail,
            phone: userPhone,
            body: fullBody,
            device_type: DN[S.device] || S.device || '',
            device_model: S.model || '',
            fault_area: S.fault || ''
          },
          source: 'shopify-website',
          timestamp: new Date().toISOString(),
          page_url: window.location.href,
          referrer: document.referrer || null
        });
        form.style.display = 'none';
        var ok = document.getElementById(prefix + 'Ok');
        if (ok) { ok.hidden = false; ok.classList.add('show'); }
        _resolutionConverted = true;
        trackWizardSubmit(source + '_submit', {
          route: S.route || null,
          value: getWizardTotalValue(),
          currency: 'GBP'
        });
        trackWizardFormSubmit(source === 'contact' ? 'quote_wizard_contact' : 'quote_wizard_question', {
          form_context: source,
          route: S.route || null,
          value: getWizardTotalValue(),
          currency: 'GBP'
        });
        if (window.posthog) posthog.capture('wizard_conversion', buildWizardTrackPayload({ action: source + '_submit' }));
      } catch (error) {
        sub.disabled = false;
        sub.textContent = 'Send question';
        pErr.textContent = error.message || 'Something went wrong. Please try again.';
      }
    };
  }

  /* ---- WIRING HELPERS ---- */
  function wireOptCards(container) {
    container.querySelectorAll('.qw-opt-card').forEach(function(card) {
      wireA11y(card, card.querySelector('.qw-opt-name') ? card.querySelector('.qw-opt-name').textContent : '');
      card.onclick = function() {
        var resCard = document.getElementById('qwResCard');
        if (!resCard) return;
        var base = parseFloat(resCard.dataset.base || 0);
        var group = card.dataset.opt;
        card.parentNode.querySelectorAll('.qw-opt-card[data-opt="' + group + '"]').forEach(function(c) { c.classList.remove('sel'); });
        card.classList.add('sel');
        var total = base;
        resCard.querySelectorAll('.qw-opt-card.sel').forEach(function(c) { total += parseFloat(c.dataset.add || 0); });
        var totalEl = document.getElementById('qwPriceTotal');
        if (totalEl) totalEl.textContent = gbp.format(total);
        var stickyPrice = document.querySelector('.qw-sticky-price');
        if (stickyPrice) stickyPrice.textContent = gbp.format(total);
        refreshAllInTotal();
      };
    });
  }

  function wireCFToggle(container) {
    var toggle = container.querySelector('#qwToggleCF');
    if (!toggle) return;
    var _questionFormOpened = false;
    toggle.onclick = function() {
      var acc = document.getElementById('qwCAcc');
      if (!acc) return;
      acc.classList.toggle('open');
      if (acc.classList.contains('open')) {
        if (!_questionFormOpened) {
          _questionFormOpened = true;
          if (window.posthog) {
            posthog.capture('question_form_opened', buildWizardTrackPayload({}));
          }
        }
        trackWizardFormStart('quote_wizard_question', {
          form_context: 'question'
        });
        wireContactForm('qwCFA', 'question');
        scrollToEl(acc, 200);
      }
    };
  }

  function wireRestart(container) {
    var btn = container.querySelector('#qwRestart');
    if (btn) btn.onclick = function() { reset(); };
  }

  function qwText(el) {
    if (!el) return '';
    return String(el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* The email is the quote card the client is looking at, plus their name. */
  function readQuoteSnapshot() {
    var headingEl = document.querySelector('#qwResCard .qw-res-h');
    var paragraphs = [];
    document.querySelectorAll('#qwResCard .qw-res-top > .qw-res-p').forEach(function(p) {
      var t = qwText(p);
      if (t) paragraphs.push(t);
    });
    var acknowledged = liquidAcknowledgedCopy();
    if (acknowledged && paragraphs.indexOf(acknowledged) === -1) paragraphs.push(acknowledged);
    var svc = document.querySelector('.qw-opt-card.sel[data-opt="svc"]');
    var serviceName = '';
    var serviceMeta = '';
    var servicePriceLabel = '';
    if (svc) {
      serviceName = qwText(svc.querySelector('.qw-opt-name'));
      serviceMeta = qwText(svc.querySelector('.qw-opt-meta'));
      servicePriceLabel = qwText(svc.querySelector('.qw-opt-price'));
      if (servicePriceLabel === '—' || servicePriceLabel === '-') servicePriceLabel = '';
    }
    var result = document.getElementById('qwCourierResult');
    var noticeTitle = '';
    var noticeDetail = '';
    if (result && !result.hidden) {
      noticeTitle = qwText(result.querySelector('.qw-courier-confirm-title'));
      noticeDetail = qwText(result.querySelector('.qw-courier-confirm-detail'));
    }
    var postEl = document.getElementById('qwPostcode');
    var slotPanel = document.getElementById('qwSlotPanel');
    var collectionDow = '';
    var collectionDay = '';
    var collectionMon = '';
    var collectionWindowLabel = '';
    var collectionWindowDetail = '';
    var collectionLabel = '';
    if (slotPanel && !slotPanel.hidden) {
      collectionLabel = qwText(slotPanel.querySelector('.qw-section-label'));
      var dateBtn = slotPanel.querySelector('.qw-date-btn.active');
      if (dateBtn) {
        collectionDow = qwText(dateBtn.querySelector('.qw-date-dow'));
        collectionDay = qwText(dateBtn.querySelector('.qw-date-day'));
        collectionMon = qwText(dateBtn.querySelector('.qw-date-mon'));
      }
      var winBtn = slotPanel.querySelector('.qw-window-btn.active');
      if (winBtn) {
        collectionWindowLabel = qwText(winBtn.querySelector('.qw-window-label'));
        collectionWindowDetail = qwText(winBtn.querySelector('.qw-window-detail'));
      }
    }
    var journeyHost = document.getElementById('qwJourney');
    var journey = [];
    var etaLabel = '';
    var etaDate = '';
    var etaNote = '';
    if (journeyHost && !journeyHost.hidden) {
      journeyHost.querySelectorAll('.qw-journey-step').forEach(function(step) {
        var title = qwText(step.querySelector('.qw-journey-title'));
        if (title) journey.push({ title: title, meta: qwText(step.querySelector('.qw-journey-meta')) });
      });
      etaLabel = qwText(journeyHost.querySelector('.qw-journey-eta-label'));
      etaDate = qwText(journeyHost.querySelector('.qw-journey-eta-date'));
      etaNote = qwText(journeyHost.querySelector('.qw-journey-eta-note'));
    }
    var trust = [];
    document.querySelectorAll('#qwPriceTrust .qw-trust-cell').forEach(function(cell) {
      if (cell.classList.contains('qw-trust-reviews')) {
        var score = qwText(cell.querySelector('.qw-trust-score'));
        if (score) trust.push({ title: score, sub: qwText(cell.querySelector('.qw-trust-sub')), kind: 'reviews' });
      } else {
        var title = qwText(cell.querySelector('.qw-trust-title'));
        if (title) trust.push({ title: title, sub: qwText(cell.querySelector('.qw-trust-sub')) });
      }
    });
    var bigWrap = document.getElementById('qwPriceBigWrap');
    var bigEl = document.getElementById('qwPriceBig');
    var allIn = (bigWrap && !bigWrap.hidden && bigEl) ? qwText(bigEl) : '';
    var priceLabel = qwText(document.querySelector('#qwPriceTrust .qw-price-from'));
    var choiceLabel = document.getElementById('qwDeliveryChoiceLabel');
    var reveal = document.getElementById('qwDeliveryReveal');
    var serviceLabel = (choiceLabel && reveal && !reveal.hidden) ? qwText(choiceLabel) : '';
    var postLabelEl = document.querySelector('.qw-service-mapper > .qw-section-label');
    var colorBtn = document.querySelector('#qwColorGrid .qw-color-btn.sel');
    var colorLabel = '';
    if (colorBtn) {
      var colorSection = colorBtn.closest('.qw-opt-section');
      if (colorSection) colorLabel = qwText(colorSection.querySelector('.qw-opt-label'));
    }
    var speedCard = document.querySelector('.qw-opt-card.sel[data-opt="speed"]');
    var turnaroundLabel = '';
    var expressName = '';
    var expressMeta = '';
    var expressPriceLabel = '';
    var expressPrice = 0;
    if (speedCard) {
      expressPrice = parseFloat(speedCard.dataset.add || 0) || 0;
      if (expressPrice > 0) {
        var speedSection = speedCard.closest('.qw-opt-section');
        if (speedSection) turnaroundLabel = qwText(speedSection.querySelector('.qw-opt-label'));
        expressName = qwText(speedCard.querySelector('.qw-opt-name'));
        expressMeta = qwText(speedCard.querySelector('.qw-opt-meta'));
        expressPriceLabel = qwText(speedCard.querySelector('.qw-opt-price'));
      }
    }
    var diagnostic = S.route === 'diagnostic';
    return {
      screenTitle: qwText(document.getElementById('qw-s4t')),
      badge: qwText(document.querySelector('#qwResCard .qw-res-badge')),
      heading: qwText(headingEl),
      paragraphs: paragraphs,
      postcode: postEl ? String(postEl.value || '').trim() : '',
      postcodeLabel: qwText(postLabelEl),
      noticeTitle: noticeTitle,
      noticeDetail: noticeDetail,
      serviceLabel: serviceLabel,
      serviceKind: selectedServiceKind() || '',
      serviceName: serviceName,
      serviceMeta: serviceMeta,
      servicePriceLabel: servicePriceLabel,
      benchDays: repairBenchDays(S.device, { diagnostic: diagnostic }),
      collectionLabel: collectionLabel,
      collectionDow: collectionDow,
      collectionDay: collectionDay,
      collectionMon: collectionMon,
      collectionWindowLabel: collectionWindowLabel,
      collectionWindowDetail: collectionWindowDetail,
      journey: journey,
      etaLabel: etaLabel,
      etaDate: etaDate,
      etaNote: etaNote,
      trust: trust,
      priceLabel: priceLabel,
      allIn: allIn,
      colorLabel: colorLabel,
      deviceColor: colorBtn ? (colorBtn.getAttribute('data-color') || '') : '',
      turnaroundLabel: turnaroundLabel,
      expressName: expressName,
      expressMeta: expressMeta,
      expressPriceLabel: expressPriceLabel,
      expressPrice: expressPrice,
      urgent: qwText(document.querySelector('.qw-urgent'))
    };
  }

    function wireEmailQuote(container, productTitle, price, route, productHandle) {
    var btn = container.querySelector('#qwEmailQuote');
    if (!btn) return;

    var _emailQuoteClicked = false;
    btn.onclick = function() {
      if (!_emailQuoteClicked) {
        _emailQuoteClicked = true;
        if (window.posthog) {
          posthog.capture('email_quote_clicked', buildWizardTrackPayload({
            product_title: productTitle,
            price: price,
            route: route
          }));
        }
      }
      var panel = document.getElementById('qwEmailPanel');
      if (panel) {
        panel.classList.toggle('show');
        if (panel.classList.contains('show')) {
          trackWizardFormStart('quote_wizard_email_quote', {
            form_context: 'email_quote'
          });
          var inp = panel.querySelector('.qw-eq-input');
          if (inp) inp.focus();
        }
        return;
      }

      var cust = window.WIZARD_CUSTOMER || {};
      var html = '<div class="qw-eq-panel show" id="qwEmailPanel">' +
        '<div class="qw-eq-fields">' +
          '<div class="qw-eq-field">' +
            '<label class="qw-eq-label" for="qwEqName">Name</label>' +
            '<input type="text" class="qw-eq-input" placeholder="John Smith" id="qwEqName" required value="' + esc(cust.name || '') + '">' +
          '</div>' +
          '<div class="qw-eq-field">' +
            '<label class="qw-eq-label" for="qwEqEmail">Email</label>' +
            '<input type="email" class="qw-eq-input" placeholder="you@example.com" id="qwEqEmail" required value="' + esc(cust.email || '') + '">' +
          '</div>' +
        '</div>' +
        '<button class="qw-eq-send" id="qwEqSend"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"/></svg>Send quote</button>' +
        '<div class="qw-eq-ok" id="qwEqOk" hidden><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>Sent! Check your inbox.</div>' +
        '<div class="qw-eq-err" id="qwEqErr" hidden></div>' +
      '</div>';

      btn.insertAdjacentHTML('afterend', html);
      trackWizardFormStart('quote_wizard_email_quote', {
        form_context: 'email_quote'
      });
      document.getElementById('qwEqName').focus();

      document.getElementById('qwEqSend').onclick = function() {
        var name = document.getElementById('qwEqName').value.trim();
        if (!name || name.length < 2) {
          document.getElementById('qwEqErr').textContent = 'Please enter your name.';
          var errEl = document.getElementById('qwEqErr'); if (errEl) { errEl.hidden = false; errEl.style.display = 'block'; }
          return;
        }
        var email = document.getElementById('qwEqEmail').value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          document.getElementById('qwEqErr').textContent = 'Please enter a valid email address.';
          var errEl = document.getElementById('qwEqErr'); if (errEl) { errEl.hidden = false; errEl.style.display = 'block'; }
          return;
        }

var errHide = document.getElementById('qwEqErr'); if (errHide) { errHide.hidden = true; errHide.style.display = 'none'; }
        var sendBtn = document.getElementById('qwEqSend');
        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending…';
 
        /* Read base price from resolution card */
        var resCard = document.getElementById('qwResCard');
        var basePrice = resCard ? parseFloat(resCard.dataset.base || 0) : 0;
        var snap = readQuoteSnapshot();

        /* Read service price add-on. The label on the card (Free pack, Included) is what the email shows. */
        var svcCard = document.querySelector('.qw-opt-card.sel[data-opt="svc"]');
        var serviceName = snap.serviceName || '';
        var servicePrice = 0;
        if (svcCard) servicePrice = parseFloat(svcCard.dataset.add || 0) || 0;
        if (!snap.servicePriceLabel && !servicePrice) servicePrice = null;

        /* Read diagnostic estimate rows */
        var estimates = [];
        document.querySelectorAll('.qw-estimate-row').forEach(function(row) {
          var spans = row.querySelectorAll('span');
          if (spans.length >= 2) {
            estimates.push({
              label: spans[0].textContent.trim(),
              value: spans[1].textContent.trim()
            });
          }
        });

        /* Visible all-in price. qwPriceBig is the figure on the card. */
        var totalEl = document.getElementById('qwPriceTotal');
        var totalPrice = snap.allIn || (totalEl ? totalEl.textContent.trim() : gbp.format(basePrice));

        function qwJson(list) {
          return list && list.length ? JSON.stringify(list) : null;
        }

        var payload = {
            source: 'quote-wizard-email-quote',
            name: name,
            email: email,
            deviceType: DN[S.device] || S.device,
            deviceModel: S.model || '',
            faultArea: S.fault || '',
            issue: S.issue || '',
            repairTitle: snap.heading || productTitle || '',
            route: route || 'repair',
            basePrice: basePrice,
            expressName: snap.expressName || null,
            expressMeta: snap.expressMeta || null,
            expressPrice: snap.expressPrice || 0,
            expressPriceLabel: snap.expressPriceLabel || null,
            serviceName: serviceName,
            serviceKind: snap.serviceKind || null,
            serviceMeta: snap.serviceMeta || null,
            servicePrice: servicePrice,
            servicePriceLabel: snap.servicePriceLabel || null,
            serviceLabel: snap.serviceLabel || null,
            benchDays: snap.benchDays || null,
            totalPrice: totalPrice,
            estimates: estimates.length > 0 ? JSON.stringify(estimates) : null,
            warranty: CFG.warrantyLabel || '2-year warranty',
            parts: partsClaimLabel(S.device, S.model),
            productUrl: productHandle ? 'https://www.icorrect.co.uk/products/' + productHandle : null,
            deviceColor: snap.deviceColor || null,
            colorLabel: snap.colorLabel || null,
            screenTitle: snap.screenTitle || null,
            badge: snap.badge || null,
            paragraphs: qwJson(snap.paragraphs),
            postcode: snap.postcode || null,
            postcodeLabel: snap.postcodeLabel || null,
            noticeTitle: snap.noticeTitle || null,
            noticeDetail: snap.noticeDetail || null,
            collectionLabel: snap.collectionLabel || null,
            collectionDow: snap.collectionDow || null,
            collectionDay: snap.collectionDay || null,
            collectionMon: snap.collectionMon || null,
            collectionWindowLabel: snap.collectionWindowLabel || null,
            collectionWindowDetail: snap.collectionWindowDetail || null,
            journey: qwJson(snap.journey),
            etaLabel: snap.etaLabel || null,
            etaDate: snap.etaDate || null,
            etaNote: snap.etaNote || null,
            trust: qwJson(snap.trust),
            priceLabel: snap.priceLabel || null,
            turnaroundLabel: snap.turnaroundLabel || null,
            urgent: snap.urgent || null,
            url: window.location.href,
            timestamp: new Date().toISOString()
        };
 
        function showEmailSuccess() {
          var panel = document.getElementById('qwEmailPanel');
          panel.querySelector('.qw-eq-fields').style.display = 'none';
          sendBtn.style.display = 'none';
          var okEl = document.getElementById('qwEqOk'); if (okEl) { okEl.hidden = false; okEl.style.display = 'flex'; }
          _resolutionConverted = true;
          trackWizardSubmit('email_quote', {
            route: route || null,
            value: getWizardTotalValue(),
            currency: 'GBP'
          });
          trackWizardFormSubmit('quote_wizard_email_quote', {
            form_context: 'email_quote',
            route: route || null,
            value: getWizardTotalValue(),
            currency: 'GBP'
          });
          if (window.posthog) posthog.capture('wizard_conversion', buildWizardTrackPayload({ action: 'email_quote' }));
        }
 
        postQuoteWizardWebhook(payload).then(function(data) {
          if (!data || data.quoteEmailed !== true) {
            sendBtn.disabled = false; sendBtn.textContent = 'Send quote';
            document.getElementById('qwEqErr').textContent = 'We could not email that quote. Please try again.';
            var errEl = document.getElementById('qwEqErr'); if (errEl) { errEl.hidden = false; errEl.style.display = 'block'; }
            return;
          }
          showEmailSuccess();
          try {
            if (typeof fireQuoteEmailRequested === 'function') {
              fireQuoteEmailRequested({
                contact_name: name,
                contact_email: email
              });
            }
          } catch (e) {}
        }).catch(function() {
          sendBtn.disabled = false; sendBtn.textContent = 'Send quote';
          document.getElementById('qwEqErr').textContent = 'Something went wrong. Please try again.';
          var errEl = document.getElementById('qwEqErr'); if (errEl) { errEl.hidden = false; errEl.style.display = 'block'; }
        });
      };
    };
  }

  /* =============================================
     [5.1] STICKY CTA ON MOBILE
     ============================================= */
  var _stickyObserver = null;
  function setupStickyCTA(price) {
    var sticky = document.getElementById('qw-sticky-cta');
    if (!sticky) return;
    sticky.innerHTML = '<span class="qw-sticky-price">' + price + '</span><button class="qw-sticky-book" onclick="document.getElementById(\'qwBookBtn\').click()">Book now</button>';

    var cta = document.querySelector('.qw-res-cta');
    if (!cta || !('IntersectionObserver' in window)) return;
    if (_stickyObserver) _stickyObserver.disconnect();
    _stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sticky.classList.toggle('show', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    _stickyObserver.observe(cta);
  }

  function destroyStickyCTA() {
    if (_stickyObserver) { _stickyObserver.disconnect(); _stickyObserver = null; }
    var sticky = document.getElementById('qw-sticky-cta');
    if (sticky) { sticky.classList.remove('show'); sticky.innerHTML = ''; }
  }

  /* =============================================
     RESET
     ============================================= */
  function reset() {
    S.device = null; S.model = null; S.modelGroup = null; S.fault = null; S.issue = null; S.step = 1; S.collectionHandle = null; S.route = null; S.repairType = null; _repairsMap = {};
    _courierQuote = null;
    _postcodeResolved = false;
    _quoteShownCaptured = false;
    _collectionSlot = { date: null, part: null };
    window.__icorrectQuote = {};
    _collectionProducts = [];
    _trackedSteps = {};
    clearResolutionState();
    document.querySelectorAll('.qw-dev').forEach(function(c) { c.classList.remove('sel'); });
    hideResolutionPanel();
    var tC = document.getElementById('qw-tC');
    if (tC) { tC.hidden = false; tC.innerHTML = ''; }
    destroyStickyCTA();
    go(1);
  }

  /* =============================================
     BACK BUTTONS
     ============================================= */
  var b2 = document.getElementById('qw-back2');
  if (b2) b2.onclick = function() {
    if (S.modelGroup && (MODELS[S.device] || []).length > 1) {
      renderModelGroups(S.device);
      return;
    }
    S.modelGroup = null;
    go(1);
  };
  var b3 = document.getElementById('qw-back3'); if (b3) b3.onclick = function() { go(2); };
  var b4 = document.getElementById('qw-back4');
  if (b4) b4.onclick = function() {
    if (_liquidGate === 'notice' && _liquidIssue) {
      showLiquidUsableQuestion(_liquidIssue);
      return;
    }
    /* From pricing/service screen → back to issue list (same step shell). */
    if (resolutionScreenOpen() && S.fault && S.fault !== 'Other') {
      clearResolutionState();
      S.issue = null; S.route = null; S.repairType = null;
      syncIcorrectQuote();
      delete _trackedSteps.resolution;
      destroyStickyCTA();
      renderIssues(S.device, S.fault);
      /* If pricing scrolled the chrome away above the viewport, ease back.
         Do not pull the page down when the wizard is simply below the fold. */
      requestAnimationFrame(function() {
        var anchor = document.querySelector('.qw-prog') || document.querySelector('.qw-wizard');
        if (!anchor) return;
        var rect = anchor.getBoundingClientRect();
        if (rect.bottom < 72) scrollToEl(anchor, 80, 'start');
      });
      return;
    }
    go(3);
  };

  /* =============================================
     PRE-FILL SYSTEM
     ============================================= */
  function normalizeModelKey(str) {
    return String(str || '').toLowerCase()
      .replace(/[""\'\'′]/g, '')
      .replace(/&/g, 'and')
      .replace(/inch(?:es)?/g, '')
      .replace(/[^a-z0-9]+/g, '');
  }

  function eachWizardModel(cb) {
    var devices = ['macbook', 'iphone', 'ipad', 'watch'];
    for (var d = 0; d < devices.length; d++) {
      var groups = MODELS[devices[d]] || [];
      for (var g = 0; g < groups.length; g++) {
        var models = groups[g].models || [];
        for (var m = 0; m < models.length; m++) {
          if (cb(devices[d], groups[g], models[m]) === false) return;
        }
      }
    }
  }

  function findModelByCollection(handle) {
    if (!handle) return null;
    var want = String(handle).toLowerCase();
    var exact = null;
    var fuzzy = [];
    eachWizardModel(function(device, group, model) {
      var ch = String(model.collectionHandle || '').toLowerCase();
      if (!ch) return;
      if (ch === want) { exact = { device: device, model: model, group: group }; return false; }
      /* Hub handles like macbook-pro-16 match many models — only fuzzy-pick when unique. */
      if (ch.indexOf(want) !== -1 || want.indexOf(ch) !== -1) {
        fuzzy.push({ device: device, model: model, group: group });
      }
    });
    if (exact) return exact;
    return fuzzy.length === 1 ? fuzzy[0] : null;
  }

  function findModelByName(name) {
    if (!name) return null;
    var want = normalizeModelKey(name);
    if (!want) return null;
    var exact = null;
    var contained = null; /* page/title contains the model name — prefer longest */
    var weak = null;      /* model name contains the query — last resort */
    eachWizardModel(function(device, group, model) {
      var key = normalizeModelKey(model.name);
      if (!key) return;
      if (key === want) { exact = { device: device, model: model, group: group }; return false; }
      if (want.indexOf(key) !== -1) {
        if (!contained || key.length > normalizeModelKey(contained.model.name).length) {
          contained = { device: device, model: model, group: group };
        }
        return;
      }
      if (!weak && key.indexOf(want) !== -1) {
        weak = { device: device, model: model, group: group };
      }
    });
    return exact || contained || weak;
  }

  function contextHaystack(ctx) {
    ctx = ctx || {};
    var parts = [
      ctx.productHandle,
      ctx.productTitle,
      ctx.collectionHandle,
      ctx.collectionTitle
    ];
    var tags = ctx.productTags || [];
    for (var i = 0; i < tags.length; i++) parts.push(tags[i]);
    var cols = [].concat(ctx.modelCollections || [], ctx.allCollections || []);
    for (var c = 0; c < cols.length; c++) parts.push(cols[c]);
    return parts.filter(Boolean).join(' ').toLowerCase();
  }

  /* Infer MacBook/iPhone series group from page copy (e.g. 16-inch, iPhone 12). */
  function findModelGroupFromContext(device, ctx) {
    var groups = MODELS[device] || [];
    if (!groups.length) return null;
    if (groups.length === 1) return groups[0];
    var hay = contextHaystack(ctx);
    if (!hay) return null;
    var best = null;
    var bestScore = 0;
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var label = String(g.group || '');
      var score = 0;
      var normLabel = normalizeModelKey(label);
      if (normLabel && normalizeModelKey(hay).indexOf(normLabel) !== -1) score += 8;
      var inch = label.match(/(\d{2})\s*["”]|(\d{2})\s*-?\s*inch/i);
      if (inch) {
        var n = inch[1] || inch[2];
        if (new RegExp('(?:^|[^0-9])' + n + '(?:\\s|-)?(?:inch|in\\b|["”])').test(hay) || hay.indexOf(n + '-inch') !== -1 || hay.indexOf('pro-' + n) !== -1 || hay.indexOf(n + 'inch') !== -1) {
          score += 10;
        }
      }
      /* iPhone group titles like "iPhone 12" */
      var iphoneGen = label.match(/iphone\s*(\d{1,2})/i);
      if (iphoneGen && new RegExp('iphone[\\s-]*' + iphoneGen[1] + '(?![0-9])').test(hay)) score += 10;
      if (score > bestScore) { bestScore = score; best = g; }
    }
    return bestScore > 0 ? best : null;
  }

  function resolveModelFromContext(ctx, opts) {
    opts = opts || {};
    var cols = [].concat(ctx.modelCollections || []);
    if (ctx.collectionHandle) cols.push(ctx.collectionHandle);
    if (opts.includeAllCollections) cols = cols.concat(ctx.allCollections || []);
    var seen = {};
    var match = null;
    for (var i = 0; i < cols.length; i++) {
      var h = cols[i];
      if (!h || seen[h]) continue;
      seen[h] = true;
      match = findModelByCollection(h);
      if (match) return match;
    }
    if (opts.modelName) {
      match = findModelByName(opts.modelName);
      if (match) return match;
    }
    if (opts.modelSlug) {
      match = findModelByName(String(opts.modelSlug).replace(/-/g, ' '));
      if (match) return match;
    }
    /* Last resort: match page title / handle against wizard model names. */
    match = findModelByName(ctx.productTitle) || findModelByName(ctx.collectionTitle);
    if (match) return match;
    return null;
  }

  function openDeviceModels(device, ctx) {
    S.device = device;
    syncIcorrectQuote();
    renderDevices();
    var group = findModelGroupFromContext(device, ctx || CONTEXT);
    if (group) {
      pickModelGroup(device, group);
    } else {
      renderModels(device);
    }
    go(2);
  }

  function initPrefill() {
    var ctx = CONTEXT;
    _suppressScroll = true; /* Don't scroll during init - page should load from top */

    /* Section setting overrides */
    if (ctx && ctx.prefillDevice) ctx.device = ctx.device || ctx.prefillDevice;
    if (ctx && ctx.prefillFault) ctx.fault = ctx.fault || ctx.prefillFault;

    /* Collection handle → device/fault via data rules (#53 slice 3) */
    if (ctx && ctx.collectionHandle && window.ICorrectWizardPrefill && window.__QW_COLLECTION_PREFILL) {
      var cp = window.ICorrectWizardPrefill.resolveCollectionPrefill(ctx.collectionHandle, window.__QW_COLLECTION_PREFILL);
      if (cp.device && !ctx.device) ctx.device = cp.device;
      if (cp.fault && !ctx.fault) ctx.fault = cp.fault;
    }
    /* Product / title handles also carry device + fault hints (e.g. macbook-pro-16-screen). */
    if (ctx && window.ICorrectWizardPrefill && window.__QW_COLLECTION_PREFILL) {
      var hintHandles = [ctx.productHandle, ctx.productTitle, ctx.collectionTitle].concat(ctx.allCollections || []);
      for (var hi = 0; hi < hintHandles.length; hi++) {
        if (!hintHandles[hi]) continue;
        var hp = window.ICorrectWizardPrefill.resolveCollectionPrefill(hintHandles[hi], window.__QW_COLLECTION_PREFILL);
        if (hp.device && !ctx.device) ctx.device = hp.device;
        if (hp.fault && !ctx.fault) ctx.fault = hp.fault;
      }
    }

    /* CASE 0: Product page — catalogue map reverse lookup lands on service step */
    if (ctx && ctx.productHandle && window.ICorrectWizardPrefill && window.__QW_CATALOGUE) {
      var hit = window.ICorrectWizardPrefill.resolveProductPrefill(window.__QW_CATALOGUE, {
        handle: ctx.productHandle,
        variantId: ctx.productVariantId
      });
      if (hit) {
        S.device = hit.device;
        S.preRepairType = hit.fault;
        S.preFault = faultForRepairType(hit.device, hit.fault);
        S.preVariantId = hit.variantId || null;
        trackWizardEntry('product_catalogue', { productHandle: ctx.productHandle, fault: hit.fault, modelName: hit.modelName || null });
        renderDevices();
        var modelMatch = resolveModelFromContext(ctx, {
          includeAllCollections: true,
          modelName: hit.modelName,
          modelSlug: hit.modelSlug
        });
        if (modelMatch) {
          pickModel(modelMatch.model.name, modelMatch.model.collectionHandle, null).then(function() {
            _suppressScroll = false;
          });
        } else {
          openDeviceModels(hit.device, ctx);
          _suppressScroll = false;
        }
        return;
      }
    }

    /* CASE 1: Product page — pre-fill device + model, derive fault from handle */
    if (ctx && ctx.productHandle) {
      var modelMatch = resolveModelFromContext(ctx, { includeAllCollections: true });
      if (modelMatch) {
        var rt = deriveRepairTypeFromHandle(ctx.productHandle);
        var faultName = rt ? faultForRepairType(modelMatch.device, rt) : null;
        S.device = modelMatch.device;
        trackWizardEntry('product', {
          collectionHandle: modelMatch.model.collectionHandle,
          productHandle: ctx.productHandle
        });
        if (faultName) S.preFault = faultName;
        renderDevices();
        pickModel(modelMatch.model.name, modelMatch.model.collectionHandle, null).then(function() {
          _suppressScroll = false;
        });
        return;
      }
      /* Product page but can't find exact model — device + best series (e.g. MacBook 16"). */
      if (ctx.device) {
        trackWizardEntry('product', {
          productHandle: ctx.productHandle,
          deviceContextOnly: true
        });
        openDeviceModels(ctx.device, ctx);
        _suppressScroll = false;
        return;
      }
    }

    /* CASE 2: Collection page — pre-fill device + model / series */
    if (ctx && ctx.collectionHandle) {
      var match = resolveModelFromContext(ctx, { includeAllCollections: true });
      if (match) {
        S.device = match.device;
        trackWizardEntry('collection', {
          collectionHandle: ctx.collectionHandle
        });
        renderDevices();
        pickModel(match.model.name, match.model.collectionHandle, null).then(function() {
          _suppressScroll = false;
        });
        return;
      }
      if (ctx.device) {
        trackWizardEntry('collection', {
          collectionHandle: ctx.collectionHandle,
          deviceContextOnly: true
        });
        if (ctx.fault) { S.preFault = faultForRepairType(ctx.device, ctx.fault); S.preRepairType = S.preFault ? ctx.fault : null; }
        openDeviceModels(ctx.device, ctx);
        _suppressScroll = false;
        return;
      }
    }

    /* CASE 3: Device context from metafield */
    if (ctx && ctx.device) {
      trackWizardEntry('device_context', {
        faultPrefill: ctx.fault || null
      });
      if (ctx.fault) { S.preFault = faultForRepairType(ctx.device, ctx.fault); S.preRepairType = S.preFault ? ctx.fault : null; }
      openDeviceModels(ctx.device, ctx);
      _suppressScroll = false;
      return;
    }

    /* CASE 4: No context — start fresh.
       Keep scroll suppressed across go(1)'s rAF pin so homepage load
       doesn't jump down into the quote module below the hero. */
    trackWizardEntry('fresh');
    renderDevices();
    go(1);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        _suppressScroll = false;
      });
    });
  }

  /* =============================================
     BROWSER BACK + [4.9] POSTHOG DROP-OFF
     ============================================= */
  window.addEventListener('popstate', function(e) {
    if (e.state && typeof e.state.step === 'number') {
      S.step = e.state.step;
      S.device = e.state.device || null;
      S.model = e.state.model || null;
      S.fault = e.state.fault || null;
      S.issue = null;
      S.route = null;
      S.repairType = null;
      syncIcorrectQuote();
      clearTrackedStepsAfter(e.state.step);
      document.querySelectorAll('.qw-step').forEach(function(el) { el.classList.remove('on'); });
      var stepEl = document.getElementById('qw-s' + e.state.step);
      if (stepEl) stepEl.classList.add('on');
      updateProg(e.state.step);
      updateCrumb();
    }
  });

  window.addEventListener('beforeunload', function() {
    if (!window.posthog) return;
    if (_resolutionSeen && !_resolutionConverted) {
      posthog.capture('wizard_resolution_abandoned', buildWizardTrackPayload({
        step: S.step,
        duration: Date.now() - _stepStartTime
      }));
      return;
    }
    if (S.step > 1 && !S.issue) {
      posthog.capture('wizard_abandoned', buildWizardTrackPayload({
        step: S.step,
        duration: Date.now() - _stepStartTime
      }));
    }
  });

  /* =============================================
     INIT
     ============================================= */
  wireProgDots();
  function bootPrefill() {
    var ctx = CONTEXT || {};
    var needsCatalogue = !!(ctx.productHandle || ctx.collectionHandle || ctx.device);
    if (needsCatalogue) {
      ensureCourierAssets().then(function() {
        initPrefill();
      }).catch(function() {
        initPrefill();
      });
      return;
    }
    /* Homepage / no context: paint step 1 immediately; fetch bands+map in the background. */
    initPrefill();
    ensureCourierAssets().catch(function(){});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPrefill);
  } else {
    bootPrefill();
  }

})();
